// storefrontI18n.js
// All storefrontData.js text extracted for i18n

const STOREFRONT_TEXTS = {
  en: {
    // --- TEXTS keys ---
    title: "LOYA SPORT",
    subtitle: "Yoga product supply chain integrator for global wholesale buyers",
    loading: "Loading products...",
    error: "Failed to load products. Please check the service status.",
    language: "Language",
    currency: "Currency",
    requestQuote: "Request Quote",
    sendMessage: "Submit Inquiry",
    heroTag: "International B2B Sourcing",
    heroTitle: "Premium Yoga and Light Fitness Products for B2B Buyers",
    heroBody: "We support wholesale buyers with end-to-end coordination from precise product curation and strict quality control to complete after-sales service.",
    heroBulletA: "Curated Product Range",
    heroBulletB: "Private Label Support",
    heroBulletC: "Verified Supply Partners",
    heroBulletD: "Global Supply Coverage",
    heroBulletE: "Fast Quotation Response",
    heroCardTitle: "How We Support Your Sourcing",
    heroCardBody: "Share your target products, branding requirements and quantity plan. We compare options, arrange samples and coordinate delivery timelines.",
    categoryTitle: "Explore Our Categories",
    categoryBody: "Explore high-demand yoga and fitness collections for wholesale channels.",
    featuredTitle: "Featured Product Selection",
    featuredBody: "Review key items and request quotes by quantity and branding plan.",
    factoryTitle: "Supply Chain Advantages",
    factoryBody: "Clear supplier matching, MOQ and export readiness.",
    storyTitle: "Supply chain coordination you can rely on",
    storyBody: "Confirm specs fast and keep delivery on track.",
    storyBodyExtra: "From supplier matching to sampling and shipment milestones, our team keeps updates visible so your sourcing plan stays controllable.",
    serviceTitle: "Quality and compliance process",
    proofEyebrow: "About Us",
    proofTitle: "A B2B Sourcing Partner for Yoga & Light Fitness",
    proofBody: "We support yoga and light fitness sourcing for global wholesale, retail and e-commerce channels.",
    proofBodyExtra: "",
    proofCta: "Contact Our B2B Team",
    inquiryCtaEyebrow: "Request a Quote",
    inquiryCtaTitle: "Ready to Source Your Next Yoga Product Line?",
    inquiryCtaBody: "Share your target products and quantity plan. We will reply with a tailored quotation.",
    inquiryQuickA: "Response target: within 8 business hours",
    inquiryQuickB: "Markets served: global wholesale channels",
    inquiryTitle: "Request a Quote",
    inquiryHint: "Tell us product, quantity, branding request and destination market.",
    inquirySuccess: "Thanks. Your inquiry has been received and our B2B team will reply soon.",
    inquiryError: "Please complete name, email, and inquiry details.",
    inquirySubmitting: "Submitting...",
    inquirySubmitFailed: "Submission failed. Please try again in a moment.",
    chooseLanguageTitle: "Who We Serve",
    chooseLanguageBody: "Built for core B2B channels.",
    trustA: "Verified Supply Chain Partners",
    trustB: "Flexible OEM & Packaging Support",
    trustC: "Reliable Lead Time Management",
    trustD: "Strict Pre-Shipment Inspection",
    viewMore: "Learn More",
    viewAll: "View Products",
    talkToUs: "Speak with Our Team",
    contactUs: "Contact Us",
    certifications: "Quality & Compliance",
    headerVerified: "Verified Suppliers",
    headerPrivateLabel: "Private Label",
    headerGlobalShipping: "Global Shipping",
    ariaBackToHomepage: "Back to homepage",
    ariaToggleNavigationMenu: "Toggle navigation menu",
    ariaPrimaryNavigation: "Primary navigation",
    ariaSearchProductByName: "Search product by name",
    ariaSearch: "search",
    sortLabel: "Sort",
    sortDefault: "Default",
    ariaSortProducts: "Sort products",
    contactModelPrefix: "Model",
    ariaSwitchStorefrontLanguage: "Switch storefront language",
    ariaAccountCenter: "Account Center",
    ariaLogin: "Login",
    globalContactTagline: "Yoga and fitness supply chain integration support for global wholesale buyers",
    accountCenter: "Account Center",
    productsCategoryTitle: "Product Categories",
    productsAll: "All Products",
    productsOthers: "Others",
    productsCategoryNavigationAria: "Product category navigation",
    productsContactNow: "Contact Now",
    productsEmpty: "No products found in this category.",
    productsPaginationAria: "Products pagination",
    productsPrev: "Prev",
    productsNext: "Next",
    productsPage: "Page",
    bookmarkHint: "Press Ctrl+D (or Cmd+D on Mac) to bookmark this site.",
    ariaBreadcrumbNavigation: "Breadcrumb navigation",
    ariaPrivacyPreference: "Privacy preference",
    privacyTitle: "Your Privacy Choices",
    privacyBody: "We use essential technologies to run the storefront, and optional privacy-safe features to improve search and recommendations.",
    privacyOptionEnhanced: "I Understand: enables optional enhancements like remembered search history and personalized recommendations.",
    privacyOptionBasic: "Do Not Sell or Share My Personal Information: keeps only essential storefront features enabled.",
    privacyAccept: "I Understand",
    privacyReject: "Do Not Sell or Share My Personal Information",
    ariaOpenPrivacyChoices: "Open privacy policy",
    privacyChoices: "Privacy Policy",
    contactInquiryPresetLoaded: "Inquiry preset loaded for",
    contactSelectedProduct: "selected product",
    contactQuoteHint: "To speed up quoting, include target SKU, estimated annual volume, destination market, and preferred packaging style.",
    inquiryProductDefault: "General Inquiry",
    navSubmenuSuffix: "submenu",
    homeSupplyImageAlt: "Supply chain coordination support",
    homeCertImageAlt: "Certification and compliance overview",
    blogSeoTitle: "Blog | Insights & Buying Guides",
    blogSeoDescription: "Practical buying guides and sourcing insights for global wholesale and private-label buyers.",
    blogHeroDescription: "Practical sourcing playbooks for importers and private-label buyers, from material choices and sample checks to launch-ready order planning.",
    blogSearchPlaceholder: "Search sourcing insights",
    blogFeaturedTitle: "Featured Article",
    blogLatestTitle: "Latest Articles",
    blogBrowseTopicTitle: "Browse by Topic",
    blogReadMore: "Read More",
    blogShowLess: "Show Less",
    blogDateFallback: "Updated recently",
    blogEmptyFeatured: "No matching featured article. Try a different keyword or category.",
    blogEmptyLatest: "No articles match the current filter.",
    blogCtaTitle: "Need sourcing support for your next collection?",
    blogCtaViewProducts: "View Products",
    blogCtaExploreSolutions: "Explore Solutions",
    blogCtaRequestQuote: "Request a Quote",
    blogCategoryAll: "All",
    blogCategoryBuyingGuide: "Buying Guide",
    blogCategoryCustomization: "Customization",
    blogCategorySampleOrder: "Sample Order",
    blogCategorySourcing: "Sourcing",
    blogCategoryProductTips: "Product Tips",
    breadcrumbProductDetail: "Product Detail",
    breadcrumbHomeSeries: "Private Label Series",
    breadcrumbHome: "Home",
    nav: "nav",
    buyerWholesalers: "Wholesalers",
    buyerWholesalersNote: "Bulk assortments and restocking support.",
    buyerRetailers: "Retailers",
    buyerRetailersNote: "Shelf-ready programs and packaging support.",
    buyerFitnessBrands: "Fitness Brands",
    buyerFitnessBrandsNote: "Private label support for product line expansion.",
    buyerYogaStudios: "Yoga Studios",
    buyerYogaStudiosNote: "Studio bundles and accessory replenishment.",
    buyerAmazonSellers: "Amazon Sellers",
    buyerAmazonSellersNote: "Marketplace-ready products with flexible MOQ.",
    buyerEcom: "E-commerce Businesses",
    buyerEcomNote: "Online-focused assortments for repeat sales.",

    featureSourcingTitle: "Product Sourcing",
    featureSourcingBody: "Compare specs before order.",
    featurePrivateLabelTitle: "Private Label",
    featurePrivateLabelBody: "Logo, pack and bundle support.",
    featureFlexibleOrderTitle: "Flexible Orders",
    featureFlexibleOrderBody: "Trial and repeat order options.",
    featureExportTitle: "Export Support",
    featureExportBody: "Docs and shipping follow-up.",

    metricVerified: "Verified Suppliers",
    metricVerifiedLabel: "Category-matched",
    metricMoq: "Flexible MOQ",
    metricMoqLabel: "Trial + repeat",
    metricBranding: "Private Label",
    metricBrandingLabel: "Brand + packaging",
    metricDocs: "Export Ready",
    metricDocsLabel: "EU/US docs",

    whyVerifiedTitle: "Verified Supplier Network",
    whyVerifiedBody: "Matched suppliers by category, quality and target market.",
    whyMoqTitle: "Flexible MOQ Support",
    whyMoqBody: "Practical order quantities for testing and phased growth.",
    whyOemTitle: "OEM & Private Label Assistance",
    whyOemBody: "Coordinate logo, packaging and bundles for your channel.",
    whySourcingTitle: "Sourcing & Selection Guidance",
    whySourcingBody: "Compare options by material, spec and positioning.",
    whyDeliveryTitle: "Stable Delivery Coordination",
    whyDeliveryBody: "Track milestones and schedules to reduce delivery risk.",
    whyInspectionTitle: "Pre-Shipment Quality Inspection",
    whyInspectionBody: "Check key quality and packing points before shipment.",

    proofStatA: "Yoga & light fitness focus",
    proofStatB: "Private label coordination",
    proofStatC: "Global buyer support",

    qcSupplierTitle: "Supplier Qualification Review",
    qcSupplierBody: "Check capability and records.",
    qcInspectionTitle: "Pre-Shipment Inspection",
    qcInspectionBody: "Verify product, label and pack.",
    qcComplianceTitle: "Product Compliance Support",
    qcComplianceBody: "Prepare destination documents.",
    qcCertTitle: "Certification Coordination",
    qcCertBody: "Align files with partners.",

    faqQ1: "Are you a manufacturer or a supply chain integrator?",
    faqA1: "We are a yoga product supply chain integrator. We work with verified partners and coordinate sourcing, customization, quality control, shipment, and after-sales support for buyers.",
    faqQ2: "Can you support private label and smaller trial orders?",
    faqA2: "Yes. For many items we can help arrange private label details and discuss flexible starting quantities based on the product and project scope.",
    faqQ3: "How do you manage quality and compliance?",
    faqA3: "We confirm specifications, review samples, follow production checkpoints with partners and check packing details before shipment.",
    homeBreadcrumbCurrent: "Current page",
    homeHeroEyebrow: "Global Sourcing Support",
    homeHeroTitle: "Your Reliable Partner for Product Sourcing and Customization",
    homeHeroSubtitle: "We support global buyers with product sourcing, customization, sampling, and order follow-up through clear communication and practical cooperation.",
    homeQuickAccessEyebrow: "Quick Access",
    homeQuickAccessTitle: "Explore Core Sourcing Topics",
    homeQuickAccessBody: "Use these quick links to navigate common wholesale and customization requests.",
    homeCategoryBrowseMore: "Browse More Series",
    homeBestSellingEyebrow: "Best-Selling Products",
    homeBestSellingTitle: "Best-Selling Yoga & Fitness Products",
    homeBestSellingBody: "Explore popular items for wholesale, studio and online channels.",
    homeBestSellingCardKicker: "Popular with B2B Buyers",
    homeSolutionsTitle: "Solutions for Different Buyer Types",
    homeSolutionsBody: "Use the existing solutions page as a practical guide for channels, use cases, and product planning.",
    homeSolutionsButton: "Explore Solutions",
    homeQualitySupportTitle: "Trusted by Buyers Across Global Markets",
    homeQualitySupportBody: "Buyer-side representatives from partner companies in key markets share their cooperation experience.",
    buyerReviewsAria: "Real customer reviews",
    buyerReviewsTitle: "Real Buyer Reviews",
    reviewName1: "Sarah Mitchell",
    reviewRole1: "Senior Sourcing Lead, Core Active LLC",
    reviewCountry1: "United States",
    reviewText1: "Their team kept every step transparent and service-oriented. We felt supported from first sample review to final shipment handover.",
    reviewName2: "Omar Al-Hassan",
    reviewRole2: "Import Operations Manager, Gulf Horizon Trading",
    reviewCountry2: "Saudi Arabia",
    reviewText2: "Your team gives clear updates and very good service. We feel comfortable in each step, and shipment timing matched our plan.",
    reviewName3: "Sophie Laurent",
    reviewRole3: "Buying Lead, Maison Fit France",
    reviewCountry3: "France",
    reviewText3: "Coordination quality was excellent. The team proactively followed up on details and gave us confidence for repeat orders in the EU market.",
    reviewName4: "James Carter",
    reviewRole4: "Purchasing Director, Northline Wellness UK",
    reviewCountry4: "United Kingdom",
    reviewText4: "The cooperation felt reliable and warm. Milestones were clear, issues were handled quickly, and delivery quality matched the agreed standards.",
    reviewStarsUnit: "stars",
    homeShowcaseAria: "Trade show product showcase",
    homeShowcaseAlt1: "Trade show yoga product booth overview",
    homeShowcaseAlt2: "Yoga mat showcase wall at exhibition booth",
    homeShowcaseAlt3: "Yoga accessories display rack in trade show booth",
    homeSeoFallbackTitle: "Product Sourcing and Customization Support | LOYA SPORT",
    homeSeoFallbackDescription: "Professional product sourcing, customization, private label support, and order follow-up for global wholesale buyers.",
    homeSourcingInsightsEyebrow: "Sourcing Insights",
    homeSourcingInsightsTitle: "Practical Cooperation for Global Wholesale Buyers",
    homeScenariosTitle: "Common Application Scenarios",
    homeScenariosBody: "Scenario planning is connected to the existing solutions page for deeper details.",
    homeScenariosLink: "Go to Solutions",
    homeProcessTitle: "Clear Cooperation Process",
    homeProcessBody: "From initial inquiry to shipment coordination, each step follows a clear handoff path.",
    homeBlogTitle: "Latest Buying and Sourcing Topics",
    homeBlogBody: "Browse concise articles focused on procurement, sampling, and customization planning.",
    homeBlogReadMore: "Read More",
    homeAboutTitle: "Who We Support and How We Cooperate",
    homeAboutBody: "We focus on practical cooperation for importers, distributors, retailers, and online sellers who need consistent communication in product sourcing and customization projects. The support scope covers requirement alignment, sample coordination, quotation communication, and order follow-up. The goal is to keep each stage clear, realistic, and execution-oriented for long-term international cooperation.",
    homeAboutLink: "Company Profile",
    homeFaqAria: "Frequently asked questions",
    homeFaqTitle: "Frequently Asked Questions",
    homeFaqBody: "Quick answers before you submit your inquiry.",
    homeFaqShowLess: "Show Less FAQ",
    homeFaqViewAll: "View All FAQ",
    homeFormNamePlaceholder: "Your Name",
    homeFormEmailPlaceholder: "Work Email",
    homeFormWhatsappPlaceholder: "WhatsApp",
    homeFormCompanyPlaceholder: "Company",
    homeFormProductPlaceholder: "Target Product",
    homeFormQuantityPlaceholder: "Estimated Quantity",
    homeFormMessagePlaceholder: "Product specs, quantity, destination market",
    homeFormUploadLabel: "Upload Reference File (optional)",
    homeFormChooseFile: "Choose File",
    homeFormNoFile: "No file selected",
    homeFormSelectedFilePrefix: "Selected file:",
    carouselAriaLabel: "Promotional banners",
    carouselBannerAltPrefix: "Banner",
    carouselPrevAria: "Previous slide",
    carouselNextAria: "Next slide",
    carouselDotsAria: "Carousel slide selectors",
    footerCtaAria: "Footer inquiry call to action",
    footerCtaTitle: "B2B yoga sourcing support",
    footerCtaPrimary: "Send inquiry",
    footerCtaSecondary: "WhatsApp us",
    footerCompanyProfileAria: "Company profile",
    footerBrandCopy: "A supply chain integration partner for overseas buyers, delivering end-to-end support from strict product screening and factory selection to quality control and complete after-sales service.",
    footerTrustPointA: "Response within 24 hours",
    footerTrustPointB: "OEM and ODM projects",
    footerTrustPointC: "Worldwide B2B delivery",
    footerQuickLinksAria: "Quick links",
    footerQuickLinksTitle: "Quick Links",
    footerPopularCategoriesAria: "Popular categories",
    footerPopularCategoriesTitle: "Popular Categories",
    footerBuyerSupportTitle: "Buyer Support",
    footerServicePointA: "Low MOQ coordination",
    footerServicePointB: "Private label sourcing",
    footerServicePointC: "Consolidated shipment support",
    footerServicePointD: "Packaging and compliance follow-up",
    footerContactAria: "Contact information",
    footerEmailLabel: "Email",
    footerWhatsappLabel: "WhatsApp",
    footerPhoneLabel: "Phone",
    footerServiceLabel: "Service",
    footerCoverageLabel: "Coverage",
    footerServiceValue: "Mon-Sat, 9:00-18:00 CST",
    footerCoverageValue: "Global markets (including Europe, North America, Middle East, Oceania, and APAC)",
    footerBottomCopyright: "Yoga and fitness product sourcing for international wholesale business.",
    footerLocationValue: "Changsha, China",
    footerNewsletterTitle: "Catalog Updates",
    footerNewsletterDesc: "Leave your email to receive new yoga product ideas and customization options.",
    footerNewsletterPlaceholder: "Your email address",
    homeEyebrowProductCategories: "Product Categories",
    homeEyebrowFeaturedSelection: "Featured Selection",
    homeEyebrowSupplyChain: "Supply Chain Advantages",
    homeEyebrowQualityControl: "Quality Control",
    homeEyebrowUseCases: "Use Cases",
    homeEyebrowWorkflow: "Workflow",
    homeEyebrowBlog: "Blog & Insights",
    homeEyebrowAbout: "About",
    homeEyebrowFaq: "FAQ",
    homeAriaIntro: "B2B yoga and fitness sourcing overview",
    homeAriaQuickNav: "Quick SEO navigation",
    homeAriaCategoryGallery: "Product categories gallery",
    homeAriaBestSellingHead: "Best-selling products",
    homeAriaBestSellingGrid: "Curated best-selling products",
    homeAriaSolutionsNav: "Solutions navigation",
    homeAriaSupplyQuality: "Supply chain and quality support highlights",
    homeAriaSourcingOverview: "Sourcing and customization overview",
    homeAriaScenarios: "Application scenarios",
    homeAriaProcess: "Cooperation process",
    homeAriaBlog: "Blog highlights",
    homeAriaAboutSummary: "About summary",
    homeEmptyBadge: "Inventory pending",
    homeEmptyTitle: "No products available yet",
    homeEmptySuffix: " will appear here once items are published.",
    homeQuickLink1Title: "Product Sourcing",
    homeQuickLink1Body: "Flexible sourcing support for wholesale buyers.",
    homeQuickLink2Title: "Private Label Support",
    homeQuickLink2Body: "Branding and packaging options for market-ready SKUs.",
    homeQuickLink3Title: "OEM / ODM Cooperation",
    homeQuickLink3Body: "From requirements to sample confirmation and production.",
    homeQuickLink4Title: "Sample Order Support",
    homeQuickLink4Body: "Discuss trial samples before bulk order planning.",
    homeQuickLink5Title: "Wholesale Supply",
    homeQuickLink5Body: "Suitable for distributors, retailers and online sellers.",
    homeQuickLink6Title: "Solutions Guidance",
    homeQuickLink6Body: "Find practical routes by buyer type and use case.",
    homeScenario1Title: "Retail Channel Preparation",
    homeScenario1Body: "Build a practical assortment for shelf-ready and wholesale-ready distribution.",
    homeScenario2Title: "Marketplace Product Program",
    homeScenario2Body: "Coordinate product combinations and packaging details for online channels.",
    homeScenario3Title: "Studio and Gym Supply",
    homeScenario3Body: "Prepare durable product sets for class usage and member resale.",
    homeProcessStep1: "Inquiry",
    homeProcessStep2: "Requirement Review",
    homeProcessStep3: "Sample Discussion",
    homeProcessStep4: "Quotation",
    homeProcessStep5: "Order Confirmation",
    homeProcessStep6: "Production Follow-up",
    homeProcessStep7: "Shipment Coordination",
    homeBlogHighlight1Title: "How to Prepare an Efficient Product Sourcing Inquiry",
    homeBlogHighlight1Body: "A practical checklist for product details, quantity, and destination information before asking for quotation.",
    homeBlogHighlight2Title: "Private Label Planning: Key Points Before Sample Stage",
    homeBlogHighlight2Body: "Logo method, packaging details, and timeline alignment that reduce revision rounds.",
    homeBlogHighlight3Title: "Wholesale Trial Orders: A Safe Way to Start Cooperation",
    homeBlogHighlight3Body: "How buyers can evaluate product quality and communication flow before larger orders.",
    homeFallbackFaq1Question: "What information is needed for a quotation?",
    homeFallbackFaq1Answer: "Share product name or image, estimated quantity, destination market, and packaging requirements so we can respond efficiently.",
    homeFallbackFaq2Question: "Can you support private label requests?",
    homeFallbackFaq2Answer: "Yes. Private label support can include logo method discussion, packaging details, and production alignment based on your requirements.",
    homeFallbackFaq3Question: "Do you offer sample support before bulk orders?",
    homeFallbackFaq3Answer: "Sample discussion is available to help confirm product specifications and communication expectations before larger production planning.",
    homeFallbackFaq4Question: "Can small trial orders be discussed?",
    homeFallbackFaq4Answer: "Trial quantities can be discussed depending on product type, packaging needs, and production arrangement.",
    homeFallbackFaq5Question: "How do you handle customization communication?",
    homeFallbackFaq5Answer: "We usually align requirements in writing, confirm sample details, and keep milestone-based updates during execution.",
    homeFallbackFaq6Question: "What is the usual cooperation process?",
    homeFallbackFaq6Answer: "The usual flow is inquiry, requirement review, sample confirmation, quotation, order confirmation, and shipment follow-up.",
    homeFallbackFaq7Question: "Can you support export document coordination?",
    homeFallbackFaq7Answer: "Export document coordination can be discussed based on destination and shipping arrangement requirements.",
    homeFallbackFaq8Question: "How quickly can I expect an initial response?",
    homeFallbackFaq8Answer: "Initial response speed depends on request complexity, and detailed product information usually helps shorten turnaround time.",
    marketNorthAmerica: "North America",
    marketNorthAmericaNote: "Importers \u00b7 Online Brands \u00b7 Studio Retail",
    marketEurope: "Europe",
    marketEuropeNote: "Distributors \u00b7 Wellness Chains \u00b7 Private Label Buyers",
    marketAsiaPacific: "Asia Pacific",
    marketAsiaPacificNote: "Yoga Studios \u00b7 Ecommerce Sellers \u00b7 Fitness Retailers",
    marketMiddleEast: "Middle East",
    marketMiddleEastNote: "Boutique Brands \u00b7 Corporate Wellness \u00b7 Gift Set Buyers",
    homeCtaEyebrow: "FOR IMPORTERS \u2022 DISTRIBUTORS \u2022 STUDIOS \u2022 ONLINE BRANDS",
    homeCtaTitle: "Request a product plan for your target market.",
    homeCtaDescription: "Tell us your country, sales channel, product category, target MOQ and brand style. We will organize suitable product options and customization routes.",
    homeCtaPrimary: "Send Inquiry",
    homeCtaSecondary: "Browse Categories",
    homeRequestCatalog: "Request Full Catalog",
    homeSeoKeywordBody: "As a sourcing partner in China for global buyers, we focus on practical cooperation around product sourcing, product customization, and private label support. The homepage is designed to help procurement teams quickly understand how cooperation can move from inquiry to shipment with clear communication. For buyers evaluating OEM ODM support, sample order support, and wholesale supply options, a structured process can reduce uncertainty and improve execution speed. Instead of adding unnecessary complexity, the cooperation model emphasizes requirement clarity, sample alignment, and consistent order follow-up. Whether your plan starts from a small trial request or a larger procurement schedule, the focus remains the same: stable communication, realistic lead-time alignment, and actionable support for product and packaging requirements across international markets."
  },
  zh: {
    // --- TEXTS keys ---
    title: "LOYA SPORT",
    subtitle: "国际批发买家的瑜伽及轻健身采购合作伙伴",
    loading: "产品加载中……",
    error: "产品加载失败，请检查服务状态。",
    language: "语言",
    currency: "货币",
    requestQuote: "获取报价",
    sendMessage: "提交询盘",
    heroTag: "国际B2B采购",
    heroTitle: "为B2B买家甄选优质瑜伽及轻健身产品",
    heroBody: "我们为批发买家提供从精细选品、严格质控到完善售后的全流程供应链协同。",
    heroBulletA: "精选产品系列",
    heroBulletB: "贴牌支持",
    heroBulletC: "认证供应链",
    heroBulletD: "全球供货覆盖",
    heroBulletE: "快速报价响应",
    heroCardTitle: "我们的采购支持方式",
    heroCardBody: "请告知目标产品、品牌需求及采购计划，我们比对方案、安排样品并协同交付进度。",
    categoryTitle: "热门产品分类",
    categoryBody: "探索适合批发渠道的高需求瑜伽及健身系列。",
    featuredTitle: "精选产品推荐",
    featuredBody: "查看重点产品并按数量和品牌方案获取报价。",
    factoryTitle: "供应链优势",
    factoryBody: "清晰的供应商匹配、起订量与出口准备。",
    storyTitle: "值得信赖的供应链协同",
    storyBody: "快速确认参数，保障交付进度。",
    storyBodyExtra: "从供应商匹配、样品确认到出货节点跟进，我们提供可追踪的协同信息，让采购计划更可控。",
    serviceTitle: "质量与合规流程",
    proofEyebrow: "关于我们",
    proofTitle: "瑜伽及轻健身B2B采购合作伙伴",
    proofBody: "我们专注于为全球批发、零售及电商渠道提供瑜伽和轻健身产品采购服务。",
    proofBodyExtra: "",
    proofCta: "联系B2B团队",
    inquiryCtaEyebrow: "获取报价",
    inquiryCtaTitle: "准备采购您的下一个瑜伽产品系列？",
    inquiryCtaBody: "请告知目标产品及采购计划，我们将回复定制化报价。",
    inquiryQuickA: "目标响应：8个工作小时内",
    inquiryQuickB: "服务市场：全球批发渠道",
    inquiryTitle: "获取报价",
    inquiryHint: "请填写产品、数量、品牌需求及目的市场。",
    inquirySuccess: "感谢您的询盘，我们的B2B团队会尽快回复。",
    inquiryError: "请填写姓名、邮箱和询盘详情。",
    inquirySubmitting: "提交中...",
    inquirySubmitFailed: "提交失败，请稍后重试。",
    chooseLanguageTitle: "服务对象",
    chooseLanguageBody: "专为核心B2B渠道打造。",
    trustA: "认证供应链合作",
    trustB: "灵活OEM与包装支持",
    trustC: "可靠交期管理",
    trustD: "严格出货前质检",
    viewMore: "了解更多",
    viewAll: "查看全部产品",
    talkToUs: "联系我们团队",
    contactUs: "联系我们",
    certifications: "质量与合规",
    headerVerified: "认证供应商",
    headerPrivateLabel: "贴牌定制",
    headerGlobalShipping: "全球交付",
    ariaBackToHomepage: "返回首页",
    ariaToggleNavigationMenu: "切换导航菜单",
    ariaPrimaryNavigation: "主导航",
    ariaSearchProductByName: "按名称搜索产品",
    ariaSearch: "搜索",
    sortLabel: "排序",
    sortDefault: "默认",
    ariaSortProducts: "产品排序",
    contactModelPrefix: "型号",
    ariaSwitchStorefrontLanguage: "切换前台语言",
    ariaAccountCenter: "账号中心",
    ariaLogin: "登录",
    globalContactTagline: "面向国际批发买家的瑜伽与健身产品采购支持",
    accountCenter: "账号中心",
    productsCategoryTitle: "产品分类",
    productsAll: "全部产品",
    productsOthers: "其他",
    productsCategoryNavigationAria: "产品分类导航",
    productsContactNow: "立即联系",
    productsEmpty: "该分类暂无产品。",
    productsPaginationAria: "产品分页",
    productsPrev: "上一页",
    productsNext: "下一页",
    productsPage: "第",
    bookmarkHint: "按 Ctrl+D（Mac 为 Cmd+D）将本站加入书签。",
    ariaBreadcrumbNavigation: "面包屑导航",
    ariaPrivacyPreference: "隐私偏好",
    privacyTitle: "您的隐私选择",
    privacyBody: "我们使用必要技术运行店铺，并提供可选的隐私安全增强功能，以改进搜索和推荐。",
    privacyOptionEnhanced: "我已了解：启用可选增强功能，如保存搜索历史和个性化推荐。",
    privacyOptionBasic: "不出售或共享我的个人信息：仅启用店铺必要功能。",
    privacyAccept: "我已了解",
    privacyReject: "不出售或共享我的个人信息",
    ariaOpenPrivacyChoices: "打开隐私政策",
    privacyChoices: "Privacy Policy",
    contactInquiryPresetLoaded: "已加载询盘预设：",
    contactSelectedProduct: "已选产品",
    contactQuoteHint: "为加快报价，请提供目标 SKU、预计年采购量、目标市场和偏好包装样式。",
    inquiryProductDefault: "通用询盘",
    navSubmenuSuffix: "子菜单",
    homeSupplyImageAlt: "供应链协同支持",
    homeCertImageAlt: "认证与合规概览",
    blogSeoTitle: "博客 | 采购洞察与选品指南",
    blogSeoDescription: "面向国际批发与贴牌买家的实用采购指南与选品洞察。",
    blogHeroDescription: "围绕材料选择、样品评估、交付节奏与上市准备，提供面向进口商和贴牌买家的实操内容。",
    blogSearchPlaceholder: "搜索采购洞察",
    blogFeaturedTitle: "精选文章",
    blogLatestTitle: "最新文章",
    blogBrowseTopicTitle: "按主题浏览",
    blogReadMore: "阅读全文",
    blogShowLess: "收起",
    blogDateFallback: "最近更新",
    blogEmptyFeatured: "没有匹配的精选文章，请尝试其他关键词或分类。",
    blogEmptyLatest: "当前筛选条件下没有文章。",
    blogCtaTitle: "需要为下一季产品做采购支持？",
    blogCtaViewProducts: "查看产品",
    blogCtaExploreSolutions: "查看解决方案",
    blogCtaRequestQuote: "获取报价",
    blogCategoryAll: "全部",
    blogCategoryBuyingGuide: "选品指南",
    blogCategoryCustomization: "定制方案",
    blogCategorySampleOrder: "样品订单",
    blogCategorySourcing: "采购实务",
    blogCategoryProductTips: "产品技巧",
    breadcrumbProductDetail: "产品详情",
    breadcrumbHomeSeries: "贴牌系列",
    breadcrumbHome: "首页",
    nav: "导航",
    buyerWholesalers: "批发商",
    buyerWholesalersNote: "大宗配货与补货支持。",
    buyerRetailers: "零售商",
    buyerRetailersNote: "现货方案与包装支持。",
    buyerFitnessBrands: "健身品牌",
    buyerFitnessBrandsNote: "产品线扩展的贴牌支持。",
    buyerYogaStudios: "瑜伽馆",
    buyerYogaStudiosNote: "馆配套餐与配件补充。",
    buyerAmazonSellers: "亚马逊卖家",
    buyerAmazonSellersNote: "灵活起订量的电商现货。",
    buyerEcom: "电商企业",
    buyerEcomNote: "复购导向的线上专供。",

    featureSourcingTitle: "产品采购",
    featureSourcingBody: "下单前可比对参数。",
    featurePrivateLabelTitle: "贴牌定制",
    featurePrivateLabelBody: "LOGO、包装、组合支持。",
    featureFlexibleOrderTitle: "灵活下单",
    featureFlexibleOrderBody: "试单与复购灵活。",
    featureExportTitle: "出口支持",
    featureExportBody: "单证与物流跟进。",

    metricVerified: "认证供应商",
    metricVerifiedLabel: "品类匹配",
    metricMoq: "灵活起订量",
    metricMoqLabel: "试单/复购",
    metricBranding: "贴牌定制",
    metricBrandingLabel: "品牌/包装",
    metricDocs: "出口合规",
    metricDocsLabel: "全球市场文件",

    whyVerifiedTitle: "认证供应网络",
    whyVerifiedBody: "按品类、质量、市场精准匹配。",
    whyMoqTitle: "灵活起订量支持",
    whyMoqBody: "适合测试与分阶段增长。",
    whyOemTitle: "OEM/贴牌协助",
    whyOemBody: "协同LOGO、包装、组合方案。",
    whySourcingTitle: "采购与选型指导",
    whySourcingBody: "材料、参数、定位多维比选。",
    whyDeliveryTitle: "交付进度协同",
    whyDeliveryBody: "跟踪节点降低延误风险。",
    whyInspectionTitle: "出货前质检",
    whyInspectionBody: "发货前重点质检与包装确认。",

    proofStatA: "瑜伽/轻健身专注",
    proofStatB: "贴牌定制协同",
    proofStatC: "全球买家支持",

    qcSupplierTitle: "供应商资质审核",
    qcSupplierBody: "能力与履约记录核查。",
    qcInspectionTitle: "出货前检验",
    qcInspectionBody: "产品、标签、包装核查。",
    qcComplianceTitle: "合规支持",
    qcComplianceBody: "目的地单证准备。",
    qcCertTitle: "认证协同",
    qcCertBody: "与合作方对齐资料。",

    faqQ1: "你们是制造商还是供应链整合商？",
    faqA1: "我们是瑜伽产品供应链整合商，与认证伙伴协同，为买家提供从选品、定制、质控到发运和售后的全流程支持。",
    faqQ2: "能否支持贴牌和小批量试单？",
    faqA2: "大部分产品可协助贴牌细节，起订量灵活，视项目具体沟通。",
    faqQ3: "你们如何把控质量和合规？",
    faqA3: "我们确认参数、审核样品、生产过程节点跟进，发货前核查包装细节。",
    homeBreadcrumbCurrent: "当前页面",
    homeHeroEyebrow: "全球采购支持",
    homeHeroTitle: "值得信赖的产品采购与定制合作伙伴",
    homeHeroSubtitle: "我们通过清晰沟通与务实协作，为全球买家提供产品采购、定制、样品与订单跟进支持。",
    homeQuickAccessEyebrow: "快速入口",
    homeQuickAccessTitle: "探索核心采购主题",
    homeQuickAccessBody: "使用这些快捷入口快速定位常见批发与定制需求。",
    homeCategoryBrowseMore: "浏览更多系列",
    homeBestSellingEyebrow: "畅销产品",
    homeBestSellingTitle: "畅销瑜伽与健身产品",
    homeBestSellingBody: "探索适用于批发、门店与线上渠道的热门产品。",
    homeBestSellingCardKicker: "B2B买家常选",
    homeSolutionsTitle: "针对不同买家类型的解决方案",
    homeSolutionsBody: "可通过解决方案页面查看渠道场景、用途与选品规划建议。",
    homeSolutionsButton: "查看解决方案",
    homeQualitySupportTitle: "来自全球市场买家的真实反馈",
    homeQualitySupportBody: "以下内容来自重点市场合作客户的买家侧代表反馈，并非我司员工介绍。",
    buyerReviewsAria: "真实客户评价",
    buyerReviewsTitle: "真实客户评价",
    reviewName1: "Sarah Mitchell",
    reviewRole1: "Core Active LLC 高级采购负责人",
    reviewCountry1: "美国",
    reviewText1: "团队在每个环节都沟通透明、服务到位。从样品评估到出货交接，我们始终感到被稳定支持。",
    reviewName2: "Omar Al-Hassan",
    reviewRole2: "Gulf Horizon Trading 进口运营经理",
    reviewCountry2: "沙特阿拉伯",
    reviewText2: "团队更新及时、服务到位。每个环节都让我们很安心，出货节奏也与计划一致。",
    reviewName3: "Sophie Laurent",
    reviewRole3: "Maison Fit France 采购负责人",
    reviewCountry3: "法国",
    reviewText3: "协同质量非常高。团队会主动跟进关键细节，让我们在欧洲市场推进复购时更有把握。",
    reviewName4: "James Carter",
    reviewRole4: "Northline Wellness UK 采购总监",
    reviewCountry4: "英国",
    reviewText4: "合作体验可靠且有温度。里程碑清晰、问题处理及时，交付质量与约定标准保持一致。",
    reviewStarsUnit: "星",
    homeShowcaseAria: "展会产品展示",
    homeShowcaseAlt1: "展会瑜伽产品展位全景",
    homeShowcaseAlt2: "展位上的瑜伽垫展示墙",
    homeShowcaseAlt3: "展位中的瑜伽配件陈列架",
    homeSeoFallbackTitle: "产品采购与定制支持 | LOYA SPORT",
    homeSeoFallbackDescription: "面向全球批发买家的专业产品采购、定制、贴牌支持与订单跟进服务。",
    homeSourcingInsightsEyebrow: "采购洞察",
    homeSourcingInsightsTitle: "面向全球批发买家的务实协作",
    homeScenariosTitle: "常见应用场景",
    homeScenariosBody: "场景规划与解决方案页面联动，可查看更完整细节。",
    homeScenariosLink: "前往解决方案",
    homeProcessTitle: "清晰协作流程",
    homeProcessBody: "从初次询盘到出货协同，每一步都遵循明确的交接路径。",
    homeBlogTitle: "最新采购与选品主题",
    homeBlogBody: "浏览聚焦采购、打样与定制规划的精简文章。",
    homeBlogReadMore: "阅读更多",
    homeAboutTitle: "我们服务谁，如何协作",
    homeAboutBody: "我们专注于与进口商、经销商、零售商和线上卖家进行务实协作，确保在产品采购与定制项目中保持稳定沟通。支持范围涵盖需求对齐、样品协同、报价沟通与订单跟进，目标是在长期国际合作中让每个阶段都清晰、可落地、可执行。",
    homeAboutLink: "公司简介",
    homeFaqAria: "常见问题",
    homeFaqTitle: "常见问题",
    homeFaqBody: "在提交询盘前，先查看这些快速解答。",
    homeFaqShowLess: "收起FAQ",
    homeFaqViewAll: "查看全部FAQ",
    homeFormNamePlaceholder: "您的姓名",
    homeFormEmailPlaceholder: "工作邮箱",
    homeFormWhatsappPlaceholder: "WhatsApp",
    homeFormCompanyPlaceholder: "公司名称",
    homeFormProductPlaceholder: "目标产品",
    homeFormQuantityPlaceholder: "预计数量",
    homeFormMessagePlaceholder: "产品规格、数量、目标市场",
    homeFormUploadLabel: "上传参考文件（可选）",
    homeFormChooseFile: "选择文件",
    homeFormNoFile: "未选择文件",
    homeFormSelectedFilePrefix: "已选择文件：",
    carouselAriaLabel: "推广横幅",
    carouselBannerAltPrefix: "横幅",
    carouselPrevAria: "上一张",
    carouselNextAria: "下一张",
    carouselDotsAria: "轮播切换",
    footerCtaAria: "页脚询盘入口",
    footerCtaTitle: "B2B瑜伽采购支持",
    footerCtaPrimary: "发送询盘",
    footerCtaSecondary: "WhatsApp 联系",
    footerCompanyProfileAria: "公司简介",
    footerBrandCopy: "我们是面向海外买家的供应链整合服务伙伴，提供从严格选品、工厂筛选、质量把控到完善售后服务的一站式支持。",
    footerTrustPointA: "24小时内响应",
    footerTrustPointB: "支持 OEM/ODM 项目",
    footerTrustPointC: "全球 B2B 交付",
    footerQuickLinksAria: "快捷链接",
    footerQuickLinksTitle: "快捷链接",
    footerPopularCategoriesAria: "热门分类",
    footerPopularCategoriesTitle: "热门分类",
    footerBuyerSupportTitle: "买家支持",
    footerServicePointA: "低起订量协同",
    footerServicePointB: "贴牌采购支持",
    footerServicePointC: "拼柜与合并发运支持",
    footerServicePointD: "包装与合规跟进",
    footerContactAria: "联系信息",
    footerEmailLabel: "邮箱",
    footerWhatsappLabel: "WhatsApp",
    footerPhoneLabel: "电话",
    footerServiceLabel: "服务时间",
    footerCoverageLabel: "覆盖市场",
    footerServiceValue: "周一至周六 9:00-18:00（CST）",
    footerCoverageValue: "全球市场（含欧洲、北美、中东、大洋洲、亚太等）",
    footerBottomCopyright: "面向国际批发业务的瑜伽与健身产品采购支持。",
    footerLocationValue: "长沙，中国",
    footerNewsletterTitle: "目录更新",
    footerNewsletterDesc: "留下您的邮箱，获取新产品方案与定制选项更新。",
    footerNewsletterPlaceholder: "您的邮箱地址",
    homeEyebrowProductCategories: "产品分类",
    homeEyebrowFeaturedSelection: "精选推荐",
    homeEyebrowSupplyChain: "供应链优势",
    homeEyebrowQualityControl: "质量控制",
    homeEyebrowUseCases: "应用场景",
    homeEyebrowWorkflow: "协作流程",
    homeEyebrowBlog: "博客与洞察",
    homeEyebrowAbout: "关于我们",
    homeEyebrowFaq: "FAQ",
    homeAriaIntro: "B2B 瑜伽与健身采购概览",
    homeAriaQuickNav: "SEO 快捷导航",
    homeAriaCategoryGallery: "产品分类画廊",
    homeAriaBestSellingHead: "畅销产品",
    homeAriaBestSellingGrid: "精选畅销产品",
    homeAriaSolutionsNav: "解决方案导航",
    homeAriaSupplyQuality: "供应链与质量支持亮点",
    homeAriaSourcingOverview: "采购与定制概览",
    homeAriaScenarios: "应用场景",
    homeAriaProcess: "合作流程",
    homeAriaBlog: "博客亮点",
    homeAriaAboutSummary: "关于摘要",
    homeEmptyBadge: "库存准备中",
    homeEmptyTitle: "暂无可展示产品",
    homeEmptySuffix: " 将在发布后显示在这里。",
    homeQuickLink1Title: "产品采购",
    homeQuickLink1Body: "为批发买家提供灵活采购支持。",
    homeQuickLink2Title: "贴牌支持",
    homeQuickLink2Body: "提供面向上市销售的品牌与包装方案。",
    homeQuickLink3Title: "OEM / ODM 协作",
    homeQuickLink3Body: "从需求确认到打样与量产协同。",
    homeQuickLink4Title: "样品订单支持",
    homeQuickLink4Body: "在大货计划前先讨论试样方案。",
    homeQuickLink5Title: "批发供货",
    homeQuickLink5Body: "适用于经销商、零售商与线上卖家。",
    homeQuickLink6Title: "解决方案指引",
    homeQuickLink6Body: "按买家类型与场景找到可执行路径。",
    homeScenario1Title: "零售渠道准备",
    homeScenario1Body: "构建兼顾上架与批发分销的实用产品组合。",
    homeScenario2Title: "平台商品计划",
    homeScenario2Body: "为线上渠道协同商品组合与包装细节。",
    homeScenario3Title: "工作室与健身房供给",
    homeScenario3Body: "为课程使用与会员转售准备耐用产品套组。",
    homeProcessStep1: "询盘",
    homeProcessStep2: "需求评估",
    homeProcessStep3: "样品沟通",
    homeProcessStep4: "报价",
    homeProcessStep5: "订单确认",
    homeProcessStep6: "生产跟进",
    homeProcessStep7: "发运协同",
    homeBlogHighlight1Title: "如何准备高效的产品采购询盘",
    homeBlogHighlight1Body: "在发起报价前，先用清单梳理产品细节、数量与目的地信息。",
    homeBlogHighlight2Title: "贴牌规划：打样前必须确认的关键点",
    homeBlogHighlight2Body: "通过 Logo 工艺、包装细节和时间节点对齐，减少返工轮次。",
    homeBlogHighlight3Title: "批发试单：开启合作的稳妥方式",
    homeBlogHighlight3Body: "在大单前先通过试单评估产品质量与沟通协同效率。",
    homeFallbackFaq1Question: "获取报价需要提供哪些信息？",
    homeFallbackFaq1Answer: "请提供产品名称或图片、预计数量、目标市场和包装要求，以便我们高效回复。",
    homeFallbackFaq2Question: "可以支持贴牌需求吗？",
    homeFallbackFaq2Answer: "可以。贴牌支持可涵盖 Logo 工艺沟通、包装细节及按需求进行生产协同。",
    homeFallbackFaq3Question: "大货前可以先做样品支持吗？",
    homeFallbackFaq3Answer: "可以先进行样品沟通，帮助在大货计划前确认产品规格和协作预期。",
    homeFallbackFaq4Question: "可以讨论小批量试单吗？",
    homeFallbackFaq4Answer: "可根据产品类型、包装需求和生产安排讨论试单数量。",
    homeFallbackFaq5Question: "你们如何处理定制沟通？",
    homeFallbackFaq5Answer: "通常通过书面方式对齐需求，确认样品细节，并在执行阶段按里程碑同步进度。",
    homeFallbackFaq6Question: "常见合作流程是什么？",
    homeFallbackFaq6Answer: "通常流程为询盘、需求评估、样品确认、报价、订单确认与发运跟进。",
    homeFallbackFaq7Question: "可以支持出口单证协同吗？",
    homeFallbackFaq7Answer: "可根据目的地与发运安排要求，协同出口相关单证。",
    homeFallbackFaq8Question: "一般多久可以收到首次回复？",
    homeFallbackFaq8Answer: "首次回复速度取决于需求复杂度，提供更完整的产品信息通常能缩短响应时间。",
    marketNorthAmerica: "北美",
    marketNorthAmericaNote: "进口商 · 线上品牌 · 工作室零售",
    marketEurope: "欧洲",
    marketEuropeNote: "经销商 · 健康连锁 · 贴牌买家",
    marketAsiaPacific: "亚太地区",
    marketAsiaPacificNote: "瑜伽工作室 · 电商卖家 · 健身零售商",
    marketMiddleEast: "中东",
    marketMiddleEastNote: "精品品牌 · 企业健康 · 礼品套装买家",
    homeCtaEyebrow: "适用于进口商 • 经销商 • 工作室 • 线上品牌",
    homeCtaTitle: "为您的目标市场制定产品采购方案。",
    homeCtaDescription: "告诉我们您所在的国家、销售渠道、产品类别、目标 MOQ 和品牌风格，我们将为您整理合适的产品选项和定制路线。",
    homeCtaPrimary: "发送询盘",
    homeCtaSecondary: "浏览分类",
    homeRequestCatalog: "索取完整目录",
    homeSeoKeywordBody: "作为服务全球买家的中国采购合作伙伴，我们专注于围绕产品采购、产品定制和贴牌支持的务实协作。首页旨在帮助采购团队快速理解如何通过清晰沟通，将合作从询盘推进到发运。对于评估 OEM/ODM、样品支持和批发供货方案的买家而言，结构化流程能够降低不确定性并提升执行效率。我们不追求不必要的复杂度，而是强调需求清晰、样品对齐与稳定的订单跟进。无论您从小批量试单还是更大规模采购计划开始，核心始终一致：稳定沟通、合理交期对齐，以及面向国际市场的可执行产品与包装支持。"
  }
};

const EN_TEXTS = STOREFRONT_TEXTS.en;

STOREFRONT_TEXTS.es = {
  ...EN_TEXTS,
  title: "LOYA SPORT",
  subtitle: "Socio de abastecimiento de yoga y fitness ligero para compradores mayoristas internacionales",
  loading: "Cargando productos...",
  error: "Error al cargar productos. Revisa el estado del servicio.",
  language: "Idioma",
  currency: "Moneda",
  requestQuote: "Solicitar cotización",
  sendMessage: "Enviar consulta",
  heroTag: "Abastecimiento internacional B2B",
  heroTitle: "Productos premium de yoga y fitness ligero para compradores B2B",
  heroBody: "Apoyamos a compradores mayoristas con coordinación integral: selección precisa de productos, control de calidad estricto y servicio posventa completo.",
  heroBulletA: "Portafolio de productos curado",
  heroBulletB: "Soporte de marca privada",
  heroBulletC: "Socios de suministro verificados",
  heroBulletD: "Cobertura global de suministro",
  heroBulletE: "Respuesta rápida de cotización",
  heroCardTitle: "Cómo apoyamos tu abastecimiento",
  heroCardBody: "Comparte productos objetivo, requisitos de marca y plan de cantidad. Comparamos opciones, organizamos muestras y coordinamos tiempos de entrega.",
  categoryTitle: "Explora nuestras categorías",
  categoryBody: "Explora colecciones de yoga y fitness de alta demanda para canales mayoristas.",
  featuredTitle: "Selección destacada de productos",
  featuredBody: "Revisa productos clave y solicita cotizaciones por cantidad y plan de marca.",
  factoryTitle: "Ventajas de la cadena de suministro",
  factoryBody: "Selección clara de proveedores, MOQ y preparación de exportación.",
  storyTitle: "Coordinación de cadena de suministro en la que puedes confiar",
  storyBody: "Confirma especificaciones con rapidez y mantén la entrega en curso.",
  storyBodyExtra: "Desde la selección de proveedores hasta muestras y hitos de embarque, mantenemos avances visibles para que tu plan de compra siga bajo control.",
  serviceTitle: "Proceso de calidad y cumplimiento",
  proofEyebrow: "Sobre nosotros",
  proofTitle: "Socio B2B de abastecimiento para Yoga y Fitness Ligero",
  proofBody: "Apoyamos el abastecimiento de yoga y fitness ligero para canales globales de mayorista, retail y e-commerce.",
  proofBodyExtra: "",
  proofCta: "Contacta a nuestro equipo B2B",
  inquiryCtaEyebrow: "Solicitar cotización",
  inquiryCtaTitle: "Listo para abastecer tu próxima línea de productos de yoga?",
  inquiryCtaBody: "Comparte productos objetivo y plan de cantidades. Te responderemos con una cotización personalizada.",
  inquiryQuickA: "Objetivo de respuesta: dentro de 8 horas hábiles",
  inquiryQuickB: "Mercados atendidos: canales mayoristas globales",
  inquiryTitle: "Solicitar cotización",
  inquiryHint: "Cuéntanos producto, cantidad, marca y mercado de destino.",
  inquirySuccess: "Gracias. Hemos recibido tu consulta y nuestro equipo B2B responderá pronto.",
  inquiryError: "Completa nombre, correo y detalles de consulta.",
  inquirySubmitting: "Enviando...",
  inquirySubmitFailed: "No se pudo enviar. Inténtalo de nuevo en un momento.",
  chooseLanguageTitle: "A quién servimos",
  chooseLanguageBody: "Diseñado para canales B2B principales.",
  trustA: "Socios de cadena de suministro verificados",
  trustB: "Soporte flexible OEM y empaque",
  trustC: "Gestión confiable de tiempos de entrega",
  trustD: "Inspección estricta antes del envío",
  viewMore: "Saber más",
  viewAll: "Ver productos",
  talkToUs: "Habla con nuestro equipo",
  contactUs: "Contáctanos",
  certifications: "Calidad y cumplimiento",
  headerVerified: "Proveedores verificados",
  headerPrivateLabel: "Marca privada",
  headerGlobalShipping: "Envío global",
  ariaBackToHomepage: "Volver al inicio",
  ariaToggleNavigationMenu: "Alternar menú de navegación",
  ariaPrimaryNavigation: "Navegación principal",
  ariaSearchProductByName: "Buscar producto por nombre",
  ariaSearch: "buscar",
  sortLabel: "Ordenar",
  sortDefault: "Por defecto",
  ariaSortProducts: "Ordenar productos",
  contactModelPrefix: "Modelo",
  ariaSwitchStorefrontLanguage: "Cambiar idioma del storefront",
  ariaAccountCenter: "Centro de cuenta",
  ariaLogin: "Iniciar sesión",
  globalContactTagline: "Soporte de abastecimiento de yoga y fitness para compradores mayoristas internacionales",
  accountCenter: "Centro de cuenta",
  productsCategoryTitle: "Categorías de productos",
  productsAll: "Todos los productos",
  productsOthers: "Otros",
  productsCategoryNavigationAria: "Navegación de categorías de productos",
  productsContactNow: "Contactar ahora",
  productsEmpty: "No se encontraron productos en esta categoría.",
  productsPaginationAria: "Paginación de productos",
  productsPrev: "Anterior",
  productsNext: "Siguiente",
  productsPage: "Página",
  bookmarkHint: "Pulsa Ctrl+D (o Cmd+D en Mac) para guardar este sitio en favoritos.",
  ariaBreadcrumbNavigation: "Navegación de migas de pan",
  ariaPrivacyPreference: "Preferencia de privacidad",
  privacyTitle: "Tus opciones de privacidad",
  privacyBody: "Usamos tecnologías esenciales para operar la tienda y funciones opcionales seguras para mejorar búsqueda y recomendaciones.",
  privacyOptionEnhanced: "Entiendo: habilita mejoras opcionales como historial de búsqueda recordado y recomendaciones personalizadas.",
  privacyOptionBasic: "No vender ni compartir mi información personal: mantiene solo las funciones esenciales habilitadas.",
  privacyAccept: "Entiendo",
  privacyReject: "No vender ni compartir mi información personal",
  ariaOpenPrivacyChoices: "Abrir politica de privacidad",
  privacyChoices: "Privacy Policy",
  contactInquiryPresetLoaded: "Consulta prellenada para",
  contactSelectedProduct: "producto seleccionado",
  contactQuoteHint: "Para acelerar la cotización, incluye SKU objetivo, volumen anual estimado, mercado destino y estilo de empaque preferido.",
  inquiryProductDefault: "Consulta general",
  navSubmenuSuffix: "submenú",
  homeSupplyImageAlt: "Soporte de coordinación de la cadena de suministro",
  homeCertImageAlt: "Resumen de certificaciones y cumplimiento",
  breadcrumbProductDetail: "Detalle del producto",
  breadcrumbHomeSeries: "Serie de Marca Privada",
  breadcrumbHome: "Inicio",
  nav: "nav",
  buyerWholesalers: "Mayoristas",
  buyerWholesalersNote: "Soporte para surtidos al por mayor y reposición.",
  buyerRetailers: "Minoristas",
  buyerRetailersNote: "Programas listos para estantería y soporte de empaque.",
  buyerFitnessBrands: "Marcas fitness",
  buyerFitnessBrandsNote: "Soporte de marca privada para expansión de línea.",
  buyerYogaStudios: "Estudios de yoga",
  buyerYogaStudiosNote: "Paquetes para estudio y reposición de accesorios.",
  buyerAmazonSellers: "Vendedores de Amazon",
  buyerAmazonSellersNote: "Productos listos para marketplace con MOQ flexible.",
  buyerEcom: "Negocios de e-commerce",
  buyerEcomNote: "Surtidos enfocados en ventas online recurrentes.",
  featureSourcingTitle: "Abastecimiento de producto",
  featureSourcingBody: "Compara especificaciones antes de ordenar.",
  featurePrivateLabelTitle: "Marca privada",
  featurePrivateLabelBody: "Soporte de logo, empaque y bundle.",
  featureFlexibleOrderTitle: "Pedidos flexibles",
  featureFlexibleOrderBody: "Opciones para pedido de prueba y recompra.",
  featureExportTitle: "Soporte de exportación",
  featureExportBody: "Documentos y seguimiento logístico.",
  metricVerified: "Proveedores verificados",
  metricVerifiedLabel: "Ajuste por categoría",
  metricMoq: "MOQ flexible",
  metricMoqLabel: "Prueba + recompra",
  metricBranding: "Marca privada",
  metricBrandingLabel: "Marca + empaque",
  metricDocs: "Listo para exportar",
  metricDocsLabel: "Docs UE/EE. UU.",
  whyVerifiedTitle: "Red de proveedores verificados",
  whyVerifiedBody: "Proveedores alineados por categoría, calidad y mercado objetivo.",
  whyMoqTitle: "Soporte de MOQ flexible",
  whyMoqBody: "Cantidades prácticas para pruebas y crecimiento por etapas.",
  whyOemTitle: "Asistencia OEM y Marca Privada",
  whyOemBody: "Coordinamos logo, empaque y bundles para tu canal.",
  whySourcingTitle: "Guía de abastecimiento y selección",
  whySourcingBody: "Compara opciones por material, especificación y posicionamiento.",
  whyDeliveryTitle: "Coordinación estable de entrega",
  whyDeliveryBody: "Seguimiento de hitos para reducir riesgo de retrasos.",
  whyInspectionTitle: "Inspección de calidad preembarque",
  whyInspectionBody: "Revisión de calidad y empaque antes del envío.",
  proofStatA: "Especialistas en yoga y fitness ligero",
  proofStatB: "Coordinación de marca privada",
  proofStatC: "Soporte para compradores globales",
  qcSupplierTitle: "Revisión de calificación de proveedor",
  qcSupplierBody: "Verificamos capacidad y registros.",
  qcInspectionTitle: "Inspección preembarque",
  qcInspectionBody: "Verificamos producto, etiqueta y empaque.",
  qcComplianceTitle: "Soporte de cumplimiento",
  qcComplianceBody: "Preparamos documentos del mercado destino.",
  qcCertTitle: "Coordinación de certificaciones",
  qcCertBody: "Alineamos archivos con socios.",
  faqQ1: "Son fabricante o integrador de cadena de suministro?",
  faqA1: "Somos un integrador de cadena de suministro para productos de yoga. Trabajamos con socios verificados y coordinamos abastecimiento, personalización, control de calidad, envío y posventa.",
  faqQ2: "Pueden apoyar marca privada y pedidos de prueba pequeños?",
  faqA2: "Sí. En muchos productos podemos coordinar detalles de marca privada y cantidades iniciales flexibles según el producto y el alcance del proyecto.",
  faqQ3: "Cómo gestionan calidad y cumplimiento?",
  faqA3: "Confirmamos especificaciones, revisamos muestras, seguimos hitos de producción con socios y verificamos detalles de empaque antes del envío.",
  blogSeoTitle: "Blog | Ideas y guias de compra",
  blogSeoDescription: "Guias practicas de compra e ideas de abastecimiento para compradores mayoristas y de marca privada.",
  blogHeroDescription: "Guias practicas de abastecimiento para importadores y compradores de marca privada, desde materiales y muestras hasta planificacion de pedidos para lanzamiento.",
  blogSearchPlaceholder: "Buscar ideas de abastecimiento",
  blogFeaturedTitle: "Articulo destacado",
  blogLatestTitle: "Articulos recientes",
  blogBrowseTopicTitle: "Explorar por tema",
  blogReadMore: "Leer mas",
  blogShowLess: "Mostrar menos",
  blogDateFallback: "Actualizado recientemente",
  blogEmptyFeatured: "No hay articulo destacado que coincida. Prueba con otra palabra clave o categoria.",
  blogEmptyLatest: "Ningun articulo coincide con el filtro actual.",
  blogCtaTitle: "Necesitas soporte de abastecimiento para tu proxima coleccion?",
  blogCtaViewProducts: "Ver productos",
  blogCtaExploreSolutions: "Explorar soluciones",
  blogCtaRequestQuote: "Solicitar cotizacion",
  blogCategoryAll: "Todos",
  blogCategoryBuyingGuide: "Guia de compra",
  blogCategoryCustomization: "Personalizacion",
  blogCategorySampleOrder: "Pedido de muestra",
  blogCategorySourcing: "Abastecimiento",
  blogCategoryProductTips: "Consejos de producto",
  homeBreadcrumbCurrent: "Pagina actual",
  homeHeroEyebrow: "Soporte global de abastecimiento",
  homeHeroTitle: "Tu socio confiable para abastecimiento y personalizacion de productos",
  homeHeroSubtitle: "Apoyamos a compradores globales con abastecimiento, personalizacion, muestreo y seguimiento de pedidos mediante comunicacion clara y cooperacion practica.",
  homeQuickAccessEyebrow: "Acceso rapido",
  homeQuickAccessTitle: "Explora temas clave de abastecimiento",
  homeQuickAccessBody: "Usa estos enlaces rapidos para navegar solicitudes comunes de mayoreo y personalizacion.",
  homeCategoryBrowseMore: "Explorar mas series",
  homeBestSellingEyebrow: "Productos mas vendidos",
  homeBestSellingTitle: "Productos de yoga y fitness mas vendidos",
  homeBestSellingBody: "Explora articulos populares para canales mayoristas, estudios y venta en linea.",
  homeBestSellingCardKicker: "Popular entre compradores B2B",
  homeSolutionsTitle: "Soluciones para distintos tipos de compradores",
  homeSolutionsBody: "Usa la pagina de soluciones como guia practica para canales, escenarios de uso y planificacion de productos.",
  homeSolutionsButton: "Explorar soluciones",
  homeQualitySupportTitle: "Con la confianza de compradores en mercados globales",
  homeQualitySupportBody: "Representantes del lado comprador de empresas asociadas en mercados clave comparten su experiencia de cooperacion.",
  homeSourcingInsightsEyebrow: "Ideas de abastecimiento",
  homeSourcingInsightsTitle: "Cooperacion practica para compradores mayoristas globales",
  homeScenariosTitle: "Escenarios de aplicacion comunes",
  homeScenariosBody: "La planificacion por escenarios esta conectada con la pagina de soluciones para mayor detalle.",
  homeScenariosLink: "Ir a soluciones",
  homeProcessTitle: "Proceso de cooperacion claro",
  homeProcessBody: "Desde la consulta inicial hasta la coordinacion de envio, cada paso sigue una ruta de transferencia clara.",
  homeBlogTitle: "Ultimos temas de compra y abastecimiento",
  homeBlogBody: "Explora articulos breves enfocados en compras, muestreo y planificacion de personalizacion.",
  homeBlogReadMore: "Leer mas",
  homeAboutTitle: "A quien apoyamos y como cooperamos",
  homeAboutBody: "Nos enfocamos en la cooperacion practica con importadores, distribuidores, minoristas y vendedores en linea que necesitan comunicacion consistente en proyectos de abastecimiento y personalizacion. El alcance incluye alineacion de requisitos, coordinacion de muestras, comunicacion de cotizaciones y seguimiento de pedidos. El objetivo es mantener cada etapa clara, realista y orientada a la ejecucion para una cooperacion internacional de largo plazo.",
  homeAboutLink: "Perfil de la empresa",
  homeFaqAria: "Preguntas frecuentes",
  homeFaqTitle: "Preguntas frecuentes",
  homeFaqBody: "Respuestas rapidas antes de enviar tu consulta.",
  homeFaqShowLess: "Mostrar menos FAQ",
  homeFaqViewAll: "Ver todas las FAQ",
  homeFormNamePlaceholder: "Tu nombre",
  homeFormEmailPlaceholder: "Correo laboral",
  homeFormWhatsappPlaceholder: "WhatsApp",
  homeFormCompanyPlaceholder: "Empresa",
  homeFormProductPlaceholder: "Producto objetivo",
  homeFormQuantityPlaceholder: "Cantidad estimada",
  homeFormMessagePlaceholder: "Especificaciones, cantidad, mercado destino",
  homeFormUploadLabel: "Subir archivo de referencia (opcional)",
  homeFormChooseFile: "Elegir archivo",
  homeFormNoFile: "Ningun archivo seleccionado",
  homeFormSelectedFilePrefix: "Archivo seleccionado:",
  carouselAriaLabel: "Banners promocionales",
  carouselBannerAltPrefix: "Banner",
  carouselPrevAria: "Diapositiva anterior",
  carouselNextAria: "Siguiente diapositiva",
  carouselDotsAria: "Selectores del carrusel",
  footerCtaAria: "Llamado a la accion de consulta en el pie",
  footerCtaTitle: "Soporte B2B para abastecimiento de yoga",
  footerCtaPrimary: "Enviar consulta",
  footerCtaSecondary: "Escribenos por WhatsApp",
  footerCompanyProfileAria: "Perfil de la empresa",
  footerBrandCopy: "Socio de integracion de cadena de suministro para compradores internacionales, con soporte integral desde la rigurosa seleccion de productos y fabricas hasta el control de calidad y un servicio posventa completo.",
  footerTrustPointA: "Respuesta dentro de 24 horas",
  footerTrustPointB: "Proyectos OEM y ODM",
  footerTrustPointC: "Entrega B2B mundial",
  footerQuickLinksAria: "Enlaces rapidos",
  footerQuickLinksTitle: "Enlaces rapidos",
  footerPopularCategoriesAria: "Categorias populares",
  footerPopularCategoriesTitle: "Categorias populares",
  footerBuyerSupportTitle: "Soporte para compradores",
  footerServicePointA: "Coordinacion de MOQ bajo",
  footerServicePointB: "Abastecimiento de marca privada",
  footerServicePointC: "Soporte de embarque consolidado",
  footerServicePointD: "Seguimiento de empaque y cumplimiento",
  footerContactAria: "Informacion de contacto",
  footerEmailLabel: "Correo",
  footerWhatsappLabel: "WhatsApp",
  footerPhoneLabel: "Teléfono",
  footerServiceLabel: "Servicio",
  footerCoverageLabel: "Cobertura",
  footerServiceValue: "Lun-Sab, 9:00-18:00 CST",
  footerCoverageValue: "Mercados globales (incluyendo Europa, Norteamerica, Medio Oriente, Oceania y APAC)",
  footerBottomCopyright: "Abastecimiento de productos de yoga y fitness para negocios mayoristas internacionales.",
  homeEyebrowProductCategories: "Categorias de productos",
  homeEyebrowFeaturedSelection: "Seleccion destacada",
  homeEyebrowSupplyChain: "Ventajas de la cadena de suministro",
  homeEyebrowQualityControl: "Control de calidad",
  homeEyebrowUseCases: "Casos de uso",
  homeEyebrowWorkflow: "Flujo de trabajo",
  homeEyebrowBlog: "Blog e ideas",
  homeEyebrowAbout: "Acerca de",
  homeEyebrowFaq: "FAQ",
  homeAriaIntro: "Resumen de abastecimiento B2B de yoga y fitness",
  homeAriaQuickNav: "Navegacion SEO rapida",
  homeAriaCategoryGallery: "Galeria de categorias de productos",
  homeAriaBestSellingHead: "Productos mas vendidos",
  homeAriaBestSellingGrid: "Productos mas vendidos seleccionados",
  homeAriaSolutionsNav: "Navegacion de soluciones",
  homeAriaSupplyQuality: "Destacados de soporte de suministro y calidad",
  homeAriaSourcingOverview: "Resumen de abastecimiento y personalizacion",
  homeAriaScenarios: "Escenarios de aplicacion",
  homeAriaProcess: "Proceso de cooperacion",
  homeAriaBlog: "Destacados del blog",
  homeAriaAboutSummary: "Resumen sobre nosotros",
  homeEmptyBadge: "Inventario pendiente",
  homeEmptyTitle: "Aun no hay productos disponibles",
  homeEmptySuffix: " aparecera aqui una vez publicados.",
  homeQuickLink1Title: "Abastecimiento de productos",
  homeQuickLink1Body: "Soporte flexible de abastecimiento para compradores mayoristas.",
  homeQuickLink2Title: "Soporte de marca privada",
  homeQuickLink2Body: "Opciones de branding y empaque para SKU listos para mercado.",
  homeQuickLink3Title: "Cooperacion OEM / ODM",
  homeQuickLink3Body: "Desde requisitos hasta confirmacion de muestras y produccion.",
  homeQuickLink4Title: "Soporte de pedido de muestra",
  homeQuickLink4Body: "Habla de muestras de prueba antes de planificar pedido masivo.",
  homeQuickLink5Title: "Suministro mayorista",
  homeQuickLink5Body: "Adecuado para distribuidores, minoristas y vendedores en linea.",
  homeQuickLink6Title: "Guia de soluciones",
  homeQuickLink6Body: "Encuentra rutas practicas por tipo de comprador y escenario.",
  homeScenario1Title: "Preparacion para canal minorista",
  homeScenario1Body: "Construye un surtido practico para distribucion lista para anaquel y mayoreo.",
  homeScenario2Title: "Programa de productos para marketplace",
  homeScenario2Body: "Coordina combinaciones de producto y detalles de empaque para canales en linea.",
  homeScenario3Title: "Suministro para estudios y gimnasios",
  homeScenario3Body: "Prepara sets duraderos para uso en clases y reventa a miembros.",
  homeProcessStep1: "Consulta",
  homeProcessStep2: "Revision de requisitos",
  homeProcessStep3: "Discusion de muestras",
  homeProcessStep4: "Cotizacion",
  homeProcessStep5: "Confirmacion de pedido",
  homeProcessStep6: "Seguimiento de produccion",
  homeProcessStep7: "Coordinacion de envio",
  homeBlogHighlight1Title: "Como preparar una consulta de abastecimiento eficiente",
  homeBlogHighlight1Body: "Lista practica de detalles de producto, cantidad y destino antes de pedir cotizacion.",
  homeBlogHighlight2Title: "Plan de marca privada: puntos clave antes de la fase de muestra",
  homeBlogHighlight2Body: "Metodo de logo, detalles de empaque y alineacion de tiempos para reducir retrabajos.",
  homeBlogHighlight3Title: "Pedidos de prueba mayoristas: una forma segura de iniciar cooperacion",
  homeBlogHighlight3Body: "Como evaluar calidad del producto y flujo de comunicacion antes de pedidos mayores.",
  homeFallbackFaq1Question: "Que informacion se necesita para una cotizacion?",
  homeFallbackFaq1Answer: "Comparte nombre o imagen del producto, cantidad estimada, mercado destino y requisitos de empaque para responder con eficiencia.",
  homeFallbackFaq2Question: "Pueden apoyar solicitudes de marca privada?",
  homeFallbackFaq2Answer: "Si. El soporte de marca privada puede incluir metodo de logo, detalles de empaque y alineacion de produccion segun tus requisitos.",
  homeFallbackFaq3Question: "Ofrecen soporte de muestras antes de pedidos masivos?",
  homeFallbackFaq3Answer: "El dialogo de muestras esta disponible para confirmar especificaciones y expectativas de comunicacion antes de planear produccion mayor.",
  homeFallbackFaq4Question: "Se pueden discutir pedidos de prueba pequenos?",
  homeFallbackFaq4Answer: "Las cantidades de prueba pueden discutirse segun tipo de producto, necesidades de empaque y arreglo de produccion.",
  homeFallbackFaq5Question: "Como gestionan la comunicacion de personalizacion?",
  homeFallbackFaq5Answer: "Normalmente alineamos requisitos por escrito, confirmamos detalles de muestra y mantenemos actualizaciones por hitos durante la ejecucion.",
  homeFallbackFaq6Question: "Cual es el proceso de cooperacion habitual?",
  homeFallbackFaq6Answer: "El flujo habitual es consulta, revision de requisitos, confirmacion de muestra, cotizacion, confirmacion de pedido y seguimiento de envio.",
  homeFallbackFaq7Question: "Pueden apoyar coordinacion de documentos de exportacion?",
  homeFallbackFaq7Answer: "La coordinacion de documentos de exportacion puede discutirse segun destino y requisitos de envio.",
  homeFallbackFaq8Question: "Con que rapidez puedo esperar una respuesta inicial?",
  homeFallbackFaq8Answer: "La rapidez de respuesta inicial depende de la complejidad de la solicitud; mas detalle de producto suele acortar el tiempo.",
  marketNorthAmerica: "América del Norte",
  marketNorthAmericaNote: "Importadores · Marcas online · Venta en estudios",
  marketEurope: "Europa",
  marketEuropeNote: "Distribuidores · Cadenas de bienestar · Compradores de marca privada",
  marketAsiaPacific: "Asia-Pacífico",
  marketAsiaPacificNote: "Estudios de yoga · Vendedores de e-commerce · Tiendas de fitness",
  marketMiddleEast: "Oriente Medio",
  marketMiddleEastNote: "Marcas boutique · Bienestar corporativo · Compradores de sets regalo",
  homeCtaEyebrow: "PARA IMPORTADORES • DISTRIBUIDORES • ESTUDIOS • MARCAS ONLINE",
  homeCtaTitle: "Solicita un plan de producto para tu mercado objetivo.",
  homeCtaDescription: "Dínos tu país, canal de venta, categoría de producto, MOQ objetivo y estilo de marca. Organizaremos opciones de producto y rutas de personalización adecuadas.",
  homeCtaPrimary: "Enviar consulta",
  homeCtaSecondary: "Explorar categorías",
  homeRequestCatalog: "Solicitar catálogo completo",
  homeSeoKeywordBody: "Como socio de abastecimiento en China para compradores globales, nos enfocamos en cooperacion practica en torno al abastecimiento de productos, la personalizacion y el soporte de marca privada. Esta pagina ayuda a los equipos de compras a entender rapidamente como avanzar de la consulta al envio con comunicacion clara. Para compradores que evaluan soporte OEM/ODM, soporte de muestras y suministro mayorista, un proceso estructurado reduce incertidumbre y mejora la ejecucion. En lugar de agregar complejidad innecesaria, el modelo de cooperacion enfatiza claridad de requisitos, alineacion de muestras y seguimiento constante de pedidos. Ya sea que el plan comience con una prueba pequena o con un calendario de compras mayor, el enfoque es el mismo: comunicacion estable, alineacion realista de plazos y soporte accionable para requisitos de producto y empaque en mercados internacionales.",
  buyerReviewsAria: "Reseñas de compradores reales",
  buyerReviewsTitle: "Opiniones reales de compradores",
  reviewName1: "Sarah Mitchell",
  reviewRole1: "Responsable principal de sourcing, Core Active LLC",
  reviewCountry1: "Estados Unidos",
  reviewText1: "Su equipo mantuvo cada etapa transparente y orientada al servicio. Nos sentimos respaldados desde la primera revisión de muestras hasta la entrega final.",
  reviewName2: "Omar Al-Hassan",
  reviewRole2: "Gerente de operaciones de importación, Gulf Horizon Trading",
  reviewCountry2: "Arabia Saudita",
  reviewText2: "Su equipo da actualizaciones claras y un servicio muy bueno. Nos sentimos cómodos en cada paso, y el tiempo de envío coincidió con nuestro plan.",
  reviewName3: "Sophie Laurent",
  reviewRole3: "Responsable de compras, Maison Fit France",
  reviewCountry3: "Francia",
  reviewText3: "La calidad de coordinación fue excelente. El equipo hizo seguimiento proactivo de los detalles y nos dio confianza para repetir pedidos en el mercado europeo.",
  reviewName4: "James Carter",
  reviewRole4: "Director de compras, Northline Wellness UK",
  reviewCountry4: "Reino Unido",
  reviewText4: "La cooperación fue confiable y cálida. Los hitos fueron claros, los problemas se resolvieron rápidamente y la calidad de entrega cumplió los estándares acordados.",
  reviewStarsUnit: "estrellas",
  homeShowcaseAria: "Exhibición de productos en feria comercial",
  homeShowcaseAlt1: "Vista general del stand de productos de yoga en la feria",
  homeShowcaseAlt2: "Muro de exhibición de colchonetas de yoga en el stand",
  homeShowcaseAlt3: "Expositor de accesorios de yoga en el stand de la feria",
  homeSeoFallbackTitle: "Sourcing y personalización de productos | LOYA SPORT",
  homeSeoFallbackDescription: "Sourcing profesional, personalización, soporte de marca privada y seguimiento de pedidos para compradores mayoristas globales.",
  footerLocationValue: "Changsha, China",
  footerNewsletterTitle: "Actualizaciones del catálogo",
  footerNewsletterDesc: "Deja tu email para recibir nuevas ideas de productos de yoga y opciones de personalización.",
  footerNewsletterPlaceholder: "Tu dirección de email",
};

STOREFRONT_TEXTS.pt = {
  ...EN_TEXTS,
  title: "LOYA SPORT",
  subtitle: "Parceiro de sourcing de yoga e fitness leve para compradores atacadistas internacionais",
  loading: "Carregando produtos...",
  error: "Falha ao carregar produtos. Verifique o status do serviço.",
  language: "Idioma",
  currency: "Moeda",
  requestQuote: "Solicitar cotação",
  sendMessage: "Enviar consulta",
  heroTag: "Sourcing internacional B2B",
  heroTitle: "Produtos premium de yoga e fitness leve para compradores B2B",
  heroBody: "Apoiamos compradores atacadistas com coordenação completa: seleção precisa de produtos, controle de qualidade rigoroso e pós-venda completo.",
  heroBulletA: "Portfólio de produtos selecionado",
  heroBulletB: "Suporte de marca própria",
  heroBulletC: "Parceiros de fornecimento verificados",
  heroBulletD: "Cobertura global de fornecimento",
  heroBulletE: "Resposta rápida de cotação",
  heroCardTitle: "Como apoiamos seu sourcing",
  heroCardBody: "Compartilhe produtos-alvo, requisitos de marca e plano de quantidade. Comparamos opções, organizamos amostras e coordenamos prazos de entrega.",
  categoryTitle: "Explore nossas categorias",
  categoryBody: "Explore coleções de yoga e fitness de alta demanda para canais atacadistas.",
  featuredTitle: "Seleção de produtos em destaque",
  featuredBody: "Revise itens-chave e solicite cotações por quantidade e plano de marca.",
  factoryTitle: "Vantagens da cadeia de suprimentos",
  factoryBody: "Correspondência clara de fornecedores, MOQ e prontidão para exportação.",
  storyTitle: "Coordenação de suprimentos em que você pode confiar",
  storyBody: "Confirme especificações rapidamente e mantenha a entrega no prazo.",
  storyBodyExtra: "Da seleção de fornecedores às amostras e aos marcos de embarque, mantemos o progresso visível para que seu plano de compras siga controlado.",
  serviceTitle: "Processo de qualidade e conformidade",
  proofEyebrow: "Sobre nós",
  proofTitle: "Parceiro B2B de sourcing para Yoga e Fitness Leve",
  proofBody: "Apoiamos sourcing de yoga e fitness leve para canais globais de atacado, varejo e e-commerce.",
  proofBodyExtra: "",
  proofCta: "Fale com nosso time B2B",
  inquiryCtaEyebrow: "Solicitar cotação",
  inquiryCtaTitle: "Pronto para abastecer sua próxima linha de produtos de yoga?",
  inquiryCtaBody: "Compartilhe seus produtos-alvo e plano de quantidades. Responderemos com uma cotação personalizada.",
  inquiryQuickA: "Meta de resposta: em até 8 horas úteis",
  inquiryQuickB: "Mercados atendidos: canais atacadistas globais",
  inquiryTitle: "Solicitar cotação",
  inquiryHint: "Informe produto, quantidade, branding e mercado de destino.",
  inquirySuccess: "Obrigado. Sua consulta foi recebida e nossa equipe B2B responderá em breve.",
  inquiryError: "Preencha nome, e-mail e detalhes da consulta.",
  inquirySubmitting: "Enviando...",
  inquirySubmitFailed: "Falha no envio. Tente novamente em instantes.",
  chooseLanguageTitle: "Quem atendemos",
  chooseLanguageBody: "Feito para os principais canais B2B.",
  trustA: "Parceiros de cadeia de suprimentos verificados",
  trustB: "Suporte flexível de OEM e embalagem",
  trustC: "Gestão confiável de lead time",
  trustD: "Inspeção rigorosa pré-embarque",
  viewMore: "Saiba mais",
  viewAll: "Ver produtos",
  talkToUs: "Fale com nossa equipe",
  contactUs: "Fale conosco",
  certifications: "Qualidade e conformidade",
  headerVerified: "Fornecedores verificados",
  headerPrivateLabel: "Marca própria",
  headerGlobalShipping: "Envio global",
  ariaBackToHomepage: "Voltar para a página inicial",
  ariaToggleNavigationMenu: "Alternar menu de navegação",
  ariaPrimaryNavigation: "Navegação principal",
  ariaSearchProductByName: "Pesquisar produto por nome",
  ariaSearch: "pesquisar",
  sortLabel: "Ordenar",
  sortDefault: "Padrão",
  ariaSortProducts: "Ordenar produtos",
  contactModelPrefix: "Modelo",
  ariaSwitchStorefrontLanguage: "Alterar idioma da vitrine",
  ariaAccountCenter: "Central da conta",
  ariaLogin: "Entrar",
  globalContactTagline: "Suporte de sourcing para yoga e fitness para compradores atacadistas internacionais",
  accountCenter: "Central da conta",
  productsCategoryTitle: "Categorias de produtos",
  productsAll: "Todos os produtos",
  productsOthers: "Outros",
  productsCategoryNavigationAria: "Navegação de categorias de produtos",
  productsContactNow: "Falar agora",
  productsEmpty: "Nenhum produto encontrado nesta categoria.",
  productsPaginationAria: "Paginação de produtos",
  productsPrev: "Anterior",
  productsNext: "Próximo",
  productsPage: "Página",
  bookmarkHint: "Pressione Ctrl+D (ou Cmd+D no Mac) para favoritar este site.",
  ariaBreadcrumbNavigation: "Navegação por trilha",
  ariaPrivacyPreference: "Preferência de privacidade",
  privacyTitle: "Suas escolhas de privacidade",
  privacyBody: "Usamos tecnologias essenciais para operar a loja e recursos opcionais seguros para melhorar busca e recomendações.",
  privacyOptionEnhanced: "Eu entendo: ativa melhorias opcionais como histórico de busca e recomendações personalizadas.",
  privacyOptionBasic: "Não vender ou compartilhar minhas informações pessoais: mantém apenas os recursos essenciais.",
  privacyAccept: "Eu entendo",
  privacyReject: "Não vender ou compartilhar minhas informações pessoais",
  ariaOpenPrivacyChoices: "Abrir politica de privacidade",
  privacyChoices: "Privacy Policy",
  contactInquiryPresetLoaded: "Pré-preenchimento de consulta carregado para",
  contactSelectedProduct: "produto selecionado",
  contactQuoteHint: "Para acelerar a cotação, inclua SKU alvo, volume anual estimado, mercado de destino e estilo de embalagem preferido.",
  inquiryProductDefault: "Consulta geral",
  navSubmenuSuffix: "submenu",
  homeSupplyImageAlt: "Suporte de coordenação da cadeia de suprimentos",
  homeCertImageAlt: "Visão geral de certificações e conformidade",
  breadcrumbProductDetail: "Detalhe do produto",
  breadcrumbHomeSeries: "Série de Marca Própria",
  breadcrumbHome: "Início",
  nav: "nav",
  buyerWholesalers: "Atacadistas",
  buyerWholesalersNote: "Suporte a sortimento em volume e reposição.",
  buyerRetailers: "Varejistas",
  buyerRetailersNote: "Programas prontos para prateleira e suporte de embalagem.",
  buyerFitnessBrands: "Marcas fitness",
  buyerFitnessBrandsNote: "Suporte de marca própria para expansão de linha.",
  buyerYogaStudios: "Estúdios de yoga",
  buyerYogaStudiosNote: "Kits para estúdio e reposição de acessórios.",
  buyerAmazonSellers: "Vendedores Amazon",
  buyerAmazonSellersNote: "Produtos prontos para marketplace com MOQ flexível.",
  buyerEcom: "Empresas de e-commerce",
  buyerEcomNote: "Sortimentos focados em vendas online recorrentes.",
  featureSourcingTitle: "Sourcing de produtos",
  featureSourcingBody: "Compare especificações antes do pedido.",
  featurePrivateLabelTitle: "Marca própria",
  featurePrivateLabelBody: "Suporte para logo, embalagem e bundle.",
  featureFlexibleOrderTitle: "Pedidos flexíveis",
  featureFlexibleOrderBody: "Opções para pedido piloto e recompra.",
  featureExportTitle: "Suporte de exportação",
  featureExportBody: "Documentos e acompanhamento logístico.",
  metricVerified: "Fornecedores verificados",
  metricVerifiedLabel: "Alinhado por categoria",
  metricMoq: "MOQ flexível",
  metricMoqLabel: "Piloto + recompra",
  metricBranding: "Marca própria",
  metricBrandingLabel: "Marca + embalagem",
  metricDocs: "Pronto para exportar",
  metricDocsLabel: "Docs UE/EUA",
  whyVerifiedTitle: "Rede de fornecedores verificados",
  whyVerifiedBody: "Fornecedores alinhados por categoria, qualidade e mercado-alvo.",
  whyMoqTitle: "Suporte de MOQ flexível",
  whyMoqBody: "Quantidades práticas para teste e crescimento por etapas.",
  whyOemTitle: "Assistência OEM e Marca Própria",
  whyOemBody: "Coordenamos logo, embalagem e bundles para seu canal.",
  whySourcingTitle: "Orientação de sourcing e seleção",
  whySourcingBody: "Compare opções por material, especificação e posicionamento.",
  whyDeliveryTitle: "Coordenação estável de entrega",
  whyDeliveryBody: "Acompanhe marcos e cronogramas para reduzir risco de atraso.",
  whyInspectionTitle: "Inspeção de qualidade pré-embarque",
  whyInspectionBody: "Verificamos pontos críticos de qualidade e embalagem antes do envio.",
  proofStatA: "Foco em yoga e fitness leve",
  proofStatB: "Coordenação de marca própria",
  proofStatC: "Suporte a compradores globais",
  qcSupplierTitle: "Revisão de qualificação de fornecedor",
  qcSupplierBody: "Verificamos capacidade e histórico.",
  qcInspectionTitle: "Inspeção pré-embarque",
  qcInspectionBody: "Validamos produto, etiqueta e embalagem.",
  qcComplianceTitle: "Suporte de conformidade",
  qcComplianceBody: "Preparamos documentos do mercado de destino.",
  qcCertTitle: "Coordenação de certificações",
  qcCertBody: "Alinhamos documentos com parceiros.",
  faqQ1: "Vocês são fabricante ou trading?",
  faqA1: "Somos uma trading focada em produtos de yoga e fitness leve. Trabalhamos com parceiros verificados e coordenamos sourcing, personalização e suporte de embarque para compradores.",
  faqQ2: "Vocês apoiam marca própria e pedidos piloto menores?",
  faqA2: "Sim. Em muitos itens podemos organizar detalhes de marca própria e discutir quantidades iniciais flexíveis de acordo com o produto e o escopo do projeto.",
  faqQ3: "Como vocês gerenciam qualidade e conformidade?",
  faqA3: "Confirmamos especificações, revisamos amostras, acompanhamos checkpoints de produção com parceiros e verificamos detalhes de embalagem antes do embarque.",
  blogSeoTitle: "Blog | Insights e guias de compra",
  blogSeoDescription: "Guias praticos de compra e insights de sourcing para compradores de atacado e marca propria.",
  blogHeroDescription: "Guias praticos de sourcing para importadores e compradores de marca propria, de escolha de materiais e amostras ao planejamento de pedidos para lancamento.",
  blogSearchPlaceholder: "Buscar insights de sourcing",
  blogFeaturedTitle: "Artigo em destaque",
  blogLatestTitle: "Artigos recentes",
  blogBrowseTopicTitle: "Navegar por tema",
  blogReadMore: "Ler mais",
  blogShowLess: "Mostrar menos",
  blogDateFallback: "Atualizado recentemente",
  blogEmptyFeatured: "Nenhum artigo em destaque corresponde. Tente outra palavra-chave ou categoria.",
  blogEmptyLatest: "Nenhum artigo corresponde ao filtro atual.",
  blogCtaTitle: "Precisa de suporte de sourcing para sua proxima colecao?",
  blogCtaViewProducts: "Ver produtos",
  blogCtaExploreSolutions: "Explorar solucoes",
  blogCtaRequestQuote: "Solicitar cotacao",
  blogCategoryAll: "Todos",
  blogCategoryBuyingGuide: "Guia de compra",
  blogCategoryCustomization: "Customizacao",
  blogCategorySampleOrder: "Pedido de amostra",
  blogCategorySourcing: "Abastecimento",
  blogCategoryProductTips: "Dicas de produto",
  homeBreadcrumbCurrent: "Pagina atual",
  homeHeroEyebrow: "Suporte global de sourcing",
  homeHeroTitle: "Seu parceiro confiavel para sourcing e customizacao de produtos",
  homeHeroSubtitle: "Apoiamos compradores globais com sourcing de produtos, customizacao, amostras e acompanhamento de pedidos por meio de comunicacao clara e cooperacao pratica.",
  homeQuickAccessEyebrow: "Acesso rapido",
  homeQuickAccessTitle: "Explore topicos centrais de sourcing",
  homeQuickAccessBody: "Use estes links rapidos para navegar por demandas comuns de atacado e customizacao.",
  homeCategoryBrowseMore: "Explorar mais series",
  homeBestSellingEyebrow: "Mais vendidos",
  homeBestSellingTitle: "Produtos de yoga e fitness mais vendidos",
  homeBestSellingBody: "Explore itens populares para canais de atacado, estudios e venda online.",
  homeBestSellingCardKicker: "Popular entre compradores B2B",
  homeSolutionsTitle: "Solucoes para diferentes tipos de compradores",
  homeSolutionsBody: "Use a pagina de solucoes como guia pratica para canais, cenarios de uso e planejamento de produtos.",
  homeSolutionsButton: "Explorar solucoes",
  homeQualitySupportTitle: "Confiado por compradores em mercados globais",
  homeQualitySupportBody: "Representantes do lado comprador de empresas parceiras em mercados-chave compartilham sua experiencia de cooperacao.",
  homeSourcingInsightsEyebrow: "Insights de sourcing",
  homeSourcingInsightsTitle: "Cooperacao pratica para compradores globais de atacado",
  homeScenariosTitle: "Cenarios de aplicacao comuns",
  homeScenariosBody: "O planejamento por cenarios esta conectado a pagina de solucoes para mais detalhes.",
  homeScenariosLink: "Ir para Solucoes",
  homeProcessTitle: "Processo de cooperacao claro",
  homeProcessBody: "Da consulta inicial a coordenacao de embarque, cada etapa segue um fluxo claro de handoff.",
  homeBlogTitle: "Topicos recentes de compras e sourcing",
  homeBlogBody: "Navegue por artigos concisos focados em compras, amostragem e planejamento de customizacao.",
  homeBlogReadMore: "Ler mais",
  homeAboutTitle: "Quem apoiamos e como cooperamos",
  homeAboutBody: "Focamos em cooperacao pratica para importadores, distribuidores, varejistas e vendedores online que precisam de comunicacao consistente em projetos de sourcing e customizacao. O suporte inclui alinhamento de requisitos, coordenacao de amostras, comunicacao de cotacoes e acompanhamento de pedidos. O objetivo e manter cada etapa clara, realista e orientada a execucao para cooperacao internacional de longo prazo.",
  homeAboutLink: "Perfil da empresa",
  homeFaqAria: "Perguntas frequentes",
  homeFaqTitle: "Perguntas frequentes",
  homeFaqBody: "Respostas rapidas antes de enviar sua consulta.",
  homeFaqShowLess: "Mostrar menos FAQ",
  homeFaqViewAll: "Ver todas as FAQ",
  homeFormNamePlaceholder: "Seu nome",
  homeFormEmailPlaceholder: "E-mail corporativo",
  homeFormWhatsappPlaceholder: "WhatsApp",
  homeFormCompanyPlaceholder: "Empresa",
  homeFormProductPlaceholder: "Produto alvo",
  homeFormQuantityPlaceholder: "Quantidade estimada",
  homeFormMessagePlaceholder: "Especificacoes do produto, quantidade, mercado de destino",
  homeFormUploadLabel: "Enviar arquivo de referencia (opcional)",
  homeFormChooseFile: "Escolher arquivo",
  homeFormNoFile: "Nenhum arquivo selecionado",
  homeFormSelectedFilePrefix: "Arquivo selecionado:",
  carouselAriaLabel: "Banners promocionais",
  carouselBannerAltPrefix: "Banner",
  carouselPrevAria: "Slide anterior",
  carouselNextAria: "Proximo slide",
  carouselDotsAria: "Seletores de slide do carrossel",
  footerCtaAria: "Chamada para consulta no rodape",
  footerCtaTitle: "Suporte B2B para sourcing de yoga",
  footerCtaPrimary: "Enviar consulta",
  footerCtaSecondary: "Fale no WhatsApp",
  footerCompanyProfileAria: "Perfil da empresa",
  footerBrandCopy: "Parceiro de integracao da cadeia de suprimentos para compradores internacionais, oferecendo suporte completo desde a selecao rigorosa de produtos e fabricas ate o controle de qualidade e o servico pos-venda completo.",
  footerTrustPointA: "Resposta em ate 24 horas",
  footerTrustPointB: "Projetos OEM e ODM",
  footerTrustPointC: "Entrega B2B mundial",
  footerQuickLinksAria: "Links rapidos",
  footerQuickLinksTitle: "Links rapidos",
  footerPopularCategoriesAria: "Categorias populares",
  footerPopularCategoriesTitle: "Categorias populares",
  footerBuyerSupportTitle: "Suporte ao comprador",
  footerServicePointA: "Coordenacao de MOQ baixo",
  footerServicePointB: "Sourcing de marca propria",
  footerServicePointC: "Suporte de embarque consolidado",
  footerServicePointD: "Acompanhamento de embalagem e conformidade",
  footerContactAria: "Informacoes de contato",
  footerEmailLabel: "E-mail",
  footerWhatsappLabel: "WhatsApp",
  footerPhoneLabel: "Telefone",
  footerServiceLabel: "Atendimento",
  footerCoverageLabel: "Cobertura",
  footerServiceValue: "Seg-Sab, 9:00-18:00 CST",
  footerCoverageValue: "Mercados globais (incluindo Europa, America do Norte, Oriente Medio, Oceania e APAC)",
  footerBottomCopyright: "Sourcing de produtos de yoga e fitness para negocios atacadistas internacionais.",
  homeEyebrowProductCategories: "Categorias de produtos",
  homeEyebrowFeaturedSelection: "Selecao em destaque",
  homeEyebrowSupplyChain: "Vantagens da cadeia de suprimentos",
  homeEyebrowQualityControl: "Controle de qualidade",
  homeEyebrowUseCases: "Casos de uso",
  homeEyebrowWorkflow: "Fluxo de trabalho",
  homeEyebrowBlog: "Blog e insights",
  homeEyebrowAbout: "Sobre",
  homeEyebrowFaq: "FAQ",
  homeAriaIntro: "Visao geral de sourcing B2B de yoga e fitness",
  homeAriaQuickNav: "Navegacao SEO rapida",
  homeAriaCategoryGallery: "Galeria de categorias de produtos",
  homeAriaBestSellingHead: "Produtos mais vendidos",
  homeAriaBestSellingGrid: "Produtos mais vendidos selecionados",
  homeAriaSolutionsNav: "Navegacao de solucoes",
  homeAriaSupplyQuality: "Destaques de suporte de cadeia e qualidade",
  homeAriaSourcingOverview: "Visao geral de sourcing e customizacao",
  homeAriaScenarios: "Cenarios de aplicacao",
  homeAriaProcess: "Processo de cooperacao",
  homeAriaBlog: "Destaques do blog",
  homeAriaAboutSummary: "Resumo sobre",
  homeEmptyBadge: "Inventario pendente",
  homeEmptyTitle: "Ainda nao ha produtos disponiveis",
  homeEmptySuffix: " aparecera aqui quando os itens forem publicados.",
  homeQuickLink1Title: "Sourcing de produtos",
  homeQuickLink1Body: "Suporte flexivel de sourcing para compradores de atacado.",
  homeQuickLink2Title: "Suporte de marca propria",
  homeQuickLink2Body: "Opcoes de branding e embalagem para SKUs prontos para mercado.",
  homeQuickLink3Title: "Cooperacao OEM / ODM",
  homeQuickLink3Body: "Dos requisitos a confirmacao de amostras e producao.",
  homeQuickLink4Title: "Suporte para pedido de amostra",
  homeQuickLink4Body: "Discuta amostras de teste antes de planejar pedidos em volume.",
  homeQuickLink5Title: "Fornecimento atacadista",
  homeQuickLink5Body: "Adequado para distribuidores, varejistas e vendedores online.",
  homeQuickLink6Title: "Guia de solucoes",
  homeQuickLink6Body: "Encontre rotas praticas por tipo de comprador e caso de uso.",
  homeScenario1Title: "Preparacao para canal de varejo",
  homeScenario1Body: "Monte um sortimento pratico para distribuicao pronta para prateleira e atacado.",
  homeScenario2Title: "Programa de produtos para marketplace",
  homeScenario2Body: "Coordene combinacoes de produtos e detalhes de embalagem para canais online.",
  homeScenario3Title: "Fornecimento para estudios e academias",
  homeScenario3Body: "Prepare conjuntos duraveis para uso em aula e revenda para membros.",
  homeProcessStep1: "Consulta",
  homeProcessStep2: "Revisao de requisitos",
  homeProcessStep3: "Discussao de amostras",
  homeProcessStep4: "Cotacao",
  homeProcessStep5: "Confirmacao do pedido",
  homeProcessStep6: "Acompanhamento da producao",
  homeProcessStep7: "Coordenacao de embarque",
  homeBlogHighlight1Title: "Como preparar uma consulta eficiente de sourcing de produtos",
  homeBlogHighlight1Body: "Checklist pratico de detalhes de produto, quantidade e destino antes de solicitar cotacao.",
  homeBlogHighlight2Title: "Planejamento de marca propria: pontos-chave antes da fase de amostra",
  homeBlogHighlight2Body: "Metodo de logo, detalhes de embalagem e alinhamento de prazo para reduzir retrabalho.",
  homeBlogHighlight3Title: "Pedidos piloto no atacado: uma forma segura de iniciar cooperacao",
  homeBlogHighlight3Body: "Como avaliar qualidade do produto e fluxo de comunicacao antes de pedidos maiores.",
  homeFallbackFaq1Question: "Quais informacoes sao necessarias para uma cotacao?",
  homeFallbackFaq1Answer: "Compartilhe nome ou imagem do produto, quantidade estimada, mercado de destino e requisitos de embalagem para resposta mais eficiente.",
  homeFallbackFaq2Question: "Voce apoia solicitacoes de marca propria?",
  homeFallbackFaq2Answer: "Sim. O suporte de marca propria pode incluir discussao do metodo de logo, detalhes de embalagem e alinhamento de producao conforme seus requisitos.",
  homeFallbackFaq3Question: "Vocês oferecem suporte de amostras antes de pedidos em volume?",
  homeFallbackFaq3Answer: "A discussao de amostras esta disponivel para validar especificacoes e expectativas de comunicacao antes de planejar producao maior.",
  homeFallbackFaq4Question: "E possivel discutir pedidos de teste pequenos?",
  homeFallbackFaq4Answer: "Quantidades de teste podem ser discutidas conforme tipo de produto, necessidades de embalagem e arranjo de producao.",
  homeFallbackFaq5Question: "Como voces tratam a comunicacao de customizacao?",
  homeFallbackFaq5Answer: "Normalmente alinhamos requisitos por escrito, confirmamos detalhes da amostra e mantemos atualizacoes por marcos durante a execucao.",
  homeFallbackFaq6Question: "Qual e o processo de cooperacao habitual?",
  homeFallbackFaq6Answer: "O fluxo habitual e consulta, revisao de requisitos, confirmacao de amostra, cotacao, confirmacao do pedido e acompanhamento de embarque.",
  homeFallbackFaq7Question: "Voce pode apoiar coordenacao de documentos de exportacao?",
  homeFallbackFaq7Answer: "A coordenacao de documentos de exportacao pode ser discutida conforme destino e requisitos de embarque.",
  homeFallbackFaq8Question: "Em quanto tempo posso esperar uma resposta inicial?",
  homeFallbackFaq8Answer: "A velocidade da resposta inicial depende da complexidade da solicitacao; informacoes de produto mais detalhadas costumam reduzir o prazo.",
  marketNorthAmerica: "América do Norte",
  marketNorthAmericaNote: "Importadores · Marcas online · Venda em estúdios",
  marketEurope: "Europa",
  marketEuropeNote: "Distribuidores · Redes de bem-estar · Compradores de marca própria",
  marketAsiaPacific: "Asia-Pacífico",
  marketAsiaPacificNote: "Estúdios de yoga · Vendedores de e-commerce · Lojas de fitness",
  marketMiddleEast: "Oriente Médio",
  marketMiddleEastNote: "Marcas boutique · Bem-estar corporativo · Compradores de kit presente",
  homeCtaEyebrow: "PARA IMPORTADORES • DISTRIBUIDORES • ESTÚDIOS • MARCAS ONLINE",
  homeCtaTitle: "Solicite um plano de produtos para o seu mercado-alvo.",
  homeCtaDescription: "Informe seu país, canal de vendas, categoria de produto, MOQ alvo e estilo de marca. Organizaremos opções de produtos e rotas de personalização adequadas.",
  homeCtaPrimary: "Enviar consulta",
  homeCtaSecondary: "Explorar categorias",
  homeRequestCatalog: "Solicitar catálogo completo",
  homeSeoKeywordBody: "Como parceiro de sourcing na China para compradores globais, focamos em cooperacao pratica em torno de sourcing de produtos, customizacao e suporte de marca propria. A homepage ajuda equipes de compras a entender rapidamente como avancar da consulta ao embarque com comunicacao clara. Para compradores que avaliam suporte OEM/ODM, suporte de amostras e fornecimento atacadista, um processo estruturado reduz incertezas e melhora a execucao. Em vez de adicionar complexidade desnecessaria, o modelo enfatiza clareza de requisitos, alinhamento de amostras e acompanhamento consistente de pedidos. Seja iniciando com um pedido piloto pequeno ou com um cronograma maior de compras, o foco permanece o mesmo: comunicacao estavel, alinhamento realista de prazo e suporte acionavel para requisitos de produto e embalagem em mercados internacionais.",
  buyerReviewsAria: "Avaliações de compradores reais",
  buyerReviewsTitle: "Avaliações reais de compradores",
  reviewName1: "Sarah Mitchell",
  reviewRole1: "Líder sênior de sourcing, Core Active LLC",
  reviewCountry1: "Estados Unidos",
  reviewText1: "A equipe manteve cada etapa transparente e orientada ao serviço. Sentimo-nos apoiados desde a primeira revisão de amostras até a entrega final.",
  reviewName2: "Omar Al-Hassan",
  reviewRole2: "Gerente de operações de importação, Gulf Horizon Trading",
  reviewCountry2: "Arábia Saudita",
  reviewText2: "Sua equipe fornece atualizações claras e um serviço muito bom. Sentimo-nos confortáveis em cada etapa, e o prazo de envio foi cumprido conforme planejado.",
  reviewName3: "Sophie Laurent",
  reviewRole3: "Responsável de compras, Maison Fit France",
  reviewCountry3: "França",
  reviewText3: "A qualidade de coordenação foi excelente. A equipe acompanhou proativamente os detalhes e nos deu confiança para repetir pedidos no mercado europeu.",
  reviewName4: "James Carter",
  reviewRole4: "Diretor de compras, Northline Wellness UK",
  reviewCountry4: "Reino Unido",
  reviewText4: "A cooperação foi confiável e acolhedora. Os marcos foram claros, os problemas resolvidos rapidamente e a qualidade de entrega atendeu aos padrões acordados.",
  reviewStarsUnit: "estrelas",
  homeShowcaseAria: "Exposição de produtos em feira comercial",
  homeShowcaseAlt1: "Visão geral do estande de produtos de yoga na feira",
  homeShowcaseAlt2: "Parede de exposição de tapetes de yoga no estande",
  homeShowcaseAlt3: "Expositor de acessórios de yoga no estande da feira",
  homeSeoFallbackTitle: "Sourcing e Personalização de Produtos | LOYA SPORT",
  homeSeoFallbackDescription: "Sourcing profissional de produtos, personalização, suporte de marca própria e acompanhamento de pedidos para compradores atacadistas globais.",
  footerLocationValue: "Changsha, China",
  footerNewsletterTitle: "Atualizações do catálogo",
  footerNewsletterDesc: "Deixe seu e-mail para receber novas ideias de produtos de yoga e opções de personalização.",
  footerNewsletterPlaceholder: "Seu endereço de e-mail",
};

STOREFRONT_TEXTS.fr = {
  ...EN_TEXTS,
  title: "LOYA SPORT",
  subtitle: "Partenaire sourcing yoga et fitness léger pour acheteurs grossistes internationaux",
  loading: "Chargement des produits...",
  error: "Échec du chargement des produits. Vérifiez l'état du service.",
  language: "Langue",
  currency: "Devise",
  requestQuote: "Demander un devis",
  sendMessage: "Envoyer la demande",
  heroTag: "Sourcing B2B international",
  heroTitle: "Produits premium de yoga et fitness léger pour acheteurs B2B",
  heroBody: "Nous accompagnons les acheteurs grossistes en sourcing produit, coordination marque blanche et exécution export.",
  heroBulletA: "Gamme de produits sélectionnée",
  heroBulletB: "Support marque blanche",
  heroBulletC: "Partenaires supply vérifiés",
  heroBulletD: "Expérience marchés UE et États-Unis",
  heroBulletE: "Réponse devis rapide",
  heroCardTitle: "Comment nous soutenons votre sourcing",
  heroCardBody: "Partagez vos produits cibles, exigences de marque et plan de quantité. Nous comparons les options, organisons les échantillons et coordonnons les délais.",
  categoryTitle: "Explorez nos catégories",
  categoryBody: "Explorez des collections yoga et fitness à forte demande pour les canaux grossistes.",
  featuredTitle: "Sélection de produits vedettes",
  featuredBody: "Consultez les articles clés et demandez des devis selon quantité et plan de marque.",
  factoryTitle: "Atouts de la chaîne d'approvisionnement",
  factoryBody: "Matching fournisseur clair, MOQ et préparation export.",
  storyTitle: "Une coordination supply chain fiable",
  storyBody: "Validez rapidement les spécifications et gardez les livraisons sur la bonne voie.",
  storyBodyExtra: "Du matching fournisseurs aux jalons d'échantillons et d'expédition, nous rendons l'avancement visible pour garder votre plan d'achat sous contrôle.",
  serviceTitle: "Processus qualité et conformité",
  proofEyebrow: "À propos",
  proofTitle: "Partenaire B2B de sourcing Yoga & Fitness Léger",
  proofBody: "Nous accompagnons le sourcing yoga et fitness léger pour les canaux grossiste, retail et e-commerce mondiaux.",
  proofBodyExtra: "",
  proofCta: "Contacter notre équipe B2B",
  inquiryCtaEyebrow: "Demander un devis",
  inquiryCtaTitle: "Prêt à sourcer votre prochaine gamme yoga?",
  inquiryCtaBody: "Partagez vos produits cibles et volumes. Nous répondrons avec un devis sur mesure.",
  inquiryQuickA: "Objectif de réponse: sous 8 heures ouvrées",
  inquiryQuickB: "Marchés servis: canaux grossistes UE et États-Unis",
  inquiryTitle: "Demander un devis",
  inquiryHint: "Indiquez le produit, la quantité, le branding et le marché cible.",
  inquirySuccess: "Merci. Votre demande a été reçue et notre équipe B2B vous répondra rapidement.",
  inquiryError: "Veuillez renseigner nom, e-mail et détails de la demande.",
  inquirySubmitting: "Envoi en cours...",
  inquirySubmitFailed: "Envoi impossible. Veuillez réessayer dans un instant.",
  chooseLanguageTitle: "Qui nous servons",
  chooseLanguageBody: "Conçu pour les principaux canaux B2B.",
  trustA: "Partenaires supply chain vérifiés",
  trustB: "Support OEM et packaging flexible",
  trustC: "Gestion fiable des délais",
  trustD: "Inspection pré-expédition stricte",
  viewMore: "En savoir plus",
  viewAll: "Voir les produits",
  talkToUs: "Parler à notre équipe",
  contactUs: "Nous contacter",
  certifications: "Qualité et conformité",
  headerVerified: "Fournisseurs vérifiés",
  headerPrivateLabel: "Marque blanche",
  headerGlobalShipping: "Expédition mondiale",
  ariaBackToHomepage: "Retour à l'accueil",
  ariaToggleNavigationMenu: "Basculer le menu de navigation",
  ariaPrimaryNavigation: "Navigation principale",
  ariaSearchProductByName: "Rechercher un produit par nom",
  ariaSearch: "recherche",
  sortLabel: "Trier",
  sortDefault: "Par défaut",
  ariaSortProducts: "Trier les produits",
  contactModelPrefix: "Modèle",
  ariaSwitchStorefrontLanguage: "Changer la langue de la vitrine",
  ariaAccountCenter: "Espace compte",
  ariaLogin: "Connexion",
  globalContactTagline: "Support de sourcing yoga et fitness pour acheteurs grossistes internationaux",
  accountCenter: "Espace compte",
  productsCategoryTitle: "Catégories de produits",
  productsAll: "Tous les produits",
  productsOthers: "Autres",
  productsCategoryNavigationAria: "Navigation des catégories de produits",
  productsContactNow: "Contacter",
  productsEmpty: "Aucun produit trouvé dans cette catégorie.",
  productsPaginationAria: "Pagination des produits",
  productsPrev: "Préc.",
  productsNext: "Suiv.",
  productsPage: "Page",
  bookmarkHint: "Appuyez sur Ctrl+D (ou Cmd+D sur Mac) pour ajouter ce site aux favoris.",
  ariaBreadcrumbNavigation: "Navigation fil d'Ariane",
  ariaPrivacyPreference: "Préférence de confidentialité",
  privacyTitle: "Vos choix de confidentialité",
  privacyBody: "Nous utilisons des technologies essentielles pour la vitrine et des options sûres facultatives pour améliorer recherche et recommandations.",
  privacyOptionEnhanced: "Je comprends: active des améliorations facultatives comme l'historique de recherche et les recommandations personnalisées.",
  privacyOptionBasic: "Ne pas vendre ni partager mes données personnelles: n'active que les fonctions essentielles.",
  privacyAccept: "Je comprends",
  privacyReject: "Ne pas vendre ni partager mes données personnelles",
  ariaOpenPrivacyChoices: "Ouvrir la politique de confidentialite",
  privacyChoices: "Privacy Policy",
  contactInquiryPresetLoaded: "Préremplissage de demande chargé pour",
  contactSelectedProduct: "produit sélectionné",
  contactQuoteHint: "Pour accélérer le devis, indiquez SKU cible, volume annuel estimé, marché destination et style d'emballage préféré.",
  inquiryProductDefault: "Demande générale",
  navSubmenuSuffix: "sous-menu",
  homeSupplyImageAlt: "Support de coordination de la chaîne d'approvisionnement",
  homeCertImageAlt: "Aperçu des certifications et de la conformité",
  breadcrumbProductDetail: "Détail produit",
  breadcrumbHomeSeries: "Série Marque Blanche",
  breadcrumbHome: "Accueil",
  nav: "nav",
  buyerWholesalers: "Grossistes",
  buyerWholesalersNote: "Support assortiments en volume et réassort.",
  buyerRetailers: "Détaillants",
  buyerRetailersNote: "Programmes prêts rayon et support packaging.",
  buyerFitnessBrands: "Marques fitness",
  buyerFitnessBrandsNote: "Support marque blanche pour extension de gamme.",
  buyerYogaStudios: "Studios de yoga",
  buyerYogaStudiosNote: "Packs studio et réassort accessoires.",
  buyerAmazonSellers: "Vendeurs Amazon",
  buyerAmazonSellersNote: "Produits prêts marketplace avec MOQ flexible.",
  buyerEcom: "Entreprises e-commerce",
  buyerEcomNote: "Assortiments orientés ventes en ligne récurrentes.",
  featureSourcingTitle: "Sourcing produit",
  featureSourcingBody: "Comparez les spécifications avant commande.",
  featurePrivateLabelTitle: "Marque blanche",
  featurePrivateLabelBody: "Support logo, packaging et bundle.",
  featureFlexibleOrderTitle: "Commandes flexibles",
  featureFlexibleOrderBody: "Options test et réassort.",
  featureExportTitle: "Support export",
  featureExportBody: "Documents et suivi expédition.",
  metricVerified: "Fournisseurs vérifiés",
  metricVerifiedLabel: "Aligné par catégorie",
  metricMoq: "MOQ flexible",
  metricMoqLabel: "Test + réassort",
  metricBranding: "Marque blanche",
  metricBrandingLabel: "Marque + packaging",
  metricDocs: "Prêt export",
  metricDocsLabel: "Docs UE/US",
  whyVerifiedTitle: "Réseau fournisseurs vérifiés",
  whyVerifiedBody: "Fournisseurs alignés par catégorie, qualité et marché cible.",
  whyMoqTitle: "Support MOQ flexible",
  whyMoqBody: "Quantités pratiques pour test et croissance progressive.",
  whyOemTitle: "Assistance OEM & Marque Blanche",
  whyOemBody: "Coordination logo, packaging et bundles selon votre canal.",
  whySourcingTitle: "Guidance sourcing et sélection",
  whySourcingBody: "Comparez les options selon matière, spécification et positionnement.",
  whyDeliveryTitle: "Coordination livraison stable",
  whyDeliveryBody: "Suivi des jalons et délais pour réduire le risque de retard.",
  whyInspectionTitle: "Inspection qualité pré-expédition",
  whyInspectionBody: "Vérification qualité et packaging avant expédition.",
  proofStatA: "Focus yoga et fitness léger",
  proofStatB: "Coordination marque blanche",
  proofStatC: "Support acheteurs UE et États-Unis",
  qcSupplierTitle: "Revue qualification fournisseur",
  qcSupplierBody: "Vérification capacité et historique.",
  qcInspectionTitle: "Inspection pré-expédition",
  qcInspectionBody: "Vérification produit, étiquette et emballage.",
  qcComplianceTitle: "Support conformité produit",
  qcComplianceBody: "Préparation des documents du marché cible.",
  qcCertTitle: "Coordination certification",
  qcCertBody: "Alignement des fichiers avec les partenaires.",
  faqQ1: "Êtes-vous fabricant ou société de négoce?",
  faqA1: "Nous sommes une société de négoce spécialisée yoga et fitness léger. Nous travaillons avec des partenaires vérifiés et coordonnons sourcing, personnalisation et expédition pour les acheteurs.",
  faqQ2: "Pouvez-vous gérer la marque blanche et les petites commandes test?",
  faqA2: "Oui. Pour de nombreux articles, nous pouvons organiser les détails de marque blanche et discuter de quantités de départ flexibles selon le produit et le périmètre projet.",
  faqQ3: "Comment gérez-vous qualité et conformité?",
  faqA3: "Nous validons les spécifications, revoyons les échantillons, suivons les étapes de production avec les partenaires et vérifions les détails packaging avant expédition.",
  blogSeoTitle: "Blog | Insights et guides d'achat",
  blogSeoDescription: "Guides d'achat pratiques et insights de sourcing pour acheteurs grossistes et private label.",
  blogHeroDescription: "Playbooks de sourcing pratiques pour importateurs et acheteurs private label, du choix des materiaux et tests echantillons jusqu'a la planification des commandes de lancement.",
  blogSearchPlaceholder: "Rechercher des insights de sourcing",
  blogFeaturedTitle: "Article a la une",
  blogLatestTitle: "Derniers articles",
  blogBrowseTopicTitle: "Parcourir par theme",
  blogReadMore: "Lire la suite",
  blogShowLess: "Afficher moins",
  blogDateFallback: "Mis a jour recemment",
  blogEmptyFeatured: "Aucun article vedette ne correspond. Essayez un autre mot-cle ou une autre categorie.",
  blogEmptyLatest: "Aucun article ne correspond au filtre actuel.",
  blogCtaTitle: "Besoin d'un support sourcing pour votre prochaine collection?",
  blogCtaViewProducts: "Voir les produits",
  blogCtaExploreSolutions: "Explorer les solutions",
  blogCtaRequestQuote: "Demander un devis",
  blogCategoryAll: "Tous",
  blogCategoryBuyingGuide: "Guide d'achat",
  blogCategoryCustomization: "Personnalisation",
  blogCategorySampleOrder: "Commande d'echantillon",
  blogCategorySourcing: "Approvisionnement",
  blogCategoryProductTips: "Conseils produit",
  homeBreadcrumbCurrent: "Page actuelle",
  homeHeroEyebrow: "Support sourcing global",
  homeHeroTitle: "Votre partenaire fiable pour le sourcing et la personnalisation produit",
  homeHeroSubtitle: "Nous accompagnons les acheteurs globaux avec sourcing, personnalisation, echantillonnage et suivi de commande via une communication claire et une cooperation pratique.",
  homeQuickAccessEyebrow: "Acces rapide",
  homeQuickAccessTitle: "Explorer les sujets sourcing essentiels",
  homeQuickAccessBody: "Utilisez ces liens rapides pour naviguer dans les demandes courantes de grossiste et personnalisation.",
  homeCategoryBrowseMore: "Voir plus de series",
  homeBestSellingEyebrow: "Meilleures ventes",
  homeBestSellingTitle: "Produits yoga et fitness les plus vendus",
  homeBestSellingBody: "Explorez les articles populaires pour grossiste, studio et canaux en ligne.",
  homeBestSellingCardKicker: "Populaire chez les acheteurs B2B",
  homeSolutionsTitle: "Solutions pour differents profils d'acheteurs",
  homeSolutionsBody: "Utilisez la page solutions comme guide pratique pour canaux, cas d'usage et planification produit.",
  homeSolutionsButton: "Explorer les solutions",
  homeQualitySupportTitle: "La confiance d'acheteurs sur les marches mondiaux",
  homeQualitySupportBody: "Des representants cote acheteur d'entreprises partenaires sur des marches cles partagent leur experience de collaboration.",
  homeSourcingInsightsEyebrow: "Insights sourcing",
  homeSourcingInsightsTitle: "Cooperation pratique pour acheteurs grossistes internationaux",
  homeScenariosTitle: "Scenarios d'application courants",
  homeScenariosBody: "La planification par scenario est reliee a la page solutions pour plus de details.",
  homeScenariosLink: "Aller aux solutions",
  homeProcessTitle: "Processus de cooperation clair",
  homeProcessBody: "De la demande initiale a la coordination d'expedition, chaque etape suit un passage de relais clair.",
  homeBlogTitle: "Derniers sujets achats et sourcing",
  homeBlogBody: "Parcourez des articles concis axes sur achats, echantillons et planification de personnalisation.",
  homeBlogReadMore: "Lire la suite",
  homeAboutTitle: "Qui nous accompagnons et comment nous cooperons",
  homeAboutBody: "Nous privilegions une cooperation pratique avec importateurs, distributeurs, detaillants et vendeurs e-commerce qui ont besoin d'une communication stable sur les projets de sourcing et personnalisation. Le support couvre alignement des besoins, coordination echantillons, echanges devis et suivi de commande. L'objectif est de garder chaque etape claire, realiste et orientee execution pour une cooperation internationale durable.",
  homeAboutLink: "Profil entreprise",
  homeFaqAria: "Questions frequentes",
  homeFaqTitle: "Questions frequentes",
  homeFaqBody: "Reponses rapides avant d'envoyer votre demande.",
  homeFaqShowLess: "Afficher moins de FAQ",
  homeFaqViewAll: "Voir toutes les FAQ",
  homeFormNamePlaceholder: "Votre nom",
  homeFormEmailPlaceholder: "E-mail professionnel",
  homeFormWhatsappPlaceholder: "WhatsApp",
  homeFormCompanyPlaceholder: "Entreprise",
  homeFormProductPlaceholder: "Produit cible",
  homeFormQuantityPlaceholder: "Quantite estimee",
  homeFormMessagePlaceholder: "Specs produit, quantite, marche de destination",
  homeFormUploadLabel: "Importer un fichier de reference (optionnel)",
  homeFormChooseFile: "Choisir un fichier",
  homeFormNoFile: "Aucun fichier selectionne",
  homeFormSelectedFilePrefix: "Fichier selectionne:",
  carouselAriaLabel: "Bannieres promotionnelles",
  carouselBannerAltPrefix: "Banniere",
  carouselPrevAria: "Diapositive precedente",
  carouselNextAria: "Diapositive suivante",
  carouselDotsAria: "Selecteurs de diapositives du carrousel",
  footerCtaAria: "Appel a l'action de demande en pied de page",
  footerCtaTitle: "Support sourcing yoga B2B",
  footerCtaPrimary: "Envoyer une demande",
  footerCtaSecondary: "Nous contacter sur WhatsApp",
  footerCompanyProfileAria: "Profil entreprise",
  footerBrandCopy: "Partenaire d'integration de la chaine d'approvisionnement pour les acheteurs internationaux, avec un accompagnement complet allant de la selection rigoureuse des produits et des usines au controle qualite et a un service apres-vente complet.",
  footerTrustPointA: "Reponse sous 24 heures",
  footerTrustPointB: "Projets OEM et ODM",
  footerTrustPointC: "Livraison B2B mondiale",
  footerQuickLinksAria: "Liens rapides",
  footerQuickLinksTitle: "Liens rapides",
  footerPopularCategoriesAria: "Categories populaires",
  footerPopularCategoriesTitle: "Categories populaires",
  footerBuyerSupportTitle: "Support acheteur",
  footerServicePointA: "Coordination MOQ bas",
  footerServicePointB: "Sourcing private label",
  footerServicePointC: "Support d'expedition consolidee",
  footerServicePointD: "Suivi packaging et conformite",
  footerContactAria: "Informations de contact",
  footerEmailLabel: "E-mail",
  footerWhatsappLabel: "WhatsApp",
  footerPhoneLabel: "Téléphone",
  footerServiceLabel: "Service client",
  footerCoverageLabel: "Couverture",
  footerServiceValue: "Lun-Sam, 9:00-18:00 CST",
  footerCoverageValue: "Marches mondiaux (incluant Europe, Amerique du Nord, Moyen-Orient, Oceanie et APAC)",
  footerBottomCopyright: "Sourcing de produits yoga et fitness pour activites de gros internationales.",
  homeEyebrowProductCategories: "Categories de produits",
  homeEyebrowFeaturedSelection: "Selection vedette",
  homeEyebrowSupplyChain: "Atouts de la supply chain",
  homeEyebrowQualityControl: "Controle qualite",
  homeEyebrowUseCases: "Cas d'usage",
  homeEyebrowWorkflow: "Processus",
  homeEyebrowBlog: "Blog et insights",
  homeEyebrowAbout: "A propos",
  homeEyebrowFaq: "FAQ",
  homeAriaIntro: "Vue d'ensemble sourcing B2B yoga et fitness",
  homeAriaQuickNav: "Navigation SEO rapide",
  homeAriaCategoryGallery: "Galerie de categories produits",
  homeAriaBestSellingHead: "Produits les plus vendus",
  homeAriaBestSellingGrid: "Selection des meilleures ventes",
  homeAriaSolutionsNav: "Navigation solutions",
  homeAriaSupplyQuality: "Points forts support supply et qualite",
  homeAriaSourcingOverview: "Vue d'ensemble sourcing et personnalisation",
  homeAriaScenarios: "Scenarios d'application",
  homeAriaProcess: "Processus de cooperation",
  homeAriaBlog: "Points forts du blog",
  homeAriaAboutSummary: "Resume a propos",
  homeEmptyBadge: "Inventaire en attente",
  homeEmptyTitle: "Aucun produit disponible pour le moment",
  homeEmptySuffix: " apparaitra ici une fois publie.",
  homeQuickLink1Title: "Sourcing produit",
  homeQuickLink1Body: "Support sourcing flexible pour acheteurs grossistes.",
  homeQuickLink2Title: "Support private label",
  homeQuickLink2Body: "Options branding et packaging pour des SKU prets au marche.",
  homeQuickLink3Title: "Cooperation OEM / ODM",
  homeQuickLink3Body: "Des besoins jusqu'a la validation echantillon et la production.",
  homeQuickLink4Title: "Support commande echantillon",
  homeQuickLink4Body: "Discutez des essais echantillons avant planification de commande en volume.",
  homeQuickLink5Title: "Approvisionnement grossiste",
  homeQuickLink5Body: "Adapte aux distributeurs, detaillants et vendeurs en ligne.",
  homeQuickLink6Title: "Guide solutions",
  homeQuickLink6Body: "Trouvez des trajectoires pratiques par type d'acheteur et scenario.",
  homeScenario1Title: "Preparation canal retail",
  homeScenario1Body: "Construisez un assortiment pratique pour distribution pret rayon et grossiste.",
  homeScenario2Title: "Programme produit marketplace",
  homeScenario2Body: "Coordonnez combinaisons produits et details packaging pour canaux en ligne.",
  homeScenario3Title: "Approvisionnement studios et salles",
  homeScenario3Body: "Preparez des ensembles durables pour usage en cours et revente aux membres.",
  homeProcessStep1: "Demande",
  homeProcessStep2: "Revue des besoins",
  homeProcessStep3: "Discussion echantillons",
  homeProcessStep4: "Devis",
  homeProcessStep5: "Confirmation de commande",
  homeProcessStep6: "Suivi production",
  homeProcessStep7: "Coordination expedition",
  homeBlogHighlight1Title: "Comment preparer une demande sourcing plus efficace",
  homeBlogHighlight1Body: "Checklist pratique des details produit, quantite et destination avant demande de devis.",
  homeBlogHighlight2Title: "Planification private label: points cles avant la phase echantillon",
  homeBlogHighlight2Body: "Methode logo, details packaging et alignement planning pour reduire les retouches.",
  homeBlogHighlight3Title: "Commandes test grossiste: une facon sure de demarrer la cooperation",
  homeBlogHighlight3Body: "Comment evaluer qualite produit et fluidite de communication avant des commandes plus importantes.",
  homeFallbackFaq1Question: "Quelles informations faut-il pour un devis?",
  homeFallbackFaq1Answer: "Partagez le nom ou une image produit, la quantite estimee, le marche de destination et les exigences packaging pour une reponse efficace.",
  homeFallbackFaq2Question: "Pouvez-vous accompagner des demandes private label?",
  homeFallbackFaq2Answer: "Oui. Le support private label peut inclure discussion methode logo, details packaging et alignement production selon vos besoins.",
  homeFallbackFaq3Question: "Proposez-vous un support echantillon avant commande en volume?",
  homeFallbackFaq3Answer: "La discussion echantillons est disponible pour valider specs produit et attentes de communication avant planification de production plus large.",
  homeFallbackFaq4Question: "Peut-on discuter de petites commandes test?",
  homeFallbackFaq4Answer: "Les quantites test peuvent etre discutees selon type produit, besoins packaging et organisation production.",
  homeFallbackFaq5Question: "Comment gerer la communication de personnalisation?",
  homeFallbackFaq5Answer: "Nous alignons generalement les besoins par ecrit, validons les details echantillon et partageons des mises a jour par jalons pendant l'execution.",
  homeFallbackFaq6Question: "Quel est le processus de cooperation habituel?",
  homeFallbackFaq6Answer: "Le flux habituel est demande, revue des besoins, validation echantillon, devis, confirmation de commande et suivi expedition.",
  homeFallbackFaq7Question: "Pouvez-vous accompagner la coordination des documents d'export?",
  homeFallbackFaq7Answer: "La coordination des documents d'export peut etre discutee selon destination et exigences d'expedition.",
  homeFallbackFaq8Question: "Sous quel delai puis-je attendre une premiere reponse?",
  homeFallbackFaq8Answer: "La vitesse de reponse initiale depend de la complexite de la demande; des informations produit plus detaillees reduisent souvent le delai.",
  marketNorthAmerica: "Amérique du Nord",
  marketNorthAmericaNote: "Importateurs · Marques en ligne · Vente en studios",
  marketEurope: "Europe",
  marketEuropeNote: "Distributeurs · Réseaux bien-être · Acheteurs private label",
  marketAsiaPacific: "Asie-Pacifique",
  marketAsiaPacificNote: "Studios de yoga · Vendeurs e-commerce · Détaillants fitness",
  marketMiddleEast: "Moyen-Orient",
  marketMiddleEastNote: "Marques boutique · Bien-être entreprise · Acheteurs coffrets cadeaux",
  homeCtaEyebrow: "POUR IMPORTATEURS • DISTRIBUTEURS • STUDIOS • MARQUES EN LIGNE",
  homeCtaTitle: "Demandez un plan produit pour votre marché cible.",
  homeCtaDescription: "Indiquez votre pays, canal de vente, catégorie produit, MOQ cible et style de marque. Nous organiserons des options produit et des axes de personnalisation adaptés.",
  homeCtaPrimary: "Envoyer une demande",
  homeCtaSecondary: "Parcourir les catégories",
  homeRequestCatalog: "Demander le catalogue complet",
  homeSeoKeywordBody: "En tant que partenaire sourcing en Chine pour des acheteurs internationaux, nous privilegions une cooperation pratique autour du sourcing produit, de la personnalisation et du support private label. La page d'accueil aide les equipes achats a comprendre rapidement comment avancer de la demande a l'expedition avec une communication claire. Pour les acheteurs qui evaluent un support OEM/ODM, support echantillons et approvisionnement grossiste, un processus structure reduit l'incertitude et ameliore l'execution. Plutot que d'ajouter de la complexite inutile, le modele met l'accent sur clarte des besoins, alignement echantillons et suivi de commande constant. Que le plan commence par un petit test ou un calendrier d'achats plus large, l'objectif reste le meme: communication stable, alignement realiste des delais et support actionnable pour les exigences produit et packaging sur les marches internationaux.",
  buyerReviewsAria: "Avis réels de clients",
  buyerReviewsTitle: "Avis réels d'acheteurs",
  reviewName1: "Sarah Mitchell",
  reviewRole1: "Responsable sourcing senior, Core Active LLC",
  reviewCountry1: "États-Unis",
  reviewText1: "Leur équipe a maintenu chaque étape transparente et orientée service. Nous nous sommes sentis soutenus de la première révision des échantillons à la livraison finale.",
  reviewName2: "Omar Al-Hassan",
  reviewRole2: "Responsable des opérations d'import, Gulf Horizon Trading",
  reviewCountry2: "Arabie Saoudite",
  reviewText2: "Votre équipe donne des mises à jour claires et un très bon service. Nous nous sentons à l'aise à chaque étape, et le délai d'expédition a correspondu à notre plan.",
  reviewName3: "Sophie Laurent",
  reviewRole3: "Responsable achats, Maison Fit France",
  reviewCountry3: "France",
  reviewText3: "La qualité de coordination était excellente. L'équipe a suivi proactivement les détails et nous a donné confiance pour des commandes répétées sur le marché européen.",
  reviewName4: "James Carter",
  reviewRole4: "Directeur des achats, Northline Wellness UK",
  reviewCountry4: "Royaume-Uni",
  reviewText4: "La coopération s'est avérée fiable et chaleureuse. Les jalons étaient clairs, les problèmes résolus rapidement, et la qualité de livraison correspondait aux normes convenues.",
  reviewStarsUnit: "étoiles",
  homeShowcaseAria: "Vitrine de produits au salon professionnel",
  homeShowcaseAlt1: "Vue générale du stand de produits yoga à la foire",
  homeShowcaseAlt2: "Mur d'exposition de tapis de yoga au stand",
  homeShowcaseAlt3: "Présentoir d'accessoires de yoga au stand du salon",
  homeSeoFallbackTitle: "Sourcing et personnalisation de produits | LOYA SPORT",
  homeSeoFallbackDescription: "Sourcing professionnel, personnalisation, support marque propre et suivi des commandes pour acheteurs grossistes internationaux.",
  footerLocationValue: "Changsha, Chine",
  footerNewsletterTitle: "Mises à jour du catalogue",
  footerNewsletterDesc: "Laissez votre e-mail pour recevoir de nouvelles idées de produits yoga et des options de personnalisation.",
  footerNewsletterPlaceholder: "Votre adresse e-mail",
};

STOREFRONT_TEXTS.ja = {
  ...EN_TEXTS,
  title: "LOYA SPORT",
  subtitle: "海外卸売バイヤー向け ヨガ・ライトフィットネス調達パートナー",
  loading: "製品を読み込み中...",
  error: "製品の読み込みに失敗しました。サービス状態を確認してください。",
  language: "言語",
  currency: "通貨",
  requestQuote: "見積もり依頼",
  sendMessage: "お問い合わせ送信",
  heroTag: "国際B2B調達",
  heroTitle: "B2Bバイヤー向け プレミアムヨガ・ライトフィットネス製品",
  heroBody: "卸売バイヤー向けに、商品調達・プライベートラベル調整・輸出実行を支援します。",
  heroBulletA: "厳選された商品ライン",
  heroBulletB: "プライベートラベル対応",
  heroBulletC: "検証済みサプライパートナー",
  heroBulletD: "EU・米国市場での実績",
  heroBulletE: "迅速な見積もり対応",
  heroCardTitle: "調達支援の進め方",
  heroCardBody: "対象商品、ブランド要件、数量計画をご共有ください。比較提案、サンプル手配、納期調整まで対応します。",
  categoryTitle: "カテゴリを見る",
  categoryBody: "卸売チャネル向けに需要の高いヨガ・フィットネス商品を確認できます。",
  featuredTitle: "注目商品のご紹介",
  featuredBody: "主要商品を確認し、数量とブランド計画に合わせて見積もり依頼できます。",
  factoryTitle: "サプライチェーンの強み",
  factoryBody: "明確なサプライヤーマッチング、MOQ、輸出準備。",
  storyTitle: "信頼できるサプライチェーン連携",
  storyBody: "仕様確認を迅速化し、納期遅延リスクを低減します。",
  storyBodyExtra: "サプライヤー選定、サンプル確認、出荷マイルストーンまで進捗を見える化し、調達計画を安定して進められるよう支援します。",
  serviceTitle: "品質・コンプライアンス工程",
  proofEyebrow: "会社情報",
  proofTitle: "ヨガ・ライトフィットネス向けB2B調達パートナー",
  proofBody: "世界の卸売・小売・ECチャネル向けに、ヨガ・ライトフィットネス商品の調達を支援します。",
  proofBodyExtra: "",
  proofCta: "B2Bチームへ問い合わせ",
  inquiryCtaEyebrow: "見積もり依頼",
  inquiryCtaTitle: "次のヨガ商品ラインを調達しませんか？",
  inquiryCtaBody: "対象商品と数量計画をご共有ください。最適な見積もりをご案内します。",
  inquiryQuickA: "目標回答時間: 8営業時間以内",
  inquiryQuickB: "対応市場: EU・米国の卸売チャネル",
  inquiryTitle: "見積もり依頼",
  inquiryHint: "商品、数量、ブランド要件、出荷先市場をご記入ください。",
  inquirySuccess: "ありがとうございます。お問い合わせを受け付けました。B2Bチームよりご連絡します。",
  inquiryError: "氏名、メールアドレス、お問い合わせ内容をご入力ください。",
  inquirySubmitting: "送信中...",
  inquirySubmitFailed: "送信に失敗しました。しばらくしてから再度お試しください。",
  chooseLanguageTitle: "対応する顧客層",
  chooseLanguageBody: "主要なB2Bチャネル向けに最適化。",
  trustA: "検証済みサプライチェーンパートナー",
  trustB: "柔軟なOEM・包装サポート",
  trustC: "信頼できるリードタイム管理",
  trustD: "厳格な出荷前検査",
  viewMore: "詳しく見る",
  viewAll: "商品を見る",
  talkToUs: "チームに相談",
  contactUs: "お問い合わせ",
  certifications: "品質・コンプライアンス",
  headerVerified: "検証済みサプライヤー",
  headerPrivateLabel: "プライベートラベル",
  headerGlobalShipping: "グローバル出荷",
  ariaBackToHomepage: "ホームページに戻る",
  ariaToggleNavigationMenu: "ナビゲーションメニューを切り替える",
  ariaPrimaryNavigation: "メインナビゲーション",
  ariaSearchProductByName: "商品名で検索",
  ariaSearch: "検索",
  sortLabel: "並び替え",
  sortDefault: "デフォルト",
  ariaSortProducts: "製品を並び替え",
  contactModelPrefix: "型番",
  ariaSwitchStorefrontLanguage: "ストアフロント言語を切り替える",
  ariaAccountCenter: "アカウントセンター",
  ariaLogin: "ログイン",
  globalContactTagline: "海外卸売バイヤー向けヨガ・フィットネス調達サポート",
  accountCenter: "アカウントセンター",
  productsCategoryTitle: "商品カテゴリ",
  productsAll: "すべての商品",
  productsOthers: "その他",
  productsCategoryNavigationAria: "商品カテゴリナビゲーション",
  productsContactNow: "今すぐ問い合わせ",
  productsEmpty: "このカテゴリに商品はありません。",
  productsPaginationAria: "商品ページネーション",
  productsPrev: "前へ",
  productsNext: "次へ",
  productsPage: "ページ",
  bookmarkHint: "Ctrl+D（Mac は Cmd+D）でこのサイトをブックマークできます。",
  ariaBreadcrumbNavigation: "パンくずナビゲーション",
  ariaPrivacyPreference: "プライバシー設定",
  privacyTitle: "プライバシー設定",
  privacyBody: "ストア運用に必要な技術を使用し、検索や推薦を改善する任意のプライバシー安全機能も提供します。",
  privacyOptionEnhanced: "内容を理解しました: 検索履歴の保存や個別推薦などの任意機能を有効化します。",
  privacyOptionBasic: "個人情報を販売・共有しない: 必須機能のみ有効化します。",
  privacyAccept: "内容を理解しました",
  privacyReject: "個人情報を販売・共有しない",
  ariaOpenPrivacyChoices: "プライバシーポリシーを開く",
  privacyChoices: "Privacy Policy",
  contactInquiryPresetLoaded: "問い合わせプリセットを読み込みました:",
  contactSelectedProduct: "選択した商品",
  contactQuoteHint: "見積もりを早めるため、対象SKU、年間見込み数量、対象市場、希望包装仕様をご記入ください。",
  inquiryProductDefault: "一般的な問い合わせ",
  navSubmenuSuffix: "サブメニュー",
  homeSupplyImageAlt: "サプライチェーン連携サポート",
  homeCertImageAlt: "認証とコンプライアンスの概要",
  breadcrumbProductDetail: "商品詳細",
  breadcrumbHomeSeries: "プライベートラベルシリーズ",
  breadcrumbHome: "ホーム",
  nav: "nav",
  buyerWholesalers: "卸売業者",
  buyerWholesalersNote: "大量構成と補充をサポート。",
  buyerRetailers: "小売業者",
  buyerRetailersNote: "店頭向けプログラムと包装支援。",
  buyerFitnessBrands: "フィットネスブランド",
  buyerFitnessBrandsNote: "商品ライン拡張のためのプライベートラベル支援。",
  buyerYogaStudios: "ヨガスタジオ",
  buyerYogaStudiosNote: "スタジオ向けセットとアクセサリー補充。",
  buyerAmazonSellers: "Amazon出品者",
  buyerAmazonSellersNote: "柔軟MOQでマーケットプレイス向け商品を提供。",
  buyerEcom: "EC事業者",
  buyerEcomNote: "継続販売向けのオンライン特化アソート。",
  featureSourcingTitle: "商品調達",
  featureSourcingBody: "発注前に仕様比較が可能。",
  featurePrivateLabelTitle: "プライベートラベル",
  featurePrivateLabelBody: "ロゴ・包装・セット提案を支援。",
  featureFlexibleOrderTitle: "柔軟な発注",
  featureFlexibleOrderBody: "テスト発注とリピート発注に対応。",
  featureExportTitle: "輸出サポート",
  featureExportBody: "書類と出荷フォローを対応。",
  metricVerified: "検証済みサプライヤー",
  metricVerifiedLabel: "カテゴリ適合",
  metricMoq: "柔軟MOQ",
  metricMoqLabel: "テスト + リピート",
  metricBranding: "プライベートラベル",
  metricBrandingLabel: "ブランド + 包装",
  metricDocs: "輸出対応",
  metricDocsLabel: "EU/US書類",
  whyVerifiedTitle: "検証済みサプライヤーネットワーク",
  whyVerifiedBody: "カテゴリ、品質、対象市場に応じたマッチング。",
  whyMoqTitle: "柔軟MOQサポート",
  whyMoqBody: "試験導入と段階的拡大に実用的な数量設定。",
  whyOemTitle: "OEM・プライベートラベル支援",
  whyOemBody: "チャネルに合わせたロゴ、包装、バンドルを調整。",
  whySourcingTitle: "調達・選定ガイダンス",
  whySourcingBody: "素材、仕様、ポジショニングで比較検討。",
  whyDeliveryTitle: "安定した納期調整",
  whyDeliveryBody: "マイルストーン管理で遅延リスクを低減。",
  whyInspectionTitle: "出荷前品質検査",
  whyInspectionBody: "出荷前に品質と梱包の重要点を確認。",
  proofStatA: "ヨガ・ライトフィットネス特化",
  proofStatB: "プライベートラベル調整",
  proofStatC: "EU・米国バイヤー支援",
  qcSupplierTitle: "サプライヤー適格性レビュー",
  qcSupplierBody: "能力と実績を確認。",
  qcInspectionTitle: "出荷前検査",
  qcInspectionBody: "商品、ラベル、梱包を確認。",
  qcComplianceTitle: "製品コンプライアンス支援",
  qcComplianceBody: "仕向地向け書類を準備。",
  qcCertTitle: "認証調整",
  qcCertBody: "パートナーと資料を整合。",
  faqQ1: "メーカーですか、それとも商社ですか？",
  faqA1: "当社はヨガ・ライトフィットネス商品に特化した商社です。検証済みサプライチェーンと連携し、調達、カスタマイズ、出荷支援を行います。",
  faqQ2: "プライベートラベルや小ロット試験注文に対応できますか？",
  faqA2: "はい。多くの商品でプライベートラベル対応が可能で、商品や案件内容に応じて柔軟な初期数量を協議できます。",
  faqQ3: "品質とコンプライアンスはどのように管理しますか？",
  faqA3: "仕様確認、サンプルレビュー、生産工程のチェックポイント管理、出荷前の梱包確認を実施します。",
  blogSeoTitle: "ブログ | 調達インサイトと購買ガイド",
  blogSeoDescription: "国際卸売とプライベートラベルのバイヤー向けに、実務的な購買ガイドと調達インサイトを提供します。",
  blogHeroDescription: "素材選定やサンプル確認から、発売準備に向けた発注計画まで、輸入業者とプライベートラベルバイヤー向けの実践的な調達ガイドです。",
  blogSearchPlaceholder: "調達インサイトを検索",
  blogFeaturedTitle: "注目記事",
  blogLatestTitle: "最新記事",
  blogBrowseTopicTitle: "トピックで探す",
  blogReadMore: "続きを読む",
  blogShowLess: "表示を減らす",
  blogDateFallback: "最近更新",
  blogEmptyFeatured: "条件に一致する注目記事がありません。別のキーワードまたはカテゴリをお試しください。",
  blogEmptyLatest: "現在の条件に一致する記事はありません。",
  blogCtaTitle: "次のコレクションに向けた調達サポートが必要ですか？",
  blogCtaViewProducts: "商品を見る",
  blogCtaExploreSolutions: "ソリューションを見る",
  blogCtaRequestQuote: "見積もりを依頼",
  blogCategoryAll: "すべて",
  blogCategoryBuyingGuide: "購買ガイド",
  blogCategoryCustomization: "カスタマイズ",
  blogCategorySampleOrder: "サンプル注文",
  blogCategorySourcing: "調達",
  blogCategoryProductTips: "商品のヒント",
  homeBreadcrumbCurrent: "現在のページ",
  homeHeroEyebrow: "グローバル調達サポート",
  homeHeroTitle: "商品調達とカスタマイズの信頼できるパートナー",
  homeHeroSubtitle: "明確なコミュニケーションと実務的な連携により、商品調達、カスタマイズ、サンプル対応、受注フォローをグローバルバイヤー向けに支援します。",
  homeQuickAccessEyebrow: "クイックアクセス",
  homeQuickAccessTitle: "主要な調達テーマを探す",
  homeQuickAccessBody: "これらのクイックリンクから、一般的な卸売・カスタマイズ要件に素早くアクセスできます。",
  homeCategoryBrowseMore: "さらにシリーズを見る",
  homeBestSellingEyebrow: "ベストセラー",
  homeBestSellingTitle: "ヨガ・フィットネスの人気商品",
  homeBestSellingBody: "卸売、スタジオ、オンライン販売向けの人気商品を確認できます。",
  homeBestSellingCardKicker: "B2Bバイヤーに人気",
  homeSolutionsTitle: "バイヤータイプ別ソリューション",
  homeSolutionsBody: "既存のソリューションページを、チャネル・利用シーン・商品計画の実用ガイドとして活用できます。",
  homeSolutionsButton: "ソリューションを見る",
  homeQualitySupportTitle: "グローバル市場のバイヤーから寄せられた評価",
  homeQualitySupportBody: "主要市場の提携企業における買い手側担当者の協業フィードバックを掲載しています。",
  homeSourcingInsightsEyebrow: "調達インサイト",
  homeSourcingInsightsTitle: "グローバル卸売バイヤー向けの実務協業",
  homeScenariosTitle: "よくある活用シナリオ",
  homeScenariosBody: "シナリオ計画はソリューションページと連動しており、詳細を確認できます。",
  homeScenariosLink: "ソリューションへ",
  homeProcessTitle: "明確な協業プロセス",
  homeProcessBody: "初回問い合わせから出荷調整まで、各ステップは明確な引き継ぎで進行します。",
  homeBlogTitle: "最新の購買・調達トピック",
  homeBlogBody: "調達、サンプル対応、カスタマイズ計画に焦点を当てた簡潔な記事を確認できます。",
  homeBlogReadMore: "続きを読む",
  homeAboutTitle: "私たちが支援する相手と協業方法",
  homeAboutBody: "当社は、商品調達やカスタマイズ案件で安定したコミュニケーションを必要とする輸入業者、ディストリビューター、小売業者、オンライン販売者との実務的な協業に注力しています。支援範囲は要件整理、サンプル調整、見積もりコミュニケーション、受注フォローまでを含みます。長期的な国際取引において、各工程を明確で現実的かつ実行可能に保つことを重視しています。",
  homeAboutLink: "会社概要",
  homeFaqAria: "よくある質問",
  homeFaqTitle: "よくある質問",
  homeFaqBody: "問い合わせ送信前に、まずはこちらをご確認ください。",
  homeFaqShowLess: "FAQを折りたたむ",
  homeFaqViewAll: "FAQをすべて表示",
  homeFormNamePlaceholder: "お名前",
  homeFormEmailPlaceholder: "業務用メール",
  homeFormWhatsappPlaceholder: "WhatsApp",
  homeFormCompanyPlaceholder: "会社名",
  homeFormProductPlaceholder: "対象商品",
  homeFormQuantityPlaceholder: "想定数量",
  homeFormMessagePlaceholder: "商品仕様、数量、対象市場",
  homeFormUploadLabel: "参考ファイルをアップロード（任意）",
  homeFormChooseFile: "ファイルを選択",
  homeFormNoFile: "ファイル未選択",
  homeFormSelectedFilePrefix: "選択中のファイル:",
  carouselAriaLabel: "プロモーションバナー",
  carouselBannerAltPrefix: "バナー",
  carouselPrevAria: "前のスライド",
  carouselNextAria: "次のスライド",
  carouselDotsAria: "カルーセルスライドセレクター",
  footerCtaAria: "フッター問い合わせCTA",
  footerCtaTitle: "B2Bヨガ調達サポート",
  footerCtaPrimary: "問い合わせを送信",
  footerCtaSecondary: "WhatsAppで連絡",
  footerCompanyProfileAria: "会社概要",
  footerBrandCopy: "海外バイヤー向けのサプライチェーン統合パートナーとして、厳格な商品選定・工場選定から品質管理、充実したアフターサービスまでをワンストップで提供します。",
  footerTrustPointA: "24時間以内に返信",
  footerTrustPointB: "OEM/ODM案件対応",
  footerTrustPointC: "世界向けB2B配送",
  footerQuickLinksAria: "クイックリンク",
  footerQuickLinksTitle: "クイックリンク",
  footerPopularCategoriesAria: "人気カテゴリ",
  footerPopularCategoriesTitle: "人気カテゴリ",
  footerBuyerSupportTitle: "バイヤーサポート",
  footerServicePointA: "低MOQ調整",
  footerServicePointB: "プライベートラベル調達",
  footerServicePointC: "混載・集約出荷サポート",
  footerServicePointD: "包装・コンプライアンスフォロー",
  footerContactAria: "連絡先情報",
  footerEmailLabel: "メール",
  footerWhatsappLabel: "WhatsApp",
  footerPhoneLabel: "電話",
  footerServiceLabel: "対応時間",
  footerCoverageLabel: "対応地域",
  footerServiceValue: "月-土 9:00-18:00 CST",
  footerCoverageValue: "グローバル市場（欧州、北米、中東、オセアニア、APAC など）",
  footerBottomCopyright: "国際卸売ビジネス向けのヨガ・フィットネス商品調達サポート。",
  homeEyebrowProductCategories: "商品カテゴリ",
  homeEyebrowFeaturedSelection: "注目セレクション",
  homeEyebrowSupplyChain: "サプライチェーンの強み",
  homeEyebrowQualityControl: "品質管理",
  homeEyebrowUseCases: "活用シーン",
  homeEyebrowWorkflow: "ワークフロー",
  homeEyebrowBlog: "ブログとインサイト",
  homeEyebrowAbout: "私たちについて",
  homeEyebrowFaq: "FAQ",
  homeAriaIntro: "B2Bヨガ・フィットネス調達の概要",
  homeAriaQuickNav: "SEOクイックナビ",
  homeAriaCategoryGallery: "商品カテゴリギャラリー",
  homeAriaBestSellingHead: "ベストセラー",
  homeAriaBestSellingGrid: "厳選ベストセラー商品",
  homeAriaSolutionsNav: "ソリューションナビ",
  homeAriaSupplyQuality: "供給・品質支援ハイライト",
  homeAriaSourcingOverview: "調達とカスタマイズの概要",
  homeAriaScenarios: "活用シナリオ",
  homeAriaProcess: "協業プロセス",
  homeAriaBlog: "ブログハイライト",
  homeAriaAboutSummary: "会社紹介サマリー",
  homeEmptyBadge: "在庫準備中",
  homeEmptyTitle: "現在表示可能な商品はありません",
  homeEmptySuffix: " は商品公開後にここへ表示されます。",
  homeQuickLink1Title: "商品調達",
  homeQuickLink1Body: "卸売バイヤー向けに柔軟な調達支援を提供します。",
  homeQuickLink2Title: "プライベートラベル支援",
  homeQuickLink2Body: "市場投入可能なSKU向けに、ブランド・包装オプションを提供します。",
  homeQuickLink3Title: "OEM / ODM協業",
  homeQuickLink3Body: "要件整理からサンプル確認、量産まで対応します。",
  homeQuickLink4Title: "サンプル注文支援",
  homeQuickLink4Body: "量産計画前に、試験サンプルについて相談できます。",
  homeQuickLink5Title: "卸売供給",
  homeQuickLink5Body: "ディストリビューター、小売業者、オンライン販売者に適しています。",
  homeQuickLink6Title: "ソリューションガイド",
  homeQuickLink6Body: "バイヤータイプと利用シーン別に実行しやすいルートを確認できます。",
  homeScenario1Title: "小売チャネル準備",
  homeScenario1Body: "店頭展開と卸売流通の両方に対応できる実用的な商品構成を作ります。",
  homeScenario2Title: "マーケットプレイス向け商品計画",
  homeScenario2Body: "オンラインチャネル向けに商品構成と包装詳細を調整します。",
  homeScenario3Title: "スタジオ・ジム向け供給",
  homeScenario3Body: "レッスン利用と会員向け再販のために、耐久性ある商品セットを準備します。",
  homeProcessStep1: "問い合わせ",
  homeProcessStep2: "要件確認",
  homeProcessStep3: "サンプル協議",
  homeProcessStep4: "見積もり",
  homeProcessStep5: "注文確定",
  homeProcessStep6: "生産フォロー",
  homeProcessStep7: "出荷調整",
  homeBlogHighlight1Title: "効率的な商品調達問い合わせの作り方",
  homeBlogHighlight1Body: "見積もり依頼前に、商品詳細・数量・出荷先情報を整理する実務チェックリスト。",
  homeBlogHighlight2Title: "プライベートラベル計画: サンプル前に確認すべき重要点",
  homeBlogHighlight2Body: "ロゴ方式、包装詳細、スケジュール調整により手戻りを減らします。",
  homeBlogHighlight3Title: "卸売トライアル注文: 協業開始の安全な進め方",
  homeBlogHighlight3Body: "大口発注前に、商品品質とコミュニケーションフローを評価する方法。",
  homeFallbackFaq1Question: "見積もりにはどの情報が必要ですか？",
  homeFallbackFaq1Answer: "商品名または画像、想定数量、対象市場、包装要件をご共有ください。効率的に回答できます。",
  homeFallbackFaq2Question: "プライベートラベル対応は可能ですか？",
  homeFallbackFaq2Answer: "可能です。ロゴ方式の相談、包装詳細、要件に応じた生産調整まで対応できます。",
  homeFallbackFaq3Question: "量産前のサンプル対応はありますか？",
  homeFallbackFaq3Answer: "仕様確認やコミュニケーション期待値のすり合わせのため、量産前にサンプル協議が可能です。",
  homeFallbackFaq4Question: "小ロットの試験注文は相談できますか？",
  homeFallbackFaq4Answer: "商品タイプ、包装要件、生産体制に応じて試験数量を相談できます。",
  homeFallbackFaq5Question: "カスタマイズ案件のコミュニケーションはどう進めますか？",
  homeFallbackFaq5Answer: "通常は書面で要件を合わせ、サンプル詳細を確認し、実行中はマイルストーン単位で進捗共有します。",
  homeFallbackFaq6Question: "一般的な協業フローは？",
  homeFallbackFaq6Answer: "一般的には、問い合わせ、要件確認、サンプル確認、見積もり、注文確定、出荷フォローの流れです。",
  homeFallbackFaq7Question: "輸出書類の調整は対応できますか？",
  homeFallbackFaq7Answer: "仕向地と出荷要件に応じて、輸出書類の調整を相談できます。",
  homeFallbackFaq8Question: "初回返信はどれくらいで受け取れますか？",
  homeFallbackFaq8Answer: "初回返信速度は要件の複雑さによります。商品情報が詳しいほど、通常は回答が早くなります。",
  marketNorthAmerica: "北米",
  marketNorthAmericaNote: "輸入業者 · オンラインブランド · スタジオ小売",
  marketEurope: "ヨーロッパ",
  marketEuropeNote: "ディストリビューター · ウェルネスチェーン · プライベートラベルバイヤー",
  marketAsiaPacific: "アジア太平洋",
  marketAsiaPacificNote: "ヨガスタジオ · イーコマース小売業者 · フィットネス小売店",
  marketMiddleEast: "中東",
  marketMiddleEastNote: "ブティックブランド · 企業ウェルネス · ギフトセットバイヤー",
  homeCtaEyebrow: "輸入業者・ディストリビューター・スタジオ・オンラインブランドの方へ",
  homeCtaTitle: "ターゲット市場向けの製品調達プランを依頼する。",
  homeCtaDescription: "居住国、販売チャネル、商品カテゴリー、目標MOQ、ブランドスタイルをお知らせください。適切な製品オプションとカスタマイズルートを整理してご提案します。",
  homeCtaPrimary: "問い合わせを送る",
  homeCtaSecondary: "カテゴリーを見る",
  homeRequestCatalog: "全カタログをリクエスト",
  homeSeoKeywordBody: "当社は、グローバルバイヤー向けに中国拠点で調達支援を行い、商品調達、商品カスタマイズ、プライベートラベル支援における実務的な協業を重視しています。ホームページは、調達チームが問い合わせから出荷までを明確なコミュニケーションで進める方法を素早く理解できるよう設計されています。OEM/ODM支援、サンプル対応、卸売供給を検討するバイヤーにとって、構造化されたプロセスは不確実性を減らし、実行速度を高めます。不要な複雑さを避け、要件明確化、サンプル整合、安定した受注フォローを重視するのが当社の協業モデルです。小規模な試験注文から大きな調達計画まで、重視するポイントは同じです。安定したコミュニケーション、現実的な納期調整、そして国際市場向けの商品・包装要件に対する実行可能な支援です。",
  buyerReviewsAria: "実際のバイヤーレビュー",
  buyerReviewsTitle: "バイヤーからの実際の声",
  reviewName1: "Sarah Mitchell",
  reviewRole1: "シニアソーシングリード、Core Active LLC",
  reviewCountry1: "アメリカ合衆国",
  reviewText1: "チームは各ステップを透明かつサービス志向で進めてくれました。最初のサンプルレビューから最終納品まで、しっかりとサポートしてもらえました。",
  reviewName2: "Omar Al-Hassan",
  reviewRole2: "輸入業務マネージャー、Gulf Horizon Trading",
  reviewCountry2: "サウジアラビア",
  reviewText2: "チームは明確な状況報告と非常に良いサービスを提供してくれます。各ステップで安心でき、出荷タイミングも計画通りでした。",
  reviewName3: "Sophie Laurent",
  reviewRole3: "購買リード、Maison Fit France",
  reviewCountry3: "フランス",
  reviewText3: "コーディネーションの品質は優れていました。チームは詳細を積極的にフォローアップし、欧州市場への繰り返し発注に自信が持てました。",
  reviewName4: "James Carter",
  reviewRole4: "購買ディレクター、Northline Wellness UK",
  reviewCountry4: "イギリス",
  reviewText4: "協力関係は信頼でき、温かみがありました。マイルストーンは明確で、問題は迅速に対処され、納品品質も合意した基準を満たしていました。",
  reviewStarsUnit: "つ星",
  homeShowcaseAria: "展示会の製品ショーケース",
  homeShowcaseAlt1: "展示会のヨガ製品ブース全景",
  homeShowcaseAlt2: "ブースのヨガマット展示ウォール",
  homeShowcaseAlt3: "展示会ブースのヨガアクセサリー展示ラック",
  homeSeoFallbackTitle: "製品調達とカスタマイズサポート | LOYA SPORT",
  homeSeoFallbackDescription: "グローバルな卸売バイヤー向けの専門的な製品調達、カスタマイズ、プライベートラベルサポート、注文フォローアップ。",
  footerLocationValue: "中国・長沙",
  footerNewsletterTitle: "カタログ更新情報",
  footerNewsletterDesc: "新しいヨガ製品のアイデアとカスタマイズオプションをお届けするためにメールアドレスを入力してください。",
  footerNewsletterPlaceholder: "メールアドレスを入力",
};

STOREFRONT_TEXTS.ko = {
  ...STOREFRONT_TEXTS.en,
  language: "언어",
  currency: "통화",
  requestQuote: "견적 요청",
  sendMessage: "문의 제출",
  subtitle: "글로벌 도매 바이어를 위한 요가 제품 공급망 통합 파트너",
  loading: "제품을 불러오는 중입니다...",
  error: "제품을 불러오지 못했습니다. 서비스 상태를 확인해 주세요.",
  heroTag: "국제 B2B 소싱",
  heroTitle: "B2B 바이어를 위한 프리미엄 요가 및 라이트 피트니스 제품",
  heroBody: "정확한 제품 큐레이션부터 엄격한 품질 관리, 사후 지원까지 원스톱으로 지원합니다.",
  heroBulletA: "큐레이션된 제품 라인업",
  heroBulletB: "프라이빗 라벨 지원",
  heroBulletC: "검증된 공급 파트너",
  heroBulletD: "글로벌 공급 커버리지",
  heroBulletE: "빠른 견적 응답",
  categoryTitle: "주요 카테고리 둘러보기",
  featuredTitle: "추천 제품 셀렉션",
  factoryTitle: "공급망 강점",
  storyTitle: "신뢰할 수 있는 공급망 협업",
  serviceTitle: "품질 및 규정 준수 프로세스",
  proofEyebrow: "회사 소개",
  proofTitle: "요가 및 라이트 피트니스 B2B 소싱 파트너",
  proofBody: "전 세계 도매, 소매, 이커머스 채널에 맞춘 소싱을 지원합니다.",
  proofCta: "B2B 팀에 문의",
  inquiryTitle: "견적 요청",
  inquiryHint: "제품, 수량, 브랜딩 요구사항, 판매 시장을 알려주세요.",
  inquirySuccess: "문의가 접수되었습니다. B2B 팀이 곧 회신드립니다.",
  inquiryError: "이름, 이메일, 문의 내용을 입력해 주세요.",
  inquirySubmitting: "제출 중...",
  viewAll: "제품 보기",
  talkToUs: "팀에 문의",
  contactUs: "문의하기",
  headerVerified: "검증된 공급업체",
  headerPrivateLabel: "프라이빗 라벨",
  headerGlobalShipping: "글로벌 배송",
  productsCategoryTitle: "제품 카테고리",
  productsAll: "전체 제품",
  productsOthers: "기타",
  productsContactNow: "지금 문의",
  productsEmpty: "해당 카테고리에 제품이 없습니다.",
  productsPrev: "이전",
  productsNext: "다음",
  productsPage: "페이지",
  privacyTitle: "개인정보 선택",
  privacyBody: "스토어 운영에 필요한 기술과 선택형 개인화 기능을 사용합니다.",
  privacyAccept: "동의합니다",
  privacyReject: "개인정보 판매/공유 안 함",
  blogSeoTitle: "블로그 | 소싱 인사이트 및 구매 가이드",
  blogSeoDescription: "글로벌 도매 및 프라이빗 라벨 바이어를 위한 실무형 인사이트.",
  blogSearchPlaceholder: "소싱 인사이트 검색",
  blogFeaturedTitle: "추천 글",
  blogLatestTitle: "최신 글",
  blogBrowseTopicTitle: "주제별 보기",
  blogReadMore: "더 보기",
  blogShowLess: "접기",
  blogDateFallback: "최근 업데이트",
  blogCtaTitle: "다음 컬렉션 소싱 지원이 필요하신가요?",
  blogCtaViewProducts: "제품 보기",
  blogCtaExploreSolutions: "솔루션 보기",
  blogCtaRequestQuote: "견적 요청",
  blogCategoryAll: "전체",
  blogCategoryBuyingGuide: "구매 가이드",
  blogCategoryCustomization: "커스터마이징",
  blogCategorySampleOrder: "샘플 주문",
  blogCategorySourcing: "소싱",
  blogCategoryProductTips: "제품 팁",
  reviewStarsUnit: "점",
  homeShowcaseAria: "전시회 제품 쇼케이스",
  homeShowcaseAlt1: "전시회 요가 제품 부스 전경",
  homeShowcaseAlt2: "전시 부스 내 요가 매트 전시 벽",
  homeShowcaseAlt3: "전시 부스 내 요가 액세서리 진열대",
  homeSeoFallbackTitle: "제품 소싱 및 커스터마이징 지원 | LOYA SPORT",
  homeSeoFallbackDescription: "글로벌 도매 바이어를 위한 제품 소싱, 커스터마이징, 프라이빗 라벨 지원 및 주문 추적 서비스.",
  breadcrumbHome: "홈",
  breadcrumbProductDetail: "제품 상세",
  heroCardTitle: "소싱을 지원하는 방식",
  heroCardBody: "목표 제품, 브랜딩 요구사항, 수량 계획을 공유해 주세요. 옵션 비교, 샘플 진행, 납기 조율을 지원합니다.",
  categoryBody: "도매 채널에 적합한 수요 높은 요가 및 피트니스 컬렉션을 확인하세요.",
  featuredBody: "핵심 품목을 검토하고 수량 및 브랜딩 계획에 맞춰 견적을 요청하세요.",
  factoryBody: "공급업체 매칭, MOQ, 수출 준비 상태를 명확히 안내합니다.",
  storyBody: "사양 확인을 빠르게 진행하고 납기 일정을 안정적으로 관리합니다.",
  storyBodyExtra: "공급업체 매칭부터 샘플, 출하 마일스톤까지 진행 상황을 투명하게 공유해 소싱 계획을 통제 가능하게 유지합니다.",
  inquiryCtaEyebrow: "견적 요청",
  inquiryCtaTitle: "다음 요가 제품 라인 소싱을 시작할 준비가 되셨나요?",
  inquiryCtaBody: "목표 제품과 수량 계획을 알려주시면 맞춤 견적을 제안드립니다.",
  inquiryQuickA: "응답 목표: 영업일 기준 8시간 이내",
  inquiryQuickB: "지원 시장: 글로벌 도매 채널",
  inquirySubmitFailed: "전송에 실패했습니다. 잠시 후 다시 시도해 주세요.",
  chooseLanguageTitle: "지원 대상 고객",
  chooseLanguageBody: "핵심 B2B 채널을 위해 설계되었습니다.",
  trustA: "검증된 공급망 파트너",
  trustB: "유연한 OEM 및 패키징 지원",
  trustC: "신뢰할 수 있는 납기 관리",
  trustD: "엄격한 선적 전 검사",
  viewMore: "자세히 보기",
  certifications: "품질 및 컴플라이언스",
  globalContactTagline: "글로벌 도매 바이어를 위한 요가 및 피트니스 공급망 통합 지원",
  privacyOptionEnhanced: "동의합니다: 검색 기록 저장 및 개인화 추천과 같은 선택 기능을 활성화합니다.",
  privacyOptionBasic: "내 개인정보 판매/공유 금지: 필수 스토어 기능만 활성화합니다.",
  homeHeroEyebrow: "글로벌 소싱 지원",
  homeHeroTitle: "제품 소싱 및 커스터마이징을 위한 신뢰할 수 있는 파트너",
  homeHeroSubtitle: "명확한 커뮤니케이션과 실무 중심 협업으로 글로벌 바이어의 제품 소싱, 커스터마이징, 샘플 진행, 주문 후속 관리를 지원합니다.",
  homeQuickAccessEyebrow: "빠른 접근",
  homeQuickAccessTitle: "핵심 소싱 주제 탐색",
  homeQuickAccessBody: "빠른 링크를 통해 자주 사용되는 도매 및 커스터마이징 요구사항으로 바로 이동하세요.",
  homeBestSellingEyebrow: "베스트셀러",
  homeBestSellingTitle: "인기 요가 및 피트니스 제품",
  homeBestSellingBody: "도매, 스튜디오, 온라인 판매 채널에서 검증된 인기 상품을 확인하세요.",
  homeSolutionsTitle: "바이어 유형별 솔루션",
  homeSolutionsBody: "기존 솔루션 페이지를 채널, 시나리오, 제품 계획에 맞춘 실행 가이드로 활용하세요.",
  homeSolutionsButton: "솔루션 보기",
  homeQualitySupportTitle: "글로벌 시장 바이어 피드백",
  homeQualitySupportBody: "주요 시장 파트너와의 실제 협업 경험을 바탕으로 한 구매 담당자 피드백을 소개합니다.",
  buyerReviewsAria: "바이어 리뷰",
  buyerReviewsTitle: "협업 후기",
  reviewRole1: "소싱 매니저",
  reviewCountry1: "독일",
  reviewText1: "샘플 조율과 패키징 커뮤니케이션이 명확해 첫 주문 진행이 매우 수월했습니다.",
  reviewRole2: "카테고리 바이어",
  reviewCountry2: "UAE",
  reviewText2: "제품 구성 제안이 실용적이어서 시장 테스트를 빠르게 시작할 수 있었습니다.",
  reviewRole3: "브랜드 오너",
  reviewCountry3: "호주",
  reviewText3: "커스터마이징 일정 관리가 체계적이어서 출시 계획을 안정적으로 맞출 수 있었습니다.",
  reviewRole4: "도매 파트너",
  reviewCountry4: "캐나다",
  reviewText4: "반복 주문 시 커뮤니케이션 속도와 납기 가시성이 특히 만족스러웠습니다.",
  homeSupplyImageAlt: "공급망 협업 지원 이미지",
  homeCertImageAlt: "인증 및 컴플라이언스 개요 이미지",
  featureSourcingTitle: "제품 소싱",
  featureSourcingBody: "주문 전 사양을 비교합니다.",
  featurePrivateLabelTitle: "프라이빗 라벨",
  featurePrivateLabelBody: "로고, 포장, 번들 지원.",
  featureFlexibleOrderTitle: "유연한 주문",
  featureFlexibleOrderBody: "테스트 주문과 반복 주문 모두 지원.",
  featureExportTitle: "수출 지원",
  featureExportBody: "문서 및 선적 후속 관리.",
  metricVerified: "검증된 공급업체",
  metricVerifiedLabel: "카테고리 매칭",
  metricMoq: "유연한 MOQ",
  metricMoqLabel: "테스트 + 반복",
  metricBranding: "프라이빗 라벨",
  metricBrandingLabel: "브랜딩 + 포장",
  metricDocs: "수출 준비",
  metricDocsLabel: "EU/US 문서",
  whyVerifiedTitle: "검증된 공급업체 네트워크",
  whyVerifiedBody: "카테고리, 품질, 목표 시장에 맞춰 공급업체를 매칭합니다.",
  whyMoqTitle: "유연한 MOQ 지원",
  whyMoqBody: "테스트와 단계적 확장에 맞는 실용적 수량을 제안합니다.",
  whyOemTitle: "OEM 및 프라이빗 라벨 지원",
  whyOemBody: "채널에 맞춰 로고, 포장, 번들 구성을 조율합니다.",
  whySourcingTitle: "소싱 및 셀렉션 가이드",
  whySourcingBody: "재질, 사양, 포지셔닝 기준으로 옵션을 비교합니다.",
  whyDeliveryTitle: "안정적인 납기 조율",
  whyDeliveryBody: "마일스톤과 일정을 추적해 납기 리스크를 줄입니다.",
  whyInspectionTitle: "선적 전 품질 검사",
  whyInspectionBody: "선적 전 핵심 품질 및 포장 항목을 점검합니다.",
  qcSupplierTitle: "공급업체 자격 검토",
  qcSupplierBody: "생산 역량과 이력을 확인합니다.",
  qcInspectionTitle: "선적 전 검사",
  qcInspectionBody: "제품, 라벨, 포장을 검증합니다.",
  qcComplianceTitle: "제품 컴플라이언스 지원",
  qcComplianceBody: "도착지 요구 문서 준비를 지원합니다.",
  qcCertTitle: "인증 문서 조율",
  qcCertBody: "파트너와 인증 파일을 정합합니다.",
  faqQ1: "귀사는 제조사인가요, 공급망 통합사인가요?",
  faqA1: "저희는 요가 제품 공급망 통합사입니다. 검증된 파트너와 함께 소싱, 커스터마이징, 품질 관리, 선적, 사후 지원을 조율합니다.",
  faqQ2: "프라이빗 라벨과 소량 테스트 주문도 가능한가요?",
  faqA2: "네. 다수 품목에서 프라이빗 라벨 적용을 지원하며 제품과 프로젝트 범위에 따라 유연한 시작 수량을 협의할 수 있습니다.",
  faqQ3: "품질과 규정 준수는 어떻게 관리하나요?",
  faqA3: "사양 확인, 샘플 검토, 생산 체크포인트 후속, 선적 전 포장 점검으로 품질과 컴플라이언스를 관리합니다.",
  homeBreadcrumbCurrent: "현재 페이지",
  homeCategoryBrowseMore: "더 많은 시리즈 보기",
  homeBestSellingCardKicker: "B2B 바이어 인기",
  homeSourcingInsightsEyebrow: "소싱 인사이트",
  homeSourcingInsightsTitle: "글로벌 도매 바이어를 위한 실무 협업",
  homeScenariosTitle: "주요 적용 시나리오",
  homeScenariosBody: "시나리오 계획은 솔루션 페이지와 연동되어 더 자세히 확인할 수 있습니다.",
  homeScenariosLink: "솔루션으로 이동",
  homeProcessTitle: "명확한 협업 프로세스",
  homeProcessBody: "초기 문의부터 선적 조율까지 단계별 인수인계가 명확합니다.",
  homeBlogTitle: "최신 구매 및 소싱 주제",
  homeBlogBody: "조달, 샘플, 커스터마이징 계획에 집중한 핵심 글을 확인하세요.",
  homeBlogReadMore: "더 읽기",
  homeAboutTitle: "지원 대상과 협업 방식",
  homeAboutBody: "제품 소싱과 커스터마이징 프로젝트에서 안정적인 커뮤니케이션이 필요한 수입업체, 유통업체, 소매업체, 온라인 판매자와의 실무 협업에 집중합니다.",
  homeAboutLink: "회사 프로필",
  homeFaqAria: "자주 묻는 질문",
  homeFaqTitle: "자주 묻는 질문",
  homeFaqBody: "문의 전 빠르게 확인할 수 있는 답변입니다.",
  homeFaqShowLess: "FAQ 접기",
  homeFaqViewAll: "FAQ 전체 보기",
  homeFormNamePlaceholder: "이름",
  homeFormEmailPlaceholder: "업무용 이메일",
  homeFormWhatsappPlaceholder: "WhatsApp",
  homeFormCompanyPlaceholder: "회사명",
  homeFormProductPlaceholder: "목표 제품",
  homeFormQuantityPlaceholder: "예상 수량",
  homeFormMessagePlaceholder: "제품 사양, 수량, 목표 시장",
  homeFormUploadLabel: "참고 파일 업로드 (선택)",
  homeFormChooseFile: "파일 선택",
  homeFormNoFile: "선택된 파일 없음",
  homeFormSelectedFilePrefix: "선택 파일:",
  homeEyebrowProductCategories: "제품 카테고리",
  homeEyebrowFeaturedSelection: "추천 셀렉션",
  homeEyebrowSupplyChain: "공급망 강점",
  homeEyebrowQualityControl: "품질 관리",
  homeEyebrowUseCases: "활용 사례",
  homeEyebrowWorkflow: "워크플로",
  homeEyebrowBlog: "블로그 및 인사이트",
  homeEyebrowAbout: "회사 소개",
  homeEyebrowFaq: "FAQ",
  homeAriaIntro: "B2B 요가 및 피트니스 소싱 개요",
  homeAriaQuickNav: "빠른 SEO 내비게이션",
  homeAriaCategoryGallery: "제품 카테고리 갤러리",
  homeAriaBestSellingHead: "베스트셀러 제품",
  homeAriaBestSellingGrid: "큐레이션 베스트셀러 제품",
  homeAriaSolutionsNav: "솔루션 내비게이션",
  homeAriaSupplyQuality: "공급망 및 품질 지원 하이라이트",
  homeAriaSourcingOverview: "소싱 및 커스터마이징 개요",
  homeAriaScenarios: "활용 시나리오",
  homeAriaProcess: "협업 프로세스",
  homeAriaBlog: "블로그 하이라이트",
  homeAriaAboutSummary: "회사 소개 요약",
  homeEmptyBadge: "재고 준비 중",
  homeEmptyTitle: "아직 표시 가능한 제품이 없습니다",
  homeEmptySuffix: " 항목은 게시 후 여기에 표시됩니다.",
  homeQuickLink1Title: "제품 소싱",
  homeQuickLink1Body: "도매 바이어를 위한 유연한 소싱 지원.",
  homeQuickLink2Title: "프라이빗 라벨 지원",
  homeQuickLink2Body: "시장 출시형 SKU를 위한 브랜딩 및 포장 옵션.",
  homeQuickLink3Title: "OEM / ODM 협업",
  homeQuickLink3Body: "요구사항 정리부터 샘플 확정, 생산까지.",
  homeQuickLink4Title: "샘플 주문 지원",
  homeQuickLink4Body: "대량 주문 계획 전 테스트 샘플을 협의하세요.",
  homeQuickLink5Title: "도매 공급",
  homeQuickLink5Body: "유통업체, 소매업체, 온라인 판매자에 적합.",
  homeQuickLink6Title: "솔루션 가이드",
  homeQuickLink6Body: "바이어 유형과 활용 시나리오별 실무 경로 확인.",
  homeScenario1Title: "리테일 채널 준비",
  homeScenario1Body: "매장 진열형과 도매 유통형 모두를 위한 실용적 상품 구성을 구축합니다.",
  homeScenario2Title: "마켓플레이스 상품 프로그램",
  homeScenario2Body: "온라인 채널에 맞춰 상품 조합과 포장 세부를 조율합니다.",
  homeScenario3Title: "스튜디오 및 체육관 공급",
  homeScenario3Body: "수업 사용과 회원 재판매를 위한 내구성 있는 상품 세트를 준비합니다.",
  homeProcessStep1: "문의",
  homeProcessStep2: "요구사항 검토",
  homeProcessStep3: "샘플 협의",
  homeProcessStep4: "견적",
  homeProcessStep5: "주문 확정",
  homeProcessStep6: "생산 후속",
  homeProcessStep7: "출하 조율",
  homeBlogHighlight1Title: "효율적인 제품 소싱 문의 작성법",
  homeBlogHighlight1Body: "견적 요청 전 제품 상세, 수량, 배송지 정보를 정리하는 실무 체크리스트.",
  homeBlogHighlight2Title: "프라이빗 라벨 계획: 샘플 전에 확인할 핵심 포인트",
  homeBlogHighlight2Body: "로고 방식, 포장 세부, 일정 정렬로 재작업 리스크를 줄입니다.",
  homeBlogHighlight3Title: "도매 테스트 주문: 안전한 협업 시작 방법",
  homeBlogHighlight3Body: "대량 발주 전 제품 품질과 커뮤니케이션 흐름을 검증하는 방법.",
  blogHeroDescription: "소재 선택, 샘플 검토, 출시 준비 발주 계획까지 수입업체와 프라이빗 라벨 바이어를 위한 실무형 소싱 가이드입니다.",
  blogEmptyFeatured: "조건에 맞는 추천 글이 없습니다. 다른 키워드나 카테고리를 시도해 보세요.",
  blogEmptyLatest: "현재 필터와 일치하는 글이 없습니다.",
  buyerWholesalers: "도매업체",
  buyerWholesalersNote: "대량 상품 구성과 재보충 지원.",
  buyerRetailers: "소매업체",
  buyerRetailersNote: "매장 진열형 프로그램과 포장 지원.",
  buyerFitnessBrands: "피트니스 브랜드",
  buyerFitnessBrandsNote: "제품 라인 확장을 위한 프라이빗 라벨 지원.",
  buyerYogaStudios: "요가 스튜디오",
  buyerYogaStudiosNote: "스튜디오 번들 및 액세서리 재보충.",
  buyerAmazonSellers: "Amazon 판매자",
  buyerAmazonSellersNote: "유연한 MOQ의 마켓플레이스 준비형 제품.",
  buyerEcom: "이커머스 기업",
  buyerEcomNote: "반복 판매에 적합한 온라인 중심 상품 구성.",
  footerCtaTitle: "B2B 요가 소싱 지원",
  footerCtaPrimary: "문의 보내기",
  footerCtaSecondary: "WhatsApp 문의",
  footerBrandCopy: "해외 바이어를 위한 공급망 통합 파트너로서 엄격한 상품 선별과 공장 매칭부터 품질 관리, 사후 지원까지 원스톱으로 제공합니다.",
  footerTrustPointA: "24시간 내 응답",
  footerTrustPointB: "OEM 및 ODM 프로젝트",
  footerTrustPointC: "전 세계 B2B 배송",
  footerQuickLinksTitle: "빠른 링크",
  footerPopularCategoriesTitle: "인기 카테고리",
  footerBuyerSupportTitle: "바이어 지원",
  footerServicePointA: "저 MOQ 조율",
  footerServicePointB: "프라이빗 라벨 소싱",
  footerServicePointC: "통합 선적 지원",
  footerServicePointD: "포장 및 컴플라이언스 후속",
  footerEmailLabel: "이메일",
  footerWhatsappLabel: "WhatsApp",
  footerPhoneLabel: "전화",
  footerServiceLabel: "서비스",
  footerCoverageLabel: "지원 범위",
  footerServiceValue: "월-토, 9:00-18:00 CST",
  footerCoverageValue: "글로벌 시장(유럽, 북미, 중동, 오세아니아, APAC 포함)",
  footerBottomCopyright: "국제 도매 비즈니스를 위한 요가 및 피트니스 제품 소싱 지원.",
  homeSeoKeywordBody: "글로벌 바이어를 위한 중국 현지 소싱 파트너로서, 제품 소싱, 제품 커스터마이징, 프라이빗 라벨 지원 전반의 실무 협업에 집중합니다. 홈페이지는 조달팀이 명확한 커뮤니케이션을 바탕으로 문의부터 출하까지 협업 구조를 빠르게 이해할 수 있도록 설계되었습니다. OEM/ODM 지원, 샘플 주문 지원, 도매 공급 옵션을 검토하는 바이어에게 구조화된 프로세스는 불확실성을 줄이고 실행 속도를 높입니다. 불필요한 복잡성보다 요구사항 정리, 샘플 정합, 안정적인 주문 후속 관리를 중시합니다. 소량 테스트 주문이든 대규모 조달 계획이든 핵심은 같습니다. 안정적인 커뮤니케이션, 현실적인 납기 조율, 국제 시장에 맞는 실행 가능한 제품 및 포장 지원입니다.",
  title: "LOYA SPORT",
  proofBodyExtra: "",
  ariaBackToHomepage: "홈으로 돌아가기",
  ariaToggleNavigationMenu: "내비게이션 메뉴 열기/닫기",
  ariaPrimaryNavigation: "주요 내비게이션",
  ariaSearchProductByName: "제품명으로 검색",
  ariaSearch: "검색",
  sortLabel: "정렬",
  sortDefault: "기본값",
  ariaSortProducts: "제품 정렬",
  contactModelPrefix: "모델",
  ariaSwitchStorefrontLanguage: "스토어프론트 언어 변경",
  ariaAccountCenter: "계정 센터",
  ariaLogin: "로그인",
  accountCenter: "계정 센터",
  productsCategoryNavigationAria: "제품 카테고리 내비게이션",
  productsPaginationAria: "제품 페이지 이동",
  bookmarkHint: "Ctrl+D(Mac은 Cmd+D)를 눈러 이 사이트를 북마크하세요.",
  ariaBreadcrumbNavigation: "브레드크럼 내비게이션",
  ariaPrivacyPreference: "개인정보 기본 설정",
  ariaOpenPrivacyChoices: "개인정보 처리방침 열기",
  privacyChoices: "Privacy Policy",
  contactInquiryPresetLoaded: "문의 사전 설정 로드됨:",
  contactSelectedProduct: "선택된 제품",
  contactQuoteHint: "견적을 빠르게 받으려면 목표 SKU, 예상 연간 수량, 목적지 시장, 선호 포장 방식을 포함해 주세요.",
  inquiryProductDefault: "일반 문의",
  navSubmenuSuffix: "하위 메뉴",
  breadcrumbHomeSeries: "프라이빗 라벨 시리즈",
  nav: "nav",
  proofStatA: "요가 및 경량 피트니스 전문",
  proofStatB: "프라이빗 라벨 조율",
  proofStatC: "글로벌 바이어 지원",
  carouselAriaLabel: "프로모션 배너",
  carouselBannerAltPrefix: "배너",
  carouselPrevAria: "이전 슬라이드",
  carouselNextAria: "다음 슬라이드",
  carouselDotsAria: "캐러셀 슬라이드 선택기",
  footerCtaAria: "푸터 문의 유도",
  footerCompanyProfileAria: "회사 프로필",
  footerQuickLinksAria: "빠른 링크",
  footerPopularCategoriesAria: "인기 카테고리",
  footerContactAria: "연락정보",
  homeFallbackFaq1Question: "견적을 위해 어떤 정보가 필요한가요?",
  homeFallbackFaq1Answer: "제품명 또는 이미지, 예상 수량, 목적지 시장, 포장 요건을 공유해 주시면 신속히 안내드립니다.",
  homeFallbackFaq2Question: "프라이빗 라벨 요청을 지원하나요?",
  homeFallbackFaq2Answer: "네. 프라이빗 라벨 지원에는 로고 방식, 포장 세부사항, 요건에 따른 생산 조율이 포함될 수 있습니다.",
  homeFallbackFaq3Question: "대량 주문 전 샘플 지원이 있나요?",
  homeFallbackFaq3Answer: "대량 생산 계획 전 사양 및 커뮤니케이션 기대치를 확인하기 위한 샘플 논의가 가능합니다.",
  homeFallbackFaq4Question: "소규모 테스트 주문도 가능한가요?",
  homeFallbackFaq4Answer: "테스트 수량은 제품 유형, 포장 필요사항, 생산 방식에 따라 논의 가능합니다.",
  homeFallbackFaq5Question: "커스터마이징 커뮤니케이션은 어떻게 관리하나요?",
  homeFallbackFaq5Answer: "요건을 서면으로 정리하고, 샘플 세부사항을 확인하며, 실행 중 마일스톤 업데이트를 유지합니다.",
  homeFallbackFaq6Question: "일반적인 협업 프로세스는 어떻게 되나요?",
  homeFallbackFaq6Answer: "일반적인 흐름은 문의 → 요건 검토 → 샘플 확인 → 견적 → 주문 확정 → 선적 추적입니다.",
  homeFallbackFaq7Question: "수출 서류 조율도 지원하나요?",
  homeFallbackFaq7Answer: "수출 서류 조율은 목적지 및 선적 요건에 따라 논의할 수 있습니다.",
  homeFallbackFaq8Question: "초기 응답은 얼마나 빨리 받을 수 있나요?",
  homeFallbackFaq8Answer: "초기 응답 속도는 요청의 복잡성에 따라 다르며, 제품 정보가 상세할수록 빠릅니다.",
  reviewName1: "Sarah Mitchell",
  reviewName2: "Omar Al-Hassan",
  reviewName3: "Sophie Laurent",
  reviewName4: "James Carter",
  footerLocationValue: "중국 창사",
  footerNewsletterTitle: "카탈로그 업데이트",
  footerNewsletterDesc: "새로운 요가 제품 아이디어와 커스터마이징 옵션을 받아보려면 이메일을 입력하세요.",
  footerNewsletterPlaceholder: "이메일 주소",
  marketNorthAmerica: "북미",
  marketNorthAmericaNote: "수입업체 · 온라인 브랜드 · 스튜디오 소매",
  marketEurope: "유럽",
  marketEuropeNote: "유통업체 · 웰니스 체인 · 프라이빗 라벨 바이어",
  marketAsiaPacific: "아시아태평양",
  marketAsiaPacificNote: "요가 스튜디오 · 이커머스 판매자 · 피트니스 소매점",
  marketMiddleEast: "중동",
  marketMiddleEastNote: "부티크 브랜드 · 기업 헬스 · 선물 세트 바이어",
  homeCtaEyebrow: "수입업체 · 유통업체 · 스튜디오 · 온라인 브랜드 대상",
  homeCtaTitle: "목표 시장에 맞는 제품 계획을 요청하세요.",
  homeCtaDescription: "국가, 판매 채널, 제품 카테고리, 목표 MOQ, 브랜드 스타일을 알려주세요. 적합한 제품 옵션과 커스터마이징 경로를 정리해 드립니다.",
  homeCtaPrimary: "문의 보내기",
  homeCtaSecondary: "카테고리 살펴보기",
  homeRequestCatalog: "전체 카탈로그 요청",
};

STOREFRONT_TEXTS.ar = {
  ...STOREFRONT_TEXTS.en,
  language: "اللغة",
  currency: "العملة",
  requestQuote: "طلب عرض سعر",
  sendMessage: "إرسال استفسار",
  subtitle: "مُكامل سلسلة توريد منتجات اليوغا للمشترين بالجملة عالميًا",
  loading: "جارٍ تحميل المنتجات...",
  error: "فشل تحميل المنتجات. يرجى التحقق من حالة الخدمة.",
  heroTag: "توريد B2B دولي",
  heroTitle: "منتجات يوغا ولياقة خفيفة عالية الجودة لمشتري B2B",
  heroBody: "ندعم المشترين بالجملة من اختيار المنتجات بدقة إلى مراقبة الجودة وخدمة ما بعد البيع.",
  heroBulletA: "تشكيلة منتجات منتقاة",
  heroBulletB: "دعم العلامة الخاصة",
  heroBulletC: "شركاء توريد موثوقون",
  heroBulletD: "تغطية توريد عالمية",
  heroBulletE: "استجابة سريعة لعروض الأسعار",
  categoryTitle: "استكشف فئاتنا",
  featuredTitle: "مجموعة منتجات مميزة",
  factoryTitle: "مزايا سلسلة التوريد",
  storyTitle: "تنسيق سلسلة توريد يمكنك الاعتماد عليه",
  serviceTitle: "عملية الجودة والامتثال",
  proofEyebrow: "من نحن",
  proofTitle: "شريك توريد B2B لمنتجات اليوغا واللياقة الخفيفة",
  proofBody: "ندعم قنوات الجملة والتجزئة والتجارة الإلكترونية عالميًا.",
  proofCta: "تواصل مع فريق B2B",
  inquiryTitle: "طلب عرض سعر",
  inquiryHint: "أخبرنا بالمنتج والكمية ومتطلبات العلامة والسوق المستهدف.",
  inquirySuccess: "شكرًا لك. تم استلام استفسارك وسيرد فريقنا قريبًا.",
  inquiryError: "يرجى إكمال الاسم والبريد وتفاصيل الاستفسار.",
  inquirySubmitting: "جارٍ الإرسال...",
  viewAll: "عرض المنتجات",
  talkToUs: "تحدث مع فريقنا",
  contactUs: "اتصل بنا",
  headerVerified: "موردون موثوقون",
  headerPrivateLabel: "علامة خاصة",
  headerGlobalShipping: "شحن عالمي",
  productsCategoryTitle: "فئات المنتجات",
  productsAll: "كل المنتجات",
  productsOthers: "أخرى",
  productsContactNow: "تواصل الآن",
  productsEmpty: "لا توجد منتجات في هذه الفئة.",
  productsPrev: "السابق",
  productsNext: "التالي",
  productsPage: "صفحة",
  privacyTitle: "خيارات الخصوصية",
  privacyBody: "نستخدم تقنيات أساسية لتشغيل المتجر وخيارات إضافية لتحسين التجربة.",
  privacyAccept: "أنا موافق",
  privacyReject: "عدم بيع أو مشاركة معلوماتي الشخصية",
  blogSeoTitle: "المدونة | رؤى التوريد وأدلة الشراء",
  blogSeoDescription: "رؤى عملية للمشترين بالجملة وبرامج العلامة الخاصة.",
  blogSearchPlaceholder: "ابحث في رؤى التوريد",
  blogFeaturedTitle: "مقال مميز",
  blogLatestTitle: "أحدث المقالات",
  blogBrowseTopicTitle: "تصفح حسب الموضوع",
  blogReadMore: "قراءة المزيد",
  blogShowLess: "عرض أقل",
  blogDateFallback: "تم التحديث مؤخرًا",
  blogCtaTitle: "هل تحتاج دعم توريد لمجموعتك القادمة؟",
  blogCtaViewProducts: "عرض المنتجات",
  blogCtaExploreSolutions: "استكشاف الحلول",
  blogCtaRequestQuote: "طلب عرض سعر",
  blogCategoryAll: "الكل",
  blogCategoryBuyingGuide: "دليل الشراء",
  blogCategoryCustomization: "التخصيص",
  blogCategorySampleOrder: "طلب عينة",
  blogCategorySourcing: "التوريد",
  blogCategoryProductTips: "نصائح المنتجات",
  reviewStarsUnit: "نجوم",
  homeShowcaseAria: "معرض منتجات من أجواء المعرض التجاري",
  homeShowcaseAlt1: "نظرة عامة على جناح منتجات اليوغا في المعرض",
  homeShowcaseAlt2: "جدار عرض حصائر اليوغا في جناح المعرض",
  homeShowcaseAlt3: "رف عرض إكسسوارات اليوغا داخل جناح المعرض",
  homeSeoFallbackTitle: "دعم توريد وتخصيص المنتجات | LOYA SPORT",
  homeSeoFallbackDescription: "خدمات احترافية لتوريد المنتجات وتخصيصها ودعم العلامة الخاصة ومتابعة الطلبات للمشترين بالجملة عالميًا.",
  breadcrumbHome: "الرئيسية",
  breadcrumbProductDetail: "تفاصيل المنتج",
  heroCardTitle: "كيف ندعم عمليات التوريد لديك",
  heroCardBody: "شارك المنتجات المستهدفة ومتطلبات العلامة والكميات المتوقعة. نقارن الخيارات وننسق العينات ومواعيد التسليم.",
  categoryBody: "استكشف مجموعات يوغا ولياقة ذات طلب مرتفع لقنوات الجملة.",
  featuredBody: "راجع المنتجات الأساسية واطلب عرض سعر وفق الكمية وخطة العلامة.",
  factoryBody: "مطابقة واضحة للموردين مع حد أدنى للطلب وجاهزية للتصدير.",
  storyBody: "تأكيد أسرع للمواصفات ومتابعة أدق لجدول التسليم.",
  storyBodyExtra: "من مطابقة الموردين إلى العينات ومراحل الشحن، نجعل تقدم المشروع واضحًا وقابلًا للمتابعة.",
  inquiryCtaEyebrow: "طلب عرض سعر",
  inquiryCtaTitle: "هل أنت جاهز لتوريد خط منتجات اليوغا التالي؟",
  inquiryCtaBody: "شارك معنا المنتجات المستهدفة وخطة الكميات لنقدم لك عرضًا مناسبًا.",
  inquiryQuickA: "هدف الرد: خلال 8 ساعات عمل",
  inquiryQuickB: "الأسواق المخدومة: قنوات الجملة العالمية",
  inquirySubmitFailed: "فشل الإرسال. يرجى المحاولة مرة أخرى بعد قليل.",
  chooseLanguageTitle: "من نخدم",
  chooseLanguageBody: "مصمم لقنوات B2B الأساسية.",
  trustA: "شركاء سلسلة توريد موثوقون",
  trustB: "دعم مرن لـ OEM والتغليف",
  trustC: "إدارة موثوقة لمواعيد التسليم",
  trustD: "فحص صارم قبل الشحن",
  viewMore: "اعرف المزيد",
  certifications: "الجودة والامتثال",
  globalContactTagline: "دعم تكامل سلسلة توريد منتجات اليوغا واللياقة لمشتري الجملة عالميًا",
  privacyOptionEnhanced: "أفهم ذلك: تفعيل الميزات الاختيارية مثل حفظ سجل البحث والتوصيات المخصصة.",
  privacyOptionBasic: "عدم بيع أو مشاركة معلوماتي الشخصية: تشغيل الميزات الأساسية فقط.",
  homeHeroEyebrow: "دعم التوريد العالمي",
  homeHeroTitle: "شريك موثوق لتوريد المنتجات وتخصيصها",
  homeHeroSubtitle: "نساعد المشترين عالميًا في التوريد والتخصيص والعينات ومتابعة الطلبات عبر تواصل واضح وتنفيذ عملي.",
  homeQuickAccessEyebrow: "وصول سريع",
  homeQuickAccessTitle: "استكشف موضوعات التوريد الأساسية",
  homeQuickAccessBody: "استخدم الروابط السريعة للوصول مباشرة إلى متطلبات الجملة والتخصيص الشائعة.",
  homeBestSellingEyebrow: "الأكثر مبيعًا",
  homeBestSellingTitle: "منتجات يوغا ولياقة الأكثر طلبًا",
  homeBestSellingBody: "اطلع على المنتجات الشائعة لقنوات الجملة والاستوديو والمتاجر الإلكترونية.",
  homeSolutionsTitle: "حلول حسب نوع المشتري",
  homeSolutionsBody: "استخدم صفحات الحلول كدليل عملي حسب القناة والسيناريو وخطة المنتج.",
  homeSolutionsButton: "استكشف الحلول",
  homeQualitySupportTitle: "آراء مشترين من أسواق عالمية",
  homeQualitySupportBody: "ملاحظات حقيقية من مسؤولين شرائيين عملوا معنا في أسواق رئيسية.",
  buyerReviewsAria: "مراجعات المشترين",
  buyerReviewsTitle: "تجارب التعاون",
  reviewRole1: "مدير مشتريات",
  reviewCountry1: "ألمانيا",
  reviewText1: "كان تنسيق العينات والتغليف واضحًا جدًا، مما سرّع إطلاق أول طلبية.",
  reviewRole2: "مشتري فئة",
  reviewCountry2: "الإمارات",
  reviewText2: "اقتراحات تشكيلة المنتجات كانت عملية وساعدتنا على اختبار السوق بسرعة.",
  reviewRole3: "مالك علامة تجارية",
  reviewCountry3: "أستراليا",
  reviewText3: "إدارة جدول التخصيص كانت منظمة، وهذا ساعدنا على الالتزام بموعد الإطلاق.",
  reviewRole4: "شريك جملة",
  reviewCountry4: "كندا",
  reviewText4: "في الطلبات المتكررة كانت سرعة التواصل ووضوح التقدم ممتازين.",
  homeSupplyImageAlt: "صورة دعم تنسيق سلسلة التوريد",
  homeCertImageAlt: "صورة نظرة عامة على الشهادات والامتثال",
  featureSourcingTitle: "توريد المنتجات",
  featureSourcingBody: "مقارنة المواصفات قبل الطلب.",
  featurePrivateLabelTitle: "العلامة الخاصة",
  featurePrivateLabelBody: "دعم الشعار والتغليف والحزم.",
  featureFlexibleOrderTitle: "طلبات مرنة",
  featureFlexibleOrderBody: "خيارات طلب تجريبي ومتكرر.",
  featureExportTitle: "دعم التصدير",
  featureExportBody: "متابعة المستندات والشحن.",
  metricVerified: "موردون موثوقون",
  metricVerifiedLabel: "مطابقة حسب الفئة",
  metricMoq: "حد أدنى مرن للطلب",
  metricMoqLabel: "تجريبي + متكرر",
  metricBranding: "العلامة الخاصة",
  metricBrandingLabel: "العلامة + التغليف",
  metricDocs: "جاهز للتصدير",
  metricDocsLabel: "مستندات EU/US",
  whyVerifiedTitle: "شبكة موردين موثوقة",
  whyVerifiedBody: "مطابقة الموردين وفق الفئة والجودة والسوق المستهدف.",
  whyMoqTitle: "دعم MOQ مرن",
  whyMoqBody: "كميات عملية للاختبار والنمو التدريجي.",
  whyOemTitle: "دعم OEM والعلامة الخاصة",
  whyOemBody: "تنسيق الشعار والتغليف والحزم بما يناسب قناتك.",
  whySourcingTitle: "إرشاد التوريد والاختيار",
  whySourcingBody: "مقارنة الخيارات حسب المادة والمواصفات والتموضع.",
  whyDeliveryTitle: "تنسيق تسليم مستقر",
  whyDeliveryBody: "متابعة المراحل والجداول لتقليل مخاطر التسليم.",
  whyInspectionTitle: "فحص الجودة قبل الشحن",
  whyInspectionBody: "التحقق من نقاط الجودة والتغليف الأساسية قبل الشحن.",
  qcSupplierTitle: "مراجعة تأهيل المورد",
  qcSupplierBody: "التحقق من القدرات والسجل.",
  qcInspectionTitle: "فحص قبل الشحن",
  qcInspectionBody: "التحقق من المنتج والملصق والتغليف.",
  qcComplianceTitle: "دعم امتثال المنتج",
  qcComplianceBody: "تجهيز مستندات بلد الوجهة.",
  qcCertTitle: "تنسيق الشهادات",
  qcCertBody: "مواءمة الملفات مع الشركاء.",
  faqQ1: "هل أنتم مصنع أم مُكامل سلسلة توريد؟",
  faqA1: "نحن مُكامل سلسلة توريد لمنتجات اليوغا. نعمل مع شركاء موثوقين وننسق التوريد والتخصيص ومراقبة الجودة والشحن وخدمة ما بعد البيع.",
  faqQ2: "هل يمكنكم دعم العلامة الخاصة والطلبات التجريبية الصغيرة؟",
  faqA2: "نعم. في العديد من المنتجات ندعم تفاصيل العلامة الخاصة ويمكننا مناقشة كميات بداية مرنة حسب المنتج ونطاق المشروع.",
  faqQ3: "كيف تديرون الجودة والامتثال؟",
  faqA3: "نؤكد المواصفات ونراجع العينات ونتابع نقاط فحص الإنتاج مع الشركاء ونتحقق من تفاصيل التغليف قبل الشحن.",
  homeBreadcrumbCurrent: "الصفحة الحالية",
  homeCategoryBrowseMore: "تصفح المزيد من السلاسل",
  homeBestSellingCardKicker: "مفضل لدى مشتري B2B",
  homeSourcingInsightsEyebrow: "رؤى التوريد",
  homeSourcingInsightsTitle: "تعاون عملي لمشتري الجملة عالميًا",
  homeScenariosTitle: "سيناريوهات التطبيق الشائعة",
  homeScenariosBody: "تخطيط السيناريو مرتبط بصفحة الحلول لمزيد من التفاصيل.",
  homeScenariosLink: "اذهب إلى الحلول",
  homeProcessTitle: "عملية تعاون واضحة",
  homeProcessBody: "من الاستفسار الأول حتى تنسيق الشحن، كل خطوة تتبع مسار تسليم واضح.",
  homeBlogTitle: "أحدث موضوعات الشراء والتوريد",
  homeBlogBody: "اطّلع على مقالات موجزة تركز على المشتريات والعينات وتخطيط التخصيص.",
  homeBlogReadMore: "اقرأ المزيد",
  homeAboutTitle: "من ندعم وكيف نتعاون",
  homeAboutBody: "نركز على التعاون العملي مع المستوردين والموزعين وتجار التجزئة والبائعين عبر الإنترنت الذين يحتاجون إلى تواصل ثابت في مشاريع التوريد والتخصيص.",
  homeAboutLink: "ملف الشركة",
  homeFaqAria: "الأسئلة الشائعة",
  homeFaqTitle: "الأسئلة الشائعة",
  homeFaqBody: "إجابات سريعة قبل إرسال استفسارك.",
  homeFaqShowLess: "عرض FAQ أقل",
  homeFaqViewAll: "عرض كل FAQ",
  homeFormNamePlaceholder: "اسمك",
  homeFormEmailPlaceholder: "البريد الإلكتروني للعمل",
  homeFormWhatsappPlaceholder: "WhatsApp",
  homeFormCompanyPlaceholder: "الشركة",
  homeFormProductPlaceholder: "المنتج المستهدف",
  homeFormQuantityPlaceholder: "الكمية التقديرية",
  homeFormMessagePlaceholder: "مواصفات المنتج، الكمية، السوق المستهدف",
  homeFormUploadLabel: "تحميل ملف مرجعي (اختياري)",
  homeFormChooseFile: "اختر ملفًا",
  homeFormNoFile: "لم يتم اختيار ملف",
  homeFormSelectedFilePrefix: "الملف المختار:",
  homeEyebrowProductCategories: "فئات المنتجات",
  homeEyebrowFeaturedSelection: "تشكيلة مميزة",
  homeEyebrowSupplyChain: "مزايا سلسلة التوريد",
  homeEyebrowQualityControl: "مراقبة الجودة",
  homeEyebrowUseCases: "حالات الاستخدام",
  homeEyebrowWorkflow: "سير العمل",
  homeEyebrowBlog: "المدونة والرؤى",
  homeEyebrowAbout: "حولنا",
  homeEyebrowFaq: "FAQ",
  homeAriaIntro: "نظرة عامة على توريد اليوغا واللياقة B2B",
  homeAriaQuickNav: "تنقل SEO سريع",
  homeAriaCategoryGallery: "معرض فئات المنتجات",
  homeAriaBestSellingHead: "المنتجات الأكثر مبيعًا",
  homeAriaBestSellingGrid: "منتجات مختارة الأكثر مبيعًا",
  homeAriaSolutionsNav: "تنقل الحلول",
  homeAriaSupplyQuality: "أبرز دعم سلسلة التوريد والجودة",
  homeAriaSourcingOverview: "نظرة عامة على التوريد والتخصيص",
  homeAriaScenarios: "سيناريوهات التطبيق",
  homeAriaProcess: "عملية التعاون",
  homeAriaBlog: "أبرز مقالات المدونة",
  homeAriaAboutSummary: "ملخص حول الشركة",
  homeEmptyBadge: "المخزون قيد التحضير",
  homeEmptyTitle: "لا توجد منتجات متاحة للعرض حاليًا",
  homeEmptySuffix: " ستظهر هنا بعد نشر المنتجات.",
  homeQuickLink1Title: "توريد المنتجات",
  homeQuickLink1Body: "دعم توريد مرن لمشتري الجملة.",
  homeQuickLink2Title: "دعم العلامة الخاصة",
  homeQuickLink2Body: "خيارات العلامة والتغليف لمنتجات جاهزة للسوق.",
  homeQuickLink3Title: "تعاون OEM / ODM",
  homeQuickLink3Body: "من توضيح المتطلبات إلى تأكيد العينة والإنتاج.",
  homeQuickLink4Title: "دعم طلب العينات",
  homeQuickLink4Body: "ناقش عينات الاختبار قبل التخطيط للطلبات الكبيرة.",
  homeQuickLink5Title: "توريد الجملة",
  homeQuickLink5Body: "مناسب للموزعين وتجار التجزئة والبائعين عبر الإنترنت.",
  homeQuickLink6Title: "إرشاد الحلول",
  homeQuickLink6Body: "اعثر على مسارات عملية حسب نوع المشتري وحالة الاستخدام.",
  homeScenario1Title: "التحضير لقنوات التجزئة",
  homeScenario1Body: "ابنِ تشكيلة عملية للتوزيع الجاهز للرف والجملة.",
  homeScenario2Title: "برنامج منتجات السوق الإلكتروني",
  homeScenario2Body: "نسق تشكيلات المنتجات وتفاصيل التغليف للقنوات الرقمية.",
  homeScenario3Title: "توريد الاستوديو والصالات",
  homeScenario3Body: "جهز مجموعات منتجات متينة للاستخدام في الحصص وإعادة البيع للأعضاء.",
  homeProcessStep1: "استفسار",
  homeProcessStep2: "مراجعة المتطلبات",
  homeProcessStep3: "مناقشة العينة",
  homeProcessStep4: "عرض السعر",
  homeProcessStep5: "تأكيد الطلب",
  homeProcessStep6: "متابعة الإنتاج",
  homeProcessStep7: "تنسيق الشحن",
  homeBlogHighlight1Title: "كيف تكتب استفسار توريد فعال",
  homeBlogHighlight1Body: "قائمة عملية لتنظيم تفاصيل المنتج والكمية والوجهة قبل طلب عرض السعر.",
  homeBlogHighlight2Title: "تخطيط العلامة الخاصة: نقاط أساسية قبل العينة",
  homeBlogHighlight2Body: "تقليل إعادة العمل عبر مواءمة طريقة الشعار وتفاصيل التغليف والجدول الزمني.",
  homeBlogHighlight3Title: "الطلب التجريبي بالجملة: بداية تعاون آمنة",
  homeBlogHighlight3Body: "طريقة تقييم جودة المنتج وتدفق التواصل قبل الالتزام بطلبات كبيرة.",
  blogHeroDescription: "أدلة توريد عملية للمستوردين ومشتري العلامة الخاصة، من اختيار المواد وفحص العينات إلى تخطيط الطلبات الجاهزة للإطلاق.",
  blogEmptyFeatured: "لا توجد مقالة مميزة مطابقة. جرّب كلمة مفتاحية أو فئة أخرى.",
  blogEmptyLatest: "لا توجد مقالات تطابق عامل التصفية الحالي.",
  buyerWholesalers: "تجار الجملة",
  buyerWholesalersNote: "دعم التشكيلات الكبيرة وإعادة التوريد.",
  buyerRetailers: "تجار التجزئة",
  buyerRetailersNote: "برامج جاهزة للرف ودعم التغليف.",
  buyerFitnessBrands: "علامات اللياقة التجارية",
  buyerFitnessBrandsNote: "دعم العلامة الخاصة لتوسيع خط المنتجات.",
  buyerYogaStudios: "استوديوهات اليوغا",
  buyerYogaStudiosNote: "حزم الاستوديو وإعادة تزويد الإكسسوارات.",
  buyerAmazonSellers: "بائعو أمازون",
  buyerAmazonSellersNote: "منتجات جاهزة للمنصات مع MOQ مرن.",
  buyerEcom: "شركات التجارة الإلكترونية",
  buyerEcomNote: "تشكيلات موجهة للبيع المتكرر عبر الإنترنت.",
  footerCtaTitle: "دعم B2B لتوريد منتجات اليوغا",
  footerCtaPrimary: "إرسال استفسار",
  footerCtaSecondary: "تواصل عبر WhatsApp",
  footerBrandCopy: "شريك تكامل سلسلة توريد للمشترين الدوليين، يقدم دعمًا متكاملًا من الاختيار الصارم للمنتجات والمصانع إلى مراقبة الجودة وخدمة ما بعد البيع الكاملة.",
  footerTrustPointA: "الرد خلال 24 ساعة",
  footerTrustPointB: "مشاريع OEM وODM",
  footerTrustPointC: "توصيل B2B عالمي",
  footerQuickLinksTitle: "روابط سريعة",
  footerPopularCategoriesTitle: "الفئات الشائعة",
  footerBuyerSupportTitle: "دعم المشترين",
  footerServicePointA: "تنسيق MOQ منخفض",
  footerServicePointB: "توريد العلامة الخاصة",
  footerServicePointC: "دعم الشحن الموحد",
  footerServicePointD: "متابعة التغليف والامتثال",
  footerEmailLabel: "البريد الإلكتروني",
  footerWhatsappLabel: "WhatsApp",
  footerPhoneLabel: "هاتف",
  footerServiceLabel: "الخدمة",
  footerCoverageLabel: "نطاق الخدمة",
  footerServiceValue: "الاثنين-السبت، 9:00-18:00 CST",
  footerCoverageValue: "الأسواق العالمية (بما في ذلك أوروبا وأمريكا الشمالية والشرق الأوسط وأوقيانوسيا وAPAC)",
  footerBottomCopyright: "دعم توريد منتجات اليوغا واللياقة لأعمال الجملة الدولية.",
  homeSeoKeywordBody: "بصفتنا شريك توريد في الصين للمشترين العالميين، نركز على التعاون العملي في توريد المنتجات وتخصيصها ودعم العلامة الخاصة. صُممت الصفحة الرئيسية لمساعدة فرق المشتريات على فهم كيفية انتقال التعاون من الاستفسار إلى الشحن عبر تواصل واضح. وللمشترين الذين يقيّمون دعم OEM/ODM ودعم العينات وخيارات التوريد بالجملة، فإن العملية المنظمة تقلل من عدم اليقين وتحسن سرعة التنفيذ. نحن لا نضيف تعقيدًا غير ضروري، بل نركز على وضوح المتطلبات، ومواءمة العينات، ومتابعة الطلبات بثبات. سواء بدأت بطلب تجريبي صغير أو بخطة شراء أكبر، تبقى الأولوية نفسها: تواصل مستقر، ومواءمة واقعية لمواعيد التسليم، ودعم قابل للتنفيذ للمنتج والتغليف للأسواق الدولية.",
  title: "LOYA SPORT",
  proofBodyExtra: "",
  ariaBackToHomepage: "العودة إلى الصفحة الرئيسية",
  ariaToggleNavigationMenu: "تبديل قائمة التنقل",
  ariaPrimaryNavigation: "التنقل الرئيسي",
  ariaSearchProductByName: "البحث عن منتج بالاسم",
  ariaSearch: "بحث",
  sortLabel: "ترتيب",
  sortDefault: "افتراضي",
  ariaSortProducts: "ترتيب المنتجات",
  contactModelPrefix: "موديل",
  ariaSwitchStorefrontLanguage: "تغيير لغة المتجر",
  ariaAccountCenter: "مركز الحساب",
  ariaLogin: "تسجيل الدخول",
  accountCenter: "مركز الحساب",
  productsCategoryNavigationAria: "تصفح فئات المنتجات",
  productsPaginationAria: "ترقيم صفحات المنتجات",
  bookmarkHint: "اضغط Ctrl+D (أو Cmd+D على Mac) لحفظ هذا الموقع في المفضلة.",
  ariaBreadcrumbNavigation: "مسار التنقل",
  ariaPrivacyPreference: "إعدادات الخصوصية",
  ariaOpenPrivacyChoices: "فتح سياسة الخصوصية",
  privacyChoices: "Privacy Policy",
  contactInquiryPresetLoaded: "تم تحميل استفسار مُهَيّأ مسبقًا لـ",
  contactSelectedProduct: "المنتج المحدد",
  contactQuoteHint: "لتسريع عملية الاقتباس، يُرجى تضمين رقم SKU المستهدف وحجم المبيعات السنوي المتوقع والسوق المستهدف وأسلوب التغليف المفضل.",
  inquiryProductDefault: "استفسار عام",
  navSubmenuSuffix: "قائمة فرعية",
  breadcrumbHomeSeries: "سلسلة العلامة الخاصة",
  nav: "nav",
  proofStatA: "تخصص في اليوغا واللياقة الخفيفة",
  proofStatB: "تنسيق العلامة الخاصة",
  proofStatC: "دعم المشترين العالميين",
  carouselAriaLabel: "لافتات ترويجية",
  carouselBannerAltPrefix: "لافتة",
  carouselPrevAria: "الشريحة السابقة",
  carouselNextAria: "الشريحة التالية",
  carouselDotsAria: "محددات شرائح العرض",
  footerCtaAria: "دعوة الإجراء في التذييل",
  footerCompanyProfileAria: "ملف الشركة",
  footerQuickLinksAria: "روابط سريعة",
  footerPopularCategoriesAria: "الفئات الشائعة",
  footerContactAria: "معلومات الاتصال",
  homeFallbackFaq1Question: "ما المعلومات المطلوبة للحصول على عرض سعر?",
  homeFallbackFaq1Answer: "شارك اسم المنتج أو صورته والكمية المتوقعة والسوق المستهدف ومتطلبات التغليف للحصول على رد سريع.",
  homeFallbackFaq2Question: "هل تدعمون طلبات العلامة الخاصة?",
  homeFallbackFaq2Answer: "نعم. يمكن أن يشمل دعم العلامة الخاصة طريقة الشعار وتفاصيل التغليف وتنسيق الإنتاج وفق متطلباتك.",
  homeFallbackFaq3Question: "هل تقدمون دعمًا للعينات قبل الطلبات الكبيرة?",
  homeFallbackFaq3Answer: "يمكن مناقشة العينات لتأكيد المواصفات وتوقعات التواصل قبل التخطيط للإنتاج الكبير.",
  homeFallbackFaq4Question: "هل يمكن مناقشة طلبات اختبار صغيرة?",
  homeFallbackFaq4Answer: "يمكن مناقشة كميات الاختبار وفق نوع المنتج ومتطلبات التغليف وترتيبات الإنتاج.",
  homeFallbackFaq5Question: "كيف تديرون تواصل التخصيص?",
  homeFallbackFaq5Answer: "نوائم المتطلبات كتابيًا ونؤكد تفاصيل العينات ونحتفظ بتحديثات المراحل أثناء التنفيذ.",
  homeFallbackFaq6Question: "ما هي عملية التعاون المعتادة?",
  homeFallbackFaq6Answer: "المسار المعتاد: استفسار ← مراجعة المتطلبات ← تأكيد العينة ← عرض السعر ← تأكيد الطلب ← متابعة الشحن.",
  homeFallbackFaq7Question: "هل تدعمون تنسيق وثائق التصدير?",
  homeFallbackFaq7Answer: "يمكن مناقشة تنسيق وثائق التصدير وفق الوجهة ومتطلبات الشحن.",
  homeFallbackFaq8Question: "كم يستغرق الرد الأولي;",
  homeFallbackFaq8Answer: "تعتمد سرعة الرد الأولي على تعقيد الطلب؛ وكلما كانت معلومات المنتج أكثر تفصيلًا كان الرد أسرع.",
  reviewName1: "Sarah Mitchell",
  reviewName2: "Omar Al-Hassan",
  reviewName3: "Sophie Laurent",
  reviewName4: "James Carter",
  footerLocationValue: "تشانغشا، الصين",
  footerNewsletterTitle: "تحديثات الكتالوج",
  footerNewsletterDesc: "اترك بريدك الإلكتروني لتلقي أفكار جديدة لمنتجات اليوغا وخيارات التخصيص.",
  footerNewsletterPlaceholder: "عنوان بريدك الإلكتروني",
  marketNorthAmerica: "أمريكا الشمالية",
  marketNorthAmericaNote: "مستوردون · علامات إلكترونية · بيع في الاستوديوهات",
  marketEurope: "أوروبا",
  marketEuropeNote: "موزعون · سلاسل العافية · مشترو العلامة الخاصة",
  marketAsiaPacific: "آسيا والمحيط الهادي",
  marketAsiaPacificNote: "استوديوهات اليوغا · بائعو التجارة الإلكترونية · تجار التجزئة الرياضية",
  marketMiddleEast: "الشرق الأوسط",
  marketMiddleEastNote: "علامات بوتيك · عافية مؤسسية · مشترو طقم الهدايا",
  homeCtaEyebrow: "للمستوردين • الموزعين • الاستوديوهات • العلامات الإلكترونية",
  homeCtaTitle: "اطلب خطة منتجات لسوقك المستهدف.",
  homeCtaDescription: "أخبرنا ببلدك وقناة البيع وفئة المنتج والحد الأدنى للطلب المستهدف وأسلوب علامتك التجارية. سننظم خيارات المنتجات ومسارات التخصيص المناسبة.",
  homeCtaPrimary: "إرسال استفسار",
  homeCtaSecondary: "تصفح الفئات",
  homeRequestCatalog: "طلب الكتالوج الكامل",
};

STOREFRONT_TEXTS.de = {
  ...STOREFRONT_TEXTS.en,
  language: "Sprache",
  currency: "Waehrung",
  requestQuote: "Angebot anfragen",
  sendMessage: "Anfrage senden",
  subtitle: "Yoga-Lieferkettenintegrator fuer globale Grosshandelskaeufer",
  loading: "Produkte werden geladen...",
  error: "Produkte konnten nicht geladen werden. Bitte pruefen Sie den Service-Status.",
  heroTag: "Internationales B2B-Sourcing",
  heroTitle: "Premium-Yoga- und Light-Fitness-Produkte fuer B2B-Kaeufer",
  heroBody: "Wir unterstuetzen Grosshandelskaeufer von der Produktauswahl bis zur Qualitaetskontrolle und After-Sales-Betreuung.",
  heroBulletA: "Kuratiertes Produktsortiment",
  heroBulletB: "Private-Label-Unterstuetzung",
  heroBulletC: "Verifizierte Lieferpartner",
  heroBulletD: "Globale Lieferabdeckung",
  heroBulletE: "Schnelle Angebotsreaktion",
  categoryTitle: "Unsere Kategorien entdecken",
  featuredTitle: "Ausgewaehlte Produktkollektion",
  factoryTitle: "Lieferkettenvorteile",
  storyTitle: "Lieferkettenkoordination, auf die Sie sich verlassen koennen",
  serviceTitle: "Qualitaets- und Compliance-Prozess",
  proofEyebrow: "Ueber uns",
  proofTitle: "Ein B2B-Sourcing-Partner fuer Yoga und Light Fitness",
  proofBody: "Wir bedienen globale Grosshandels-, Retail- und E-Commerce-Kanaele.",
  proofCta: "B2B-Team kontaktieren",
  inquiryTitle: "Angebot anfragen",
  inquiryHint: "Teilen Sie Produkt, Menge, Branding und Zielmarkt mit.",
  inquirySuccess: "Danke. Ihre Anfrage ist eingegangen. Unser Team antwortet in Kuerze.",
  inquiryError: "Bitte Name, E-Mail und Anfragedetails ausfuellen.",
  inquirySubmitting: "Wird gesendet...",
  viewAll: "Produkte ansehen",
  talkToUs: "Mit unserem Team sprechen",
  contactUs: "Kontakt",
  headerVerified: "Verifizierte Lieferanten",
  headerPrivateLabel: "Private Label",
  headerGlobalShipping: "Globaler Versand",
  productsCategoryTitle: "Produktkategorien",
  productsAll: "Alle Produkte",
  productsOthers: "Sonstige",
  productsContactNow: "Jetzt kontaktieren",
  productsEmpty: "In dieser Kategorie wurden keine Produkte gefunden.",
  productsPrev: "Zurueck",
  productsNext: "Weiter",
  productsPage: "Seite",
  privacyTitle: "Ihre Datenschutzoptionen",
  privacyBody: "Wir nutzen notwendige Technologien fuer den Shopbetrieb sowie optionale Verbesserungen.",
  privacyAccept: "Ich stimme zu",
  privacyReject: "Meine Daten nicht verkaufen oder weitergeben",
  blogSeoTitle: "Blog | Sourcing-Insights und Einkaufsleitfaeden",
  blogSeoDescription: "Praxisnahe Leitfaeden fuer globale Grosshandels- und Private-Label-Kaeufer.",
  blogSearchPlaceholder: "Sourcing-Insights suchen",
  blogFeaturedTitle: "Hervorgehobener Beitrag",
  blogLatestTitle: "Neueste Beitraege",
  blogBrowseTopicTitle: "Nach Thema durchsuchen",
  blogReadMore: "Mehr lesen",
  blogShowLess: "Weniger anzeigen",
  blogDateFallback: "Kuerzlich aktualisiert",
  blogCtaTitle: "Brauchen Sie Sourcing-Support fuer Ihre naechste Kollektion?",
  blogCtaViewProducts: "Produkte ansehen",
  blogCtaExploreSolutions: "Loesungen entdecken",
  blogCtaRequestQuote: "Angebot anfragen",
  blogCategoryAll: "Alle",
  blogCategoryBuyingGuide: "Einkaufsleitfaden",
  blogCategoryCustomization: "Individualisierung",
  blogCategorySampleOrder: "Musterbestellung",
  blogCategorySourcing: "Beschaffung",
  blogCategoryProductTips: "Produkttipps",
  reviewStarsUnit: "Sterne",
  homeShowcaseAria: "Produkt-Showcase von der Messe",
  homeShowcaseAlt1: "Uebersicht des Yoga-Produktstands auf der Messe",
  homeShowcaseAlt2: "Yoga-Matten-Showcase-Wand am Messestand",
  homeShowcaseAlt3: "Praesentationsregal fuer Yoga-Zubehoer am Messestand",
  homeSeoFallbackTitle: "Unterstuetzung fuer Produktsourcing und Anpassung | LOYA SPORT",
  homeSeoFallbackDescription: "Professionelles Produktsourcing, Anpassung, Private-Label-Unterstuetzung und Auftragsnachverfolgung fuer globale Grosshandelskaeufer.",
  breadcrumbHome: "Startseite",
  breadcrumbProductDetail: "Produktdetail",
  heroCardTitle: "So unterstuetzen wir Ihr Sourcing",
  heroCardBody: "Teilen Sie Zielprodukte, Branding-Anforderungen und Mengenplanung. Wir vergleichen Optionen, koordinieren Muster und steuern Liefertermine.",
  categoryBody: "Entdecken Sie stark nachgefragte Yoga- und Fitness-Kollektionen fuer den Grosshandel.",
  featuredBody: "Pruefen Sie Schluesselartikel und fragen Sie Angebote nach Menge und Branding-Plan an.",
  factoryBody: "Klare Lieferantenzuordnung, MOQ und Exportbereitschaft.",
  storyBody: "Spezifikationen schneller bestaetigen und Liefertermine sicher im Blick behalten.",
  storyBodyExtra: "Von Lieferantenabgleich ueber Muster bis zu Versand-Meilensteinen halten wir den Projektstatus transparent.",
  inquiryCtaEyebrow: "Angebot anfragen",
  inquiryCtaTitle: "Bereit fuer Ihre naechste Yoga-Produktlinie?",
  inquiryCtaBody: "Teilen Sie Zielprodukte und Mengenplanung, wir senden ein passendes Angebot.",
  inquiryQuickA: "Antwortziel: innerhalb von 8 Geschaeftsstunden",
  inquiryQuickB: "Bediente Maerkte: globale Grosshandelskanaele",
  inquirySubmitFailed: "Senden fehlgeschlagen. Bitte versuchen Sie es in einem Moment erneut.",
  chooseLanguageTitle: "Wen wir unterstuetzen",
  chooseLanguageBody: "Fuer zentrale B2B-Kanaele entwickelt.",
  trustA: "Verifizierte Lieferkettenpartner",
  trustB: "Flexible OEM- und Verpackungsunterstuetzung",
  trustC: "Zuverlaessiges Lead-Time-Management",
  trustD: "Strenge Vorversandpruefung",
  viewMore: "Mehr erfahren",
  certifications: "Qualitaet und Compliance",
  globalContactTagline: "Integration von Yoga- und Fitness-Lieferketten fuer globale Grosshandelskaeufer",
  privacyOptionEnhanced: "Ich verstehe: aktiviert optionale Funktionen wie Suchverlauf und personalisierte Empfehlungen.",
  privacyOptionBasic: "Meine Daten nicht verkaufen oder teilen: nur essentielle Shop-Funktionen aktiv.",
  homeHeroEyebrow: "Globaler Sourcing-Support",
  homeHeroTitle: "Ihr verlaesslicher Partner fuer Produktsourcing und Anpassung",
  homeHeroSubtitle: "Mit klarer Kommunikation und pragmischer Koordination unterstuetzen wir globale Kaeufer bei Sourcing, Anpassung, Mustern und Auftrags-Follow-up.",
  homeQuickAccessEyebrow: "Schnellzugriff",
  homeQuickAccessTitle: "Wichtige Sourcing-Themen entdecken",
  homeQuickAccessBody: "Nutzen Sie diese Schnelllinks fuer typische Grosshandels- und Anpassungsanforderungen.",
  homeBestSellingEyebrow: "Bestseller",
  homeBestSellingTitle: "Beliebte Yoga- und Fitnessprodukte",
  homeBestSellingBody: "Sehen Sie gefragte Artikel fuer Grosshandel, Studios und Online-Verkauf.",
  homeSolutionsTitle: "Loesungen nach Kaeufertyp",
  homeSolutionsBody: "Nutzen Sie die Loesungsseiten als praktische Leitfaeden nach Kanal, Szenario und Produktplanung.",
  homeSolutionsButton: "Loesungen ansehen",
  homeQualitySupportTitle: "Feedback von Kaeufern aus globalen Maerkten",
  homeQualitySupportBody: "Rueckmeldungen aus realen Kooperationen mit Beschaffungsverantwortlichen in wichtigen Regionen.",
  buyerReviewsAria: "Kaeuferbewertungen",
  buyerReviewsTitle: "Stimmen zur Zusammenarbeit",
  reviewRole1: "Sourcing Manager",
  reviewCountry1: "Deutschland",
  reviewText1: "Musterabstimmung und Verpackungskommunikation waren klar und haben den ersten Auftrag deutlich beschleunigt.",
  reviewRole2: "Category Buyer",
  reviewCountry2: "VAE",
  reviewText2: "Die vorgeschlagenen Produktmischungen waren praxisnah und haben unseren Markttest schnell gestartet.",
  reviewRole3: "Brand Owner",
  reviewCountry3: "Australien",
  reviewText3: "Das Zeitmanagement fuer die Anpassung war sauber strukturiert und hat unseren Launch-Plan stabil gehalten.",
  reviewRole4: "Grosshandelspartner",
  reviewCountry4: "Kanada",
  reviewText4: "Bei Wiederholauftraegen waren Reaktionsgeschwindigkeit und Liefertransparenz besonders stark.",
  homeSupplyImageAlt: "Bild zur Unterstuetzung der Lieferkettenkoordination",
  homeCertImageAlt: "Bild mit Ueberblick zu Zertifizierung und Compliance",
  featureSourcingTitle: "Produktsourcing",
  featureSourcingBody: "Spezifikationen vor der Bestellung vergleichen.",
  featurePrivateLabelTitle: "Private Label",
  featurePrivateLabelBody: "Support fuer Logo, Verpackung und Bundles.",
  featureFlexibleOrderTitle: "Flexible Bestellungen",
  featureFlexibleOrderBody: "Optionen fuer Test- und Wiederholauftraege.",
  featureExportTitle: "Export-Support",
  featureExportBody: "Dokumente und Versand-Follow-up.",
  metricVerified: "Verifizierte Lieferanten",
  metricVerifiedLabel: "Kategoriegenau",
  metricMoq: "Flexible MOQ",
  metricMoqLabel: "Test + Wiederholung",
  metricBranding: "Private Label",
  metricBrandingLabel: "Marke + Verpackung",
  metricDocs: "Exportbereit",
  metricDocsLabel: "EU/US-Dokumente",
  whyVerifiedTitle: "Verifiziertes Lieferantennetzwerk",
  whyVerifiedBody: "Lieferantenabgleich nach Kategorie, Qualitaet und Zielmarkt.",
  whyMoqTitle: "Flexible MOQ-Unterstuetzung",
  whyMoqBody: "Praktische Bestellmengen fuer Tests und stufenweises Wachstum.",
  whyOemTitle: "OEM- und Private-Label-Unterstuetzung",
  whyOemBody: "Logo, Verpackung und Bundles passend zu Ihrem Kanal koordinieren.",
  whySourcingTitle: "Sourcing- und Auswahlleitfaden",
  whySourcingBody: "Optionen nach Material, Spezifikation und Positionierung vergleichen.",
  whyDeliveryTitle: "Stabile Lieferkoordination",
  whyDeliveryBody: "Meilensteine und Zeitplaene verfolgen, um Lieferrisiken zu senken.",
  whyInspectionTitle: "Qualitaetspruefung vor dem Versand",
  whyInspectionBody: "Wichtige Qualitaets- und Verpackungspunkte vor dem Versand pruefen.",
  qcSupplierTitle: "Lieferantenqualifikation pruefen",
  qcSupplierBody: "Kapazitaet und Leistungsnachweise pruefen.",
  qcInspectionTitle: "Vorversandpruefung",
  qcInspectionBody: "Produkt, Etikett und Verpackung verifizieren.",
  qcComplianceTitle: "Produkt-Compliance-Support",
  qcComplianceBody: "Dokumente fuer den Zielmarkt vorbereiten.",
  qcCertTitle: "Zertifizierungskoordination",
  qcCertBody: "Dateien mit Partnern abstimmen.",
  faqQ1: "Sind Sie Hersteller oder Lieferketten-Integrator?",
  faqA1: "Wir sind ein Lieferketten-Integrator fuer Yoga-Produkte. Mit verifizierten Partnern koordinieren wir Sourcing, Anpassung, Qualitaetskontrolle, Versand und After-Sales-Support.",
  faqQ2: "Unterstuetzen Sie Private Label und kleinere Testbestellungen?",
  faqA2: "Ja. Fuer viele Artikel koennen wir Private-Label-Details organisieren und flexible Startmengen je nach Produkt und Projektumfang abstimmen.",
  faqQ3: "Wie steuern Sie Qualitaet und Compliance?",
  faqA3: "Wir bestaetigen Spezifikationen, pruefen Muster, verfolgen Produktionscheckpoints mit Partnern und kontrollieren Verpackungsdetails vor dem Versand.",
  homeBreadcrumbCurrent: "Aktuelle Seite",
  homeCategoryBrowseMore: "Mehr Serien ansehen",
  homeBestSellingCardKicker: "Beliebt bei B2B-Kaeufern",
  homeSourcingInsightsEyebrow: "Sourcing-Insights",
  homeSourcingInsightsTitle: "Praktische Zusammenarbeit fuer globale Grosshandelskaeufer",
  homeScenariosTitle: "Hauefige Anwendungsszenarien",
  homeScenariosBody: "Die Szenarioplanung ist mit der Loesungsseite fuer weitere Details verknuepft.",
  homeScenariosLink: "Zu den Loesungen",
  homeProcessTitle: "Klarer Kooperationsprozess",
  homeProcessBody: "Von der Erstanfrage bis zur Versandkoordination folgt jeder Schritt einem klaren Uebergabeweg.",
  homeBlogTitle: "Aktuelle Einkaufs- und Sourcing-Themen",
  homeBlogBody: "Kompakte Artikel zu Beschaffung, Mustern und Anpassungsplanung.",
  homeBlogReadMore: "Mehr lesen",
  homeAboutTitle: "Wen wir unterstuetzen und wie wir zusammenarbeiten",
  homeAboutBody: "Wir fokussieren uns auf praxisnahe Zusammenarbeit mit Importeuren, Distributoren, Einzelhaendlern und Online-Verkaeufern, die in Sourcing- und Anpassungsprojekten verlaessliche Kommunikation benoetigen.",
  homeAboutLink: "Unternehmensprofil",
  homeFaqAria: "Hauefig gestellte Fragen",
  homeFaqTitle: "Hauefig gestellte Fragen",
  homeFaqBody: "Schnelle Antworten vor dem Absenden Ihrer Anfrage.",
  homeFaqShowLess: "FAQ einklappen",
  homeFaqViewAll: "Alle FAQ anzeigen",
  homeFormNamePlaceholder: "Ihr Name",
  homeFormEmailPlaceholder: "Geschaeftliche E-Mail",
  homeFormWhatsappPlaceholder: "WhatsApp",
  homeFormCompanyPlaceholder: "Unternehmen",
  homeFormProductPlaceholder: "Zielprodukt",
  homeFormQuantityPlaceholder: "Geschaetzte Menge",
  homeFormMessagePlaceholder: "Produktspezifikationen, Menge, Zielmarkt",
  homeFormUploadLabel: "Referenzdatei hochladen (optional)",
  homeFormChooseFile: "Datei waehlen",
  homeFormNoFile: "Keine Datei ausgewaehlt",
  homeFormSelectedFilePrefix: "Ausgewaehlte Datei:",
  homeEyebrowProductCategories: "Produktkategorien",
  homeEyebrowFeaturedSelection: "Ausgewaehlte Highlights",
  homeEyebrowSupplyChain: "Lieferkettenvorteile",
  homeEyebrowQualityControl: "Qualitaetskontrolle",
  homeEyebrowUseCases: "Anwendungsfaelle",
  homeEyebrowWorkflow: "Workflow",
  homeEyebrowBlog: "Blog und Insights",
  homeEyebrowAbout: "Ueber uns",
  homeEyebrowFaq: "FAQ",
  homeAriaIntro: "B2B-Ueberblick zu Yoga- und Fitnesssourcing",
  homeAriaQuickNav: "Schnelle SEO-Navigation",
  homeAriaCategoryGallery: "Galerie der Produktkategorien",
  homeAriaBestSellingHead: "Bestseller-Produkte",
  homeAriaBestSellingGrid: "Kuratiertes Bestseller-Raster",
  homeAriaSolutionsNav: "Loesungsnavigation",
  homeAriaSupplyQuality: "Highlights zu Lieferkette und Qualitaetssupport",
  homeAriaSourcingOverview: "Ueberblick zu Sourcing und Anpassung",
  homeAriaScenarios: "Anwendungsszenarien",
  homeAriaProcess: "Kooperationsprozess",
  homeAriaBlog: "Blog-Highlights",
  homeAriaAboutSummary: "Kurzprofil Ueber uns",
  homeEmptyBadge: "Bestand in Vorbereitung",
  homeEmptyTitle: "Aktuell sind noch keine Produkte verfuegbar",
  homeEmptySuffix: " wird hier angezeigt, sobald Artikel veroeffentlicht sind.",
  homeQuickLink1Title: "Produktsourcing",
  homeQuickLink1Body: "Flexibler Sourcing-Support fuer Grosshandelskaeufer.",
  homeQuickLink2Title: "Private-Label-Support",
  homeQuickLink2Body: "Branding- und Verpackungsoptionen fuer marktreife SKUs.",
  homeQuickLink3Title: "OEM / ODM Zusammenarbeit",
  homeQuickLink3Body: "Von Anforderungen ueber Musterfreigabe bis zur Produktion.",
  homeQuickLink4Title: "Musterbestellungs-Support",
  homeQuickLink4Body: "Testmuster vor der Planung von Grossauftraegen abstimmen.",
  homeQuickLink5Title: "Grosshandelsversorgung",
  homeQuickLink5Body: "Geeignet fuer Distributoren, Einzelhaendler und Online-Verkaeufer.",
  homeQuickLink6Title: "Loesungsleitfaden",
  homeQuickLink6Body: "Praktische Wege nach Kaeufertyp und Anwendungsfall finden.",
  homeScenario1Title: "Vorbereitung fuer Retail-Kanaele",
  homeScenario1Body: "Ein praktikables Sortiment fuer regalfertige und grosshandelstaugliche Verteilung aufbauen.",
  homeScenario2Title: "Marketplace-Produktprogramm",
  homeScenario2Body: "Produktkombinationen und Verpackungsdetails fuer Online-Kanaele abstimmen.",
  homeScenario3Title: "Studio- und Gym-Versorgung",
  homeScenario3Body: "Langlebige Produktsets fuer Kursnutzung und Mitglieder-Weiterverkauf vorbereiten.",
  homeProcessStep1: "Anfrage",
  homeProcessStep2: "Anforderungspruefung",
  homeProcessStep3: "Musterabstimmung",
  homeProcessStep4: "Angebot",
  homeProcessStep5: "Auftragsbestaetigung",
  homeProcessStep6: "Produktions-Follow-up",
  homeProcessStep7: "Versandkoordination",
  homeBlogHighlight1Title: "So erstellen Sie eine effiziente Sourcing-Anfrage",
  homeBlogHighlight1Body: "Praktische Checkliste fuer Produktdetails, Menge und Zielort vor der Angebotsanfrage.",
  homeBlogHighlight2Title: "Private-Label-Planung: Wichtige Punkte vor dem Muster",
  homeBlogHighlight2Body: "Nacharbeit reduzieren durch Abstimmung von Logo-Methode, Verpackungsdetails und Zeitplan.",
  homeBlogHighlight3Title: "Grosshandels-Testauftrag: Sicher in die Zusammenarbeit starten",
  homeBlogHighlight3Body: "So pruefen Sie Produktqualitaet und Kommunikationsablauf vor grossen Bestellungen.",
  blogHeroDescription: "Praktische Sourcing-Leitfaeden fuer Importeure und Private-Label-Kaeufer, von Materialwahl und Musterpruefung bis zur startbereiten Bestellplanung.",
  blogEmptyFeatured: "Kein passender hervorgehobener Beitrag gefunden. Bitte versuchen Sie ein anderes Stichwort oder eine andere Kategorie.",
  blogEmptyLatest: "Keine Beitraege passen zum aktuellen Filter.",
  buyerWholesalers: "Grosshaendler",
  buyerWholesalersNote: "Support fuer Mengen-Sortimente und Nachversorgung.",
  buyerRetailers: "Einzelhaendler",
  buyerRetailersNote: "Regalfertige Programme und Verpackungssupport.",
  buyerFitnessBrands: "Fitnessmarken",
  buyerFitnessBrandsNote: "Private-Label-Support fuer die Erweiterung von Produktlinien.",
  buyerYogaStudios: "Yoga-Studios",
  buyerYogaStudiosNote: "Studio-Bundles und Nachfuellung von Zubehoer.",
  buyerAmazonSellers: "Amazon-Verkaeufer",
  buyerAmazonSellersNote: "Marketplace-faehige Produkte mit flexibler MOQ.",
  buyerEcom: "E-Commerce-Unternehmen",
  buyerEcomNote: "Online-orientierte Sortimente fuer Wiederholverkaeufe.",
  footerCtaTitle: "B2B-Yoga-Sourcing-Support",
  footerCtaPrimary: "Anfrage senden",
  footerCtaSecondary: "Per WhatsApp kontaktieren",
  footerBrandCopy: "Ein Lieferketten-Integrationspartner fuer internationale Kaeufer mit End-to-End-Unterstuetzung von strenger Produktauswahl und Fabrikmatching bis zu Qualitaetskontrolle und umfassendem After-Sales-Service.",
  footerTrustPointA: "Antwort innerhalb von 24 Stunden",
  footerTrustPointB: "OEM- und ODM-Projekte",
  footerTrustPointC: "Weltweite B2B-Lieferung",
  footerQuickLinksTitle: "Schnelllinks",
  footerPopularCategoriesTitle: "Beliebte Kategorien",
  footerBuyerSupportTitle: "Kaeufer-Support",
  footerServicePointA: "Koordination niedriger MOQ",
  footerServicePointB: "Private-Label-Sourcing",
  footerServicePointC: "Unterstuetzung fuer Sammelversand",
  footerServicePointD: "Verpackungs- und Compliance-Follow-up",
  footerEmailLabel: "E-Mail",
  footerWhatsappLabel: "WhatsApp",
  footerPhoneLabel: "Telefon",
  footerServiceLabel: "Service",
  footerCoverageLabel: "Abdeckung",
  footerServiceValue: "Mo-Sa, 9:00-18:00 CST",
  footerCoverageValue: "Globale Maerkte (einschliesslich Europa, Nordamerika, Naher Osten, Ozeanien und APAC)",
  footerBottomCopyright: "Sourcing von Yoga- und Fitnessprodukten fuer das internationale Grosshandelsgeschaeft.",
  homeSeoKeywordBody: "Als Sourcing-Partner in China fuer globale Kaeufer konzentrieren wir uns auf praxisnahe Zusammenarbeit rund um Produktsourcing, Produktanpassung und Private-Label-Support. Die Startseite hilft Einkaufsteams, schnell zu verstehen, wie Kooperation mit klarer Kommunikation von der Anfrage bis zum Versand voranschreiten kann. Fuer Kaeufer, die OEM/ODM-Support, Mustersupport und Grosshandelsversorgung pruefen, reduziert ein strukturierter Prozess Unsicherheit und verbessert die Umsetzungsgeschwindigkeit. Statt unnoetige Komplexitaet hinzuzufuegen, legen wir Wert auf klare Anforderungen, abgestimmte Muster und stabiles Auftrags-Follow-up. Ob kleiner Testauftrag oder groesserer Beschaffungsplan: Entscheidend bleiben stabile Kommunikation, realistische Terminabstimmung sowie umsetzbare Produkt- und Verpackungsunterstuetzung fuer internationale Maerkte.",
  title: "LOYA SPORT",
  proofBodyExtra: "",
  ariaBackToHomepage: "Zur Startseite",
  ariaToggleNavigationMenu: "Navigationsmenue umschalten",
  ariaPrimaryNavigation: "Hauptnavigation",
  ariaSearchProductByName: "Produkt nach Name suchen",
  ariaSearch: "suchen",
  sortLabel: "Sortieren",
  sortDefault: "Standard",
  ariaSortProducts: "Produkte sortieren",
  contactModelPrefix: "Modell",
  ariaSwitchStorefrontLanguage: "Shop-Sprache wechseln",
  ariaAccountCenter: "Kontocenter",
  ariaLogin: "Anmelden",
  accountCenter: "Kontocenter",
  productsCategoryNavigationAria: "Produktkategorie-Navigation",
  productsPaginationAria: "Produktseitennummerierung",
  bookmarkHint: "Druecken Sie Strg+D (oder Cmd+D auf Mac), um diese Seite als Lesezeichen zu speichern.",
  ariaBreadcrumbNavigation: "Breadcrumb-Navigation",
  ariaPrivacyPreference: "Datenschutzeinstellungen",
  ariaOpenPrivacyChoices: "Datenschutzrichtlinie oeffnen",
  privacyChoices: "Privacy Policy",
  contactInquiryPresetLoaded: "Anfragevorgabe geladen fuer",
  contactSelectedProduct: "ausgewaehltes Produkt",
  contactQuoteHint: "Um die Angebotsphase zu beschleunigen, geben Sie bitte Ziel-SKU, geschaetztes Jahresvolumen, Zielmarkt und bevorzugte Verpackungsart an.",
  inquiryProductDefault: "Allgemeine Anfrage",
  navSubmenuSuffix: "Untermenue",
  breadcrumbHomeSeries: "Private-Label-Serie",
  nav: "nav",
  proofStatA: "Spezialisierung auf Yoga und Leichtfitness",
  proofStatB: "Private-Label-Koordination",
  proofStatC: "Globale Kaeuferunterstuetzung",
  carouselAriaLabel: "Werbebanner",
  carouselBannerAltPrefix: "Banner",
  carouselPrevAria: "Vorherige Folie",
  carouselNextAria: "Naechste Folie",
  carouselDotsAria: "Karussell-Folienauswahl",
  footerCtaAria: "Footer-Anfrage Handlungsaufforderung",
  footerCompanyProfileAria: "Unternehmensprofil",
  footerQuickLinksAria: "Schnelllinks",
  footerPopularCategoriesAria: "Beliebte Kategorien",
  footerContactAria: "Kontaktinformationen",
  homeFallbackFaq1Question: "Welche Informationen werden fuer ein Angebot benoetigt?",
  homeFallbackFaq1Answer: "Teilen Sie Produktname oder -bild, geschaetzte Menge, Zielmarkt und Verpackungsanforderungen fuer eine schnelle Rueckmeldung.",
  homeFallbackFaq2Question: "Unterstuetzen Sie Private-Label-Anfragen?",
  homeFallbackFaq2Answer: "Ja. Private-Label-Support kann Logogestaltung, Verpackungsdetails und Produktionsabstimmung gemaess Ihren Anforderungen umfassen.",
  homeFallbackFaq3Question: "Bieten Sie Musterunterstuetzung vor Grossbestellungen an?",
  homeFallbackFaq3Answer: "Musterdialoge sind moeglich, um Spezifikationen und Kommunikationserwartungen vor der Produktionsplanung zu bestaetigen.",
  homeFallbackFaq4Question: "Koennen Kleinbestellungen zum Testen besprochen werden?",
  homeFallbackFaq4Answer: "Testmengen koennen je nach Produkttyp, Verpackungsbedarf und Produktionsplanung besprochen werden.",
  homeFallbackFaq5Question: "Wie managen Sie die Kommunikation bei Individualisierungen?",
  homeFallbackFaq5Answer: "Wir richten Anforderungen schriftlich aus, bestaetigen Musterdetails und pflegen Meilenstein-Updates waehrend der Ausfuehrung.",
  homeFallbackFaq6Question: "Wie laueft der typische Kooperationsprozess ab?",
  homeFallbackFaq6Answer: "Der typische Ablauf ist: Anfrage > Anforderungspruefung > Musterbestaetigung > Angebot > Auftragsbestaetigung > Versandverfolgung.",
  homeFallbackFaq7Question: "Unterstuetzen Sie die Koordination von Exportdokumenten?",
  homeFallbackFaq7Answer: "Die Koordination von Exportdokumenten kann je nach Zielort und Versandanforderungen besprochen werden.",
  homeFallbackFaq8Question: "Wie schnell kann ich mit einer ersten Rueckmeldung rechnen?",
  homeFallbackFaq8Answer: "Die Geschwindigkeit der ersten Antwort haengt von der Komplexitaet der Anfrage ab; detailliertere Produktangaben verkuerzen in der Regel die Zeit.",
  reviewName1: "Sarah Mitchell",
  reviewName2: "Omar Al-Hassan",
  reviewName3: "Sophie Laurent",
  reviewName4: "James Carter",
  footerLocationValue: "Changsha, China",
  footerNewsletterTitle: "Katalog-Updates",
  footerNewsletterDesc: "Hinterlassen Sie Ihre E-Mail, um neue Yoga-Produktideen und Individualisierungsoptionen zu erhalten.",
  footerNewsletterPlaceholder: "Ihre E-Mail-Adresse",
  marketNorthAmerica: "Nordamerika",
  marketNorthAmericaNote: "Importeure · Online-Marken · Studio-Einzelhandel",
  marketEurope: "Europa",
  marketEuropeNote: "Distributoren · Wellness-Ketten · Private-Label-Kaeufer",
  marketAsiaPacific: "Asien-Pazifik",
  marketAsiaPacificNote: "Yoga-Studios · E-Commerce-Verkaeufer · Fitness-Einzelhaendler",
  marketMiddleEast: "Naher Osten",
  marketMiddleEastNote: "Boutique-Marken · Corporate Wellness · Geschenk-Set-Kaeufer",
  homeCtaEyebrow: "FUER IMPORTEURE \u2022 DISTRIBUTOREN \u2022 STUDIOS \u2022 ONLINE-MARKEN",
  homeCtaTitle: "Fordern Sie einen Produktplan fuer Ihren Zielmarkt an.",
  homeCtaDescription: "Teilen Sie uns Ihr Land, Ihren Vertriebskanal, Ihre Produktkategorie, Ziel-MOQ und Markenstil mit. Wir stellen geeignete Produktoptionen und Individualisierungsrouten zusammen.",
  homeCtaPrimary: "Anfrage senden",
  homeCtaSecondary: "Kategorien durchsuchen",
  homeRequestCatalog: "Vollständigen Katalog anfordern",
};

STOREFRONT_TEXTS.ru = {
  ...STOREFRONT_TEXTS.en,
  language: "Язык",
  currency: "Валюта",
  requestQuote: "Запросить предложение",
  sendMessage: "Отправить запрос",
  subtitle: "Интегратор цепочки поставок товаров для йоги для глобальных оптовых покупателей",
  loading: "Загрузка товаров...",
  error: "Не удалось загрузить товары. Проверьте состояние сервиса.",
  heroTag: "Международный B2B-сорсинг",
  heroTitle: "Премиальные товары для йоги и легкого фитнеса для B2B-покупателей",
  heroBody: "Поддерживаем оптовых покупателей от подбора товаров до контроля качества и послепродажного сервиса.",
  heroBulletA: "Отобранный ассортимент",
  heroBulletB: "Поддержка private label",
  heroBulletC: "Проверенные поставщики",
  heroBulletD: "Глобальное покрытие поставок",
  heroBulletE: "Быстрый ответ по ценам",
  categoryTitle: "Изучите наши категории",
  featuredTitle: "Рекомендуемая подборка",
  factoryTitle: "Преимущества цепочки поставок",
  storyTitle: "Координация поставок, на которую можно положиться",
  serviceTitle: "Процесс качества и соответствия",
  proofEyebrow: "О нас",
  proofTitle: "B2B-партнер по сорсингу товаров для йоги и легкого фитнеса",
  proofBody: "Поддерживаем оптовые, розничные и e-commerce каналы по всему миру.",
  proofCta: "Связаться с B2B-командой",
  inquiryTitle: "Запросить предложение",
  inquiryHint: "Укажите товар, объем, требования к брендингу и рынок назначения.",
  inquirySuccess: "Спасибо. Ваш запрос получен, команда скоро ответит.",
  inquiryError: "Пожалуйста, заполните имя, email и детали запроса.",
  inquirySubmitting: "Отправка...",
  viewAll: "Смотреть товары",
  talkToUs: "Связаться с нашей командой",
  contactUs: "Связаться с нами",
  headerVerified: "Проверенные поставщики",
  headerPrivateLabel: "Private Label",
  headerGlobalShipping: "Глобальная доставка",
  productsCategoryTitle: "Категории товаров",
  productsAll: "Все товары",
  productsOthers: "Прочее",
  productsContactNow: "Связаться сейчас",
  productsEmpty: "В этой категории нет товаров.",
  productsPrev: "Назад",
  productsNext: "Вперед",
  productsPage: "Страница",
  privacyTitle: "Ваш выбор конфиденциальности",
  privacyBody: "Мы используем необходимые технологии для работы витрины и дополнительные функции улучшения.",
  privacyAccept: "Понятно",
  privacyReject: "Не продавать и не передавать мои персональные данные",
  blogSeoTitle: "Блог | Инсайты по закупкам и руководства",
  blogSeoDescription: "Практические материалы для глобальных оптовых и private label покупателей.",
  blogSearchPlaceholder: "Поиск инсайтов по закупкам",
  blogFeaturedTitle: "Рекомендуемая статья",
  blogLatestTitle: "Последние статьи",
  blogBrowseTopicTitle: "Просмотр по теме",
  blogReadMore: "Читать далее",
  blogShowLess: "Свернуть",
  blogDateFallback: "Обновлено недавно",
  blogCtaTitle: "Нужна поддержка закупок для следующей коллекции?",
  blogCtaViewProducts: "Смотреть товары",
  blogCtaExploreSolutions: "Изучить решения",
  blogCtaRequestQuote: "Запросить предложение",
  blogCategoryAll: "Все",
  blogCategoryBuyingGuide: "Гид по закупкам",
  blogCategoryCustomization: "Кастомизация",
  blogCategorySampleOrder: "Заказ образца",
  blogCategorySourcing: "Сорсинг",
  blogCategoryProductTips: "Советы по продукту",
  reviewStarsUnit: "звезд",
  homeShowcaseAria: "Выставочная витрина продукции",
  homeShowcaseAlt1: "Обзор стенда с товарами для йоги на выставке",
  homeShowcaseAlt2: "Стенд с экспозицией ковриков для йоги на выставке",
  homeShowcaseAlt3: "Стеллаж с аксессуарами для йоги на выставочном стенде",
  homeSeoFallbackTitle: "Поддержка сорсинга и кастомизации продукции | LOYA SPORT",
  homeSeoFallbackDescription: "Профессиональная поддержка сорсинга, кастомизации, private label и сопровождения заказов для глобальных оптовых покупателей.",
  breadcrumbHome: "Главная",
  breadcrumbProductDetail: "Детали товара",
  heroCardTitle: "Как мы поддерживаем ваш сорсинг",
  heroCardBody: "Поделитесь целевыми товарами, требованиями к брендингу и планом объема. Мы сравним варианты, организуем образцы и согласуем сроки поставки.",
  categoryBody: "Изучите востребованные коллекции товаров для йоги и фитнеса для оптовых каналов.",
  featuredBody: "Проверьте ключевые позиции и запросите предложение по объему и плану брендинга.",
  factoryBody: "Прозрачный подбор поставщиков, MOQ и готовность к экспорту.",
  storyBody: "Быстрее подтверждайте спецификации и держите поставки в графике.",
  storyBodyExtra: "От подбора поставщиков до образцов и этапов отгрузки мы делаем прогресс проекта понятным и управляемым.",
  inquiryCtaEyebrow: "Запрос предложения",
  inquiryCtaTitle: "Готовы запустить следующую линейку товаров для йоги?",
  inquiryCtaBody: "Поделитесь целевыми товарами и планом объема, и мы подготовим предложение под ваш запрос.",
  inquiryQuickA: "Цель ответа: в течение 8 рабочих часов",
  inquiryQuickB: "Рынки: глобальные оптовые каналы",
  inquirySubmitFailed: "Не удалось отправить. Пожалуйста, попробуйте еще раз через минуту.",
  chooseLanguageTitle: "Кому мы помогаем",
  chooseLanguageBody: "Решения для ключевых B2B-каналов.",
  trustA: "Проверенные партнеры цепочки поставок",
  trustB: "Гибкая поддержка OEM и упаковки",
  trustC: "Надежное управление сроками",
  trustD: "Строгая инспекция перед отгрузкой",
  viewMore: "Подробнее",
  certifications: "Качество и соответствие",
  globalContactTagline: "Интеграционная поддержка цепочки поставок товаров для йоги и фитнеса для глобальных оптовых покупателей",
  privacyOptionEnhanced: "Понимаю: включить дополнительные функции, такие как сохранение поиска и персональные рекомендации.",
  privacyOptionBasic: "Не продавать и не передавать мои персональные данные: только базовые функции витрины.",
  homeHeroEyebrow: "Глобальная поддержка закупок",
  homeHeroTitle: "Надежный партнер по сорсингу и кастомизации продукции",
  homeHeroSubtitle: "Через понятную коммуникацию и практичную координацию мы поддерживаем глобальных покупателей в сорсинге, кастомизации, образцах и сопровождении заказов.",
  homeQuickAccessEyebrow: "Быстрый доступ",
  homeQuickAccessTitle: "Ключевые темы закупок",
  homeQuickAccessBody: "Используйте быстрые ссылки для типовых задач опта и кастомизации.",
  homeBestSellingEyebrow: "Хиты продаж",
  homeBestSellingTitle: "Популярные товары для йоги и фитнеса",
  homeBestSellingBody: "Смотрите востребованные позиции для опта, студий и онлайн-продаж.",
  homeSolutionsTitle: "Решения по типу покупателя",
  homeSolutionsBody: "Используйте страницу решений как практичный гид по каналу, сценарию и товарному плану.",
  homeSolutionsButton: "Смотреть решения",
  homeQualitySupportTitle: "Отзывы покупателей с глобальных рынков",
  homeQualitySupportBody: "Реальные комментарии менеджеров закупок из ключевых регионов о совместной работе.",
  buyerReviewsAria: "Отзывы покупателей",
  buyerReviewsTitle: "Опыт сотрудничества",
  reviewRole1: "Менеджер по закупкам",
  reviewCountry1: "Германия",
  reviewText1: "Координация образцов и упаковки была очень прозрачной, поэтому мы быстро запустили первый заказ.",
  reviewRole2: "Категорийный закупщик",
  reviewCountry2: "ОАЭ",
  reviewText2: "Предложенные продуктовые наборы оказались практичными и помогли быстро начать тест рынка.",
  reviewRole3: "Владелец бренда",
  reviewCountry3: "Австралия",
  reviewText3: "График кастомизации был хорошо организован, и запуск прошел по плану.",
  reviewRole4: "Оптовый партнер",
  reviewCountry4: "Канада",
  reviewText4: "В повторных заказах особенно порадовали скорость коммуникации и прозрачность по срокам.",
  homeSupplyImageAlt: "Изображение поддержки координации цепочки поставок",
  homeCertImageAlt: "Изображение обзора сертификации и compliance",
  featureSourcingTitle: "Сорсинг продукции",
  featureSourcingBody: "Сравнение спецификаций до заказа.",
  featurePrivateLabelTitle: "Private Label",
  featurePrivateLabelBody: "Поддержка логотипа, упаковки и наборов.",
  featureFlexibleOrderTitle: "Гибкие заказы",
  featureFlexibleOrderBody: "Варианты тестовых и повторных заказов.",
  featureExportTitle: "Поддержка экспорта",
  featureExportBody: "Документы и сопровождение отгрузки.",
  metricVerified: "Проверенные поставщики",
  metricVerifiedLabel: "Подбор по категории",
  metricMoq: "Гибкий MOQ",
  metricMoqLabel: "Тест + повтор",
  metricBranding: "Private Label",
  metricBrandingLabel: "Бренд + упаковка",
  metricDocs: "Готово к экспорту",
  metricDocsLabel: "Документы EU/US",
  whyVerifiedTitle: "Сеть проверенных поставщиков",
  whyVerifiedBody: "Подбор поставщиков по категории, качеству и целевому рынку.",
  whyMoqTitle: "Поддержка гибкого MOQ",
  whyMoqBody: "Практичные объёмы для теста и поэтапного роста.",
  whyOemTitle: "Поддержка OEM и Private Label",
  whyOemBody: "Координируем логотип, упаковку и наборы под ваш канал.",
  whySourcingTitle: "Руководство по сорсингу и отбору",
  whySourcingBody: "Сравнивайте варианты по материалу, спецификации и позиционированию.",
  whyDeliveryTitle: "Стабильная координация поставки",
  whyDeliveryBody: "Отслеживаем этапы и графики, чтобы снизить риски поставки.",
  whyInspectionTitle: "Контроль качества перед отгрузкой",
  whyInspectionBody: "Проверяем ключевые точки качества и упаковки до отгрузки.",
  qcSupplierTitle: "Проверка квалификации поставщика",
  qcSupplierBody: "Проверка возможностей и истории выполнения.",
  qcInspectionTitle: "Проверка перед отгрузкой",
  qcInspectionBody: "Проверка товара, маркировки и упаковки.",
  qcComplianceTitle: "Поддержка product compliance",
  qcComplianceBody: "Подготовка документов для рынка назначения.",
  qcCertTitle: "Координация сертификации",
  qcCertBody: "Согласование файлов с партнерами.",
  faqQ1: "Вы производитель или интегратор цепочки поставок?",
  faqA1: "Мы интегратор цепочки поставок товаров для йоги. С проверенными партнерами координируем сорсинг, кастомизацию, контроль качества, отгрузку и after-sales поддержку.",
  faqQ2: "Поддерживаете ли вы private label и небольшие тестовые заказы?",
  faqA2: "Да. По многим позициям мы помогаем с private label деталями и обсуждаем гибкие стартовые объёмы в зависимости от товара и проекта.",
  faqQ3: "Как вы управляете качеством и compliance?",
  faqA3: "Мы подтверждаем спецификации, проверяем образцы, сопровождаем производственные checkpoints с партнёрами и контролируем упаковку перед отгрузкой.",
  homeBreadcrumbCurrent: "Текущая страница",
  homeCategoryBrowseMore: "Смотреть больше серий",
  homeBestSellingCardKicker: "Популярно у B2B покупателей",
  homeSourcingInsightsEyebrow: "Sourcing-Insights",
  homeSourcingInsightsTitle: "Практичное сотрудничество для глобальных оптовых покупателей",
  homeScenariosTitle: "Типовые сценарии применения",
  homeScenariosBody: "Планирование сценариев связано со страницей решений для более детального просмотра.",
  homeScenariosLink: "Перейти к решениям",
  homeProcessTitle: "Понятный процесс сотрудничества",
  homeProcessBody: "От первого запроса до координации отгрузки каждый шаг имеет чёткую передачу.",
  homeBlogTitle: "Актуальные темы закупки и сорсинга",
  homeBlogBody: "Смотрите короткие материалы о закупке, образцах и планировании кастомизации.",
  homeBlogReadMore: "Читать далее",
  homeAboutTitle: "Кому мы помогаем и как сотрудничаем",
  homeAboutBody: "Мы фокусируемся на практичном сотрудничестве с импортёрами, дистрибьюторами, ритейлерами и онлайн-продавцами, которым нужна стабильная коммуникация в проектах сорсинга и кастомизации.",
  homeAboutLink: "Профиль компании",
  homeFaqAria: "Часто задаваемые вопросы",
  homeFaqTitle: "Часто задаваемые вопросы",
  homeFaqBody: "Быстрые ответы перед отправкой запроса.",
  homeFaqShowLess: "Свернуть FAQ",
  homeFaqViewAll: "Показать все FAQ",
  homeFormNamePlaceholder: "Ваше имя",
  homeFormEmailPlaceholder: "Рабочий email",
  homeFormWhatsappPlaceholder: "WhatsApp",
  homeFormCompanyPlaceholder: "Компания",
  homeFormProductPlaceholder: "Целевой товар",
  homeFormQuantityPlaceholder: "Оценочный объём",
  homeFormMessagePlaceholder: "Спецификации товара, количество, целевой рынок",
  homeFormUploadLabel: "Загрузить референсный файл (необязательно)",
  homeFormChooseFile: "Выбрать файл",
  homeFormNoFile: "Файл не выбран",
  homeFormSelectedFilePrefix: "Выбранный файл:",
  homeEyebrowProductCategories: "Категории товаров",
  homeEyebrowFeaturedSelection: "Рекомендуемая подборка",
  homeEyebrowSupplyChain: "Преимущества цепочки поставок",
  homeEyebrowQualityControl: "Контроль качества",
  homeEyebrowUseCases: "Сценарии применения",
  homeEyebrowWorkflow: "Процесс",
  homeEyebrowBlog: "Блог и инсайты",
  homeEyebrowAbout: "О нас",
  homeEyebrowFaq: "FAQ",
  homeAriaIntro: "Обзор B2B сорсинга товаров для йоги и фитнеса",
  homeAriaQuickNav: "Быстрая SEO-навигация",
  homeAriaCategoryGallery: "Галерея категорий товаров",
  homeAriaBestSellingHead: "Хиты продаж",
  homeAriaBestSellingGrid: "Курируемая сетка хитов",
  homeAriaSolutionsNav: "Навигация по решениям",
  homeAriaSupplyQuality: "Ключевые моменты поддержки цепочки поставок и качества",
  homeAriaSourcingOverview: "Обзор сорсинга и кастомизации",
  homeAriaScenarios: "Сценарии применения",
  homeAriaProcess: "Процесс сотрудничества",
  homeAriaBlog: "Ключевые материалы блога",
  homeAriaAboutSummary: "Кратко о компании",
  homeEmptyBadge: "Запасы в подготовке",
  homeEmptyTitle: "Пока нет доступных для показа товаров",
  homeEmptySuffix: " появится здесь после публикации позиций.",
  homeQuickLink1Title: "Сорсинг товаров",
  homeQuickLink1Body: "Гибкая поддержка сорсинга для оптовых покупателей.",
  homeQuickLink2Title: "Поддержка Private Label",
  homeQuickLink2Body: "Брендинг и упаковка для SKU, готовых к рынку.",
  homeQuickLink3Title: "OEM / ODM сотрудничество",
  homeQuickLink3Body: "От требований до подтверждения образца и производства.",
  homeQuickLink4Title: "Поддержка заказа образцов",
  homeQuickLink4Body: "Обсудите тестовые образцы до планирования массового заказа.",
  homeQuickLink5Title: "Оптовые поставки",
  homeQuickLink5Body: "Подходит для дистрибьюторов, ритейлеров и онлайн-продавцов.",
  homeQuickLink6Title: "Гид по решениям",
  homeQuickLink6Body: "Найдите практичные маршруты по типу покупателя и сценарию.",
  homeScenario1Title: "Подготовка розничного канала",
  homeScenario1Body: "Соберите практичный ассортимент для полочной и оптовой дистрибуции.",
  homeScenario2Title: "Программа товаров для маркетплейса",
  homeScenario2Body: "Скоординируйте товарные комбинации и детали упаковки для онлайн-каналов.",
  homeScenario3Title: "Поставки для студий и залов",
  homeScenario3Body: "Подготовьте износостойкие наборы для занятий и перепродажи участникам.",
  homeProcessStep1: "Запрос",
  homeProcessStep2: "Проверка требований",
  homeProcessStep3: "Обсуждение образца",
  homeProcessStep4: "Коммерческое предложение",
  homeProcessStep5: "Подтверждение заказа",
  homeProcessStep6: "Сопровождение производства",
  homeProcessStep7: "Координация отгрузки",
  homeBlogHighlight1Title: "Как составить эффективный запрос на сорсинг",
  homeBlogHighlight1Body: "Практичный чеклист по деталям товара, объему и направлению перед запросом цены.",
  homeBlogHighlight2Title: "План Private Label: ключевые проверки до образца",
  homeBlogHighlight2Body: "Снижайте доработки за счет выравнивания способа логотипа, упаковки и графика.",
  homeBlogHighlight3Title: "Тестовый оптовый заказ: безопасный старт сотрудничества",
  homeBlogHighlight3Body: "Как оценить качество товара и коммуникационный процесс до крупных заказов.",
  blogHeroDescription: "Практичные гайды по сорсингу для импортёров и private label покупателей: от выбора материалов и проверки образцов до планирования заказов к запуску.",
  blogEmptyFeatured: "Подходящая рекомендуемая статья не найдена. Попробуйте другое ключевое слово или категорию.",
  blogEmptyLatest: "Нет статей, соответствующих текущему фильтру.",
  buyerWholesalers: "Оптовики",
  buyerWholesalersNote: "Поддержка крупных ассортиментов и пополнения запасов.",
  buyerRetailers: "Ритейлеры",
  buyerRetailersNote: "Программы для полки и поддержка упаковки.",
  buyerFitnessBrands: "Фитнес-бренды",
  buyerFitnessBrandsNote: "Поддержка private label для расширения продуктовой линейки.",
  buyerYogaStudios: "Йога-студии",
  buyerYogaStudiosNote: "Студийные наборы и пополнение аксессуаров.",
  buyerAmazonSellers: "Продавцы Amazon",
  buyerAmazonSellersNote: "Готовые для маркетплейса товары с гибким MOQ.",
  buyerEcom: "E-commerce компании",
  buyerEcomNote: "Онлайн-ориентированные ассортиментные наборы для повторных продаж.",
  footerCtaTitle: "B2B поддержка сорсинга товаров для йоги",
  footerCtaPrimary: "Отправить запрос",
  footerCtaSecondary: "Написать в WhatsApp",
  footerBrandCopy: "Партнер по интеграции цепочки поставок для зарубежных покупателей с полным сопровождением от строгого отбора товаров и фабрик до контроля качества и полного after-sales сервиса.",
  footerTrustPointA: "Ответ в течение 24 часов",
  footerTrustPointB: "Проекты OEM и ODM",
  footerTrustPointC: "Глобальная B2B-доставка",
  footerQuickLinksTitle: "Быстрые ссылки",
  footerPopularCategoriesTitle: "Популярные категории",
  footerBuyerSupportTitle: "Поддержка покупателей",
  footerServicePointA: "Координация низкого MOQ",
  footerServicePointB: "Private label сорсинг",
  footerServicePointC: "Поддержка консолидированной отгрузки",
  footerServicePointD: "Сопровождение упаковки и compliance",
  footerEmailLabel: "Email",
  footerWhatsappLabel: "WhatsApp",
  footerPhoneLabel: "Телефон",
  footerServiceLabel: "Сервис",
  footerCoverageLabel: "Покрытие",
  footerServiceValue: "Пн-Сб, 9:00-18:00 CST",
  footerCoverageValue: "Глобальные рынки (включая Европу, Северную Америку, Ближний Восток, Океанию и APAC)",
  footerBottomCopyright: "Сорсинг товаров для йоги и фитнеса для международного оптового бизнеса.",
  homeSeoKeywordBody: "Как партнёр по сорсингу в Китае для глобальных покупателей, мы фокусируемся на практичном сотрудничестве вокруг сорсинга товаров, кастомизации продукции и private label поддержки. Главная страница помогает закупочным командам быстро понять, как при понятной коммуникации взаимодействие движется от запроса к отгрузке. Для покупателей, оценивающих OEM/ODM поддержку, поддержку образцов и оптовые поставки, структурированный процесс снижает неопределенность и ускоряет выполнение. Вместо лишней сложности мы делаем акцент на ясных требованиях, согласовании образцов и стабильном сопровождении заказа. Независимо от того, начинаете ли вы с небольшого тестового заказа или с более крупного плана закупки, приоритеты остаются одинаковыми: стабильная коммуникация, реалистичное согласование сроков и выполнимая поддержка по продукту и упаковке для международных рынков.",
  title: "LOYA SPORT",
  proofBodyExtra: "",
  ariaBackToHomepage: "Вернуться на главную",
  ariaToggleNavigationMenu: "Переключить меню навигации",
  ariaPrimaryNavigation: "Основная навигация",
  ariaSearchProductByName: "Поиск товара по названию",
  ariaSearch: "поиск",
  sortLabel: "Сортировка",
  sortDefault: "По умолчанию",
  ariaSortProducts: "Сортировать товары",
  contactModelPrefix: "Модель",
  ariaSwitchStorefrontLanguage: "Изменить язык витрины",
  ariaAccountCenter: "Центр аккаунта",
  ariaLogin: "Войти",
  accountCenter: "Центр аккаунта",
  productsCategoryNavigationAria: "Навигация по категориям товаров",
  productsPaginationAria: "Пагинация товаров",
  bookmarkHint: "Нажмите Ctrl+D (или Cmd+D на Mac), чтобы добавить этот сайт в закладки.",
  ariaBreadcrumbNavigation: "Навигация по хлебным крошкам",
  ariaPrivacyPreference: "Настройки конфиденциальности",
  ariaOpenPrivacyChoices: "Открыть политику конфиденциальности",
  privacyChoices: "Privacy Policy",
  contactInquiryPresetLoaded: "Загружен предустановленный запрос для",
  contactSelectedProduct: "выбранный товар",
  contactQuoteHint: "Для ускорения подготовки предложения укажите целевой SKU, ожидаемый годовой объём, рынок назначения и предпочитаемый стиль упаковки.",
  inquiryProductDefault: "Общий запрос",
  navSubmenuSuffix: "подменю",
  breadcrumbHomeSeries: "Серия частной марки",
  nav: "nav",
  proofStatA: "Специализация на йоге и лёгком фитнесе",
  proofStatB: "Координация частной марки",
  proofStatC: "Поддержка глобальных покупателей",
  carouselAriaLabel: "Рекламные баннеры",
  carouselBannerAltPrefix: "Баннер",
  carouselPrevAria: "Предыдущий слайд",
  carouselNextAria: "Следующий слайд",
  carouselDotsAria: "Выбор слайда карусели",
  footerCtaAria: "Призыв к действию в подвале",
  footerCompanyProfileAria: "Профиль компании",
  footerQuickLinksAria: "Быстрые ссылки",
  footerPopularCategoriesAria: "Популярные категории",
  footerContactAria: "Контактная информация",
  homeFallbackFaq1Question: "Какая информация нужна для получения предложения?",
  homeFallbackFaq1Answer: "Укажите название или фото товара, ожидаемое количество, целевой рынок и требования к упаковке для оперативного ответа.",
  homeFallbackFaq2Question: "Вы поддерживаете запросы на частную марку?",
  homeFallbackFaq2Answer: "Да. Поддержка частной марки может включать способ нанесения логотипа, детали упаковки и согласование производства в соответствии с вашими требованиями.",
  homeFallbackFaq3Question: "Предоставляете ли образцы перед крупными заказами?",
  homeFallbackFaq3Answer: "Обсуждение образцов доступно для подтверждения спецификаций и ожиданий по коммуникации до планирования крупного производства.",
  homeFallbackFaq4Question: "Можно ли обсудить небольшие тестовые заказы?",
  homeFallbackFaq4Answer: "Тестовые объёмы можно обсудить в зависимости от типа товара, требований к упаковке и производственных договорённостей.",
  homeFallbackFaq5Question: "Как вы управляете коммуникацией по кастомизации?",
  homeFallbackFaq5Answer: "Мы согласовываем требования письменно, подтверждаем детали образцов и поддерживаем поэтапные обновления в ходе исполнения.",
  homeFallbackFaq6Question: "Каков типичный процесс сотрудничества?",
  homeFallbackFaq6Answer: "Типичный порядок: запрос > проверка требований > подтверждение образца > предложение > подтверждение заказа > отслеживание отгрузки.",
  homeFallbackFaq7Question: "Помогаете ли с оформлением экспортных документов?",
  homeFallbackFaq7Answer: "Координация экспортных документов может обсуждаться в зависимости от направления и требований к отгрузке.",
  homeFallbackFaq8Question: "Как быстро можно ожидать первый ответ?",
  homeFallbackFaq8Answer: "Скорость первого ответа зависит от сложности запроса; чем детальнее описан товар, тем быстрее ответ.",
  reviewName1: "Sarah Mitchell",
  reviewName2: "Omar Al-Hassan",
  reviewName3: "Sophie Laurent",
  reviewName4: "James Carter",
  footerLocationValue: "Чанша, Китай",
  footerNewsletterTitle: "Обновления каталога",
  footerNewsletterDesc: "Оставьте email, чтобы получать новые идеи товаров для йоги и варианты кастомизации.",
  footerNewsletterPlaceholder: "Ваш адрес email",
  marketNorthAmerica: "Северная Америка",
  marketNorthAmericaNote: "Импортёры · Онлайн-бренды · Студийный ритейл",
  marketEurope: "Европа",
  marketEuropeNote: "Дистрибьюторы · Велнес-сети · Покупатели private label",
  marketAsiaPacific: "Азиатско-Тихоокеанский регион",
  marketAsiaPacificNote: "Йога-студии · Продавцы е-коммерса · Фитнес-ритейлеры",
  marketMiddleEast: "Ближний Восток",
  marketMiddleEastNote: "Бутик-бренды · Корпоративный велнес · Покупатели подарочных наборов",
  homeCtaEyebrow: "ДЛЯ ИМПОРТЁРОВ \u2022 ДИСТРИБЬЮТОРОВ \u2022 СТУДИЙ \u2022 ОНЛАЙН-БРЕНДОВ",
  homeCtaTitle: "Запросите план по продуктам для вашего целевого рынка.",
  homeCtaDescription: "Укажите страну, канал продаж, категорию товара, целевой MOQ и стиль бренда. Мы подберём подходящие варианты товаров и маршруты кастомизации.",
  homeCtaPrimary: "Отправить запрос",
  homeCtaSecondary: "Просмотреть каталог",
  homeRequestCatalog: "Запросить полный каталог",
};

export default STOREFRONT_TEXTS;
